/*
 * @license
 * Modular Theme (c) Invisible Themes
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
!(function (t, e, i, s, o, n, r, a, l) {
  "use strict";
  function c(t) {
    t.querySelectorAll(".form-field").forEach(t => {
      const e = t.querySelector("label"),
        i = t.querySelector("input, textarea");
      e &&
        i &&
        (i.addEventListener("keyup", t => {
          "" !== t.target.value
            ? e.classList.add("label--float")
            : e.classList.remove("label--float");
        }),
        i.value && i.value.length && e.classList.add("label--float"));
    });
  }
  function d() {
    const t = {};
    return (
      (t.windowHeight = window.innerHeight),
      (t.announcementHeight = u('[data-section-type*="announcement"]')),
      (t.footerHeight = u('[data-section-type*="footer"]')),
      (t.headerHeight = u("[data-header-height].header--has-scrolled") || 60),
      (t.headerInitialHeight = u(
        "[data-header-height]:not(.header--has-scrolled)"
      )),
      t
    );
  }
  function h() {
    const {
      windowHeight: t,
      announcementHeight: e,
      headerHeight: i,
      footerHeight: s,
    } = d();
    document.documentElement.style.setProperty(
      "--announcement-height",
      `${e}px`
    ),
      document.documentElement.style.setProperty("--header-height", `${i}px`),
      document.documentElement.style.setProperty("--footer-height", `${s}px`),
      document.documentElement.style.setProperty(
        "--content-full",
        t - i + "px"
      ),
      document.documentElement.style.setProperty(
        "--content-min",
        t - i - s + "px"
      );
  }
  function u(t) {
    const e = document.querySelector(t);
    return e ? e.clientHeight : 0;
  }
  (window.theme = window.theme || {}),
    (window.theme.sizes = {
      mobile: 550,
      small: 767,
      large: 1023,
      widescreen: 1279,
    }),
    (window.theme.keyboardKeys = {
      TAB: 9,
      ENTER: 13,
      ESCAPE: 27,
      SPACE: 32,
      LEFTARROW: 37,
      RIGHTARROW: 39,
    }),
    (window.theme.dimensions = { headerScrolled: 60 }),
    (window.theme.loadedSPR = !1),
    (window.theme.focusable =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  const p = t => {
      const e = getComputedStyle(t);
      let i = t.offsetHeight;
      return (i += parseInt(e.marginTop) + parseInt(e.marginBottom)), i;
    },
    m = "[data-banner-container]",
    f = "[data-banner-content]";
  function y(t) {
    const e = t.querySelectorAll(m);
    e &&
      e.forEach(t => {
        const e = t.querySelector(f);
        e &&
          ((t.style.minHeight = `${p(e)}px`),
          document.addEventListener("theme:resize", () => {
            t.style.minHeight = `${p(e)}px`;
          }));
      });
  }
  function v(t, e) {
    let i;
    return function () {
      if (t) {
        const s = () => t.apply(this, arguments);
        clearTimeout(i), (i = setTimeout(s, e));
      }
    };
  }
  let g = window.pageYOffset,
    b = null,
    w = null,
    E = null,
    L = null,
    S = 0;
  function k(e) {
    t.disableBodyScroll(e.detail, {
      allowTouchMove: t => "TEXTAREA" === t.tagName,
    }),
      document.documentElement.setAttribute("data-scroll-locked", "");
  }
  function q() {
    if (
      ((S = setTimeout(() => {
        document.body.removeAttribute("data-drawer-closing");
      }, 20)),
      document.body.hasAttribute("data-drawer-closing"))
    )
      return (
        document.body.removeAttribute("data-drawer-closing"),
        void (S && clearTimeout(S))
      );
    document.body.setAttribute("data-drawer-closing", ""),
      document.documentElement.removeAttribute("data-scroll-locked"),
      t.clearAllBodyScrollLocks();
  }
  document.addEventListener(
    "touchstart",
    function t() {
      (window.theme.touched = !0),
        document.removeEventListener("touchstart", t, { passive: !0 }),
        (document.documentElement.className =
          document.documentElement.className.replace("no-touch", "touch")),
        document.dispatchEvent(new CustomEvent("theme:touch", { bubbles: !0 }));
    },
    { passive: !0 }
  );
  const A = {};
  function T(t = {}) {
    if ((t.type || (t.type = "json"), t.url))
      return A[t.url]
        ? A[t.url]
        : (function (t, e) {
            const i = new Promise((i, s) => {
              "text" === e
                ? fetch(t)
                    .then(t => t.text())
                    .then(t => {
                      i(t);
                    })
                    .catch(t => {
                      s(t);
                    })
                : (function (t, e, i) {
                    let s = document.getElementsByTagName("head")[0],
                      o = !1,
                      n = document.createElement("script");
                    (n.src = t),
                      (n.onload = n.onreadystatechange =
                        function () {
                          o ||
                          (this.readyState &&
                            "loaded" != this.readyState &&
                            "complete" != this.readyState)
                            ? i()
                            : ((o = !0), e());
                        }),
                      s.appendChild(n);
                  })(
                    t,
                    function () {
                      i();
                    },
                    function () {
                      s();
                    }
                  );
            });
            return (A[t] = i), i;
          })(t.url, t.type);
    if (t.json)
      return A[t.json]
        ? Promise.resolve(A[t.json])
        : window
            .fetch(t.json)
            .then(t => t.json())
            .then(e => ((A[t.json] = e), e));
    if (t.name) {
      const e = "".concat(t.name, t.version);
      return A[e]
        ? A[e]
        : (function (t) {
            const e = "".concat(t.name, t.version),
              i = new Promise((e, i) => {
                try {
                  window.Shopify.loadFeatures([
                    {
                      name: t.name,
                      version: t.version,
                      onLoad: t => {
                        !(function (t, e, i) {
                          i ? e(i) : t();
                        })(e, i, t);
                      },
                    },
                  ]);
                } catch (t) {
                  i(t);
                }
              });
            return (A[e] = i), i;
          })(t);
    }
    return Promise.reject();
  }
  window.isYoutubeAPILoaded = !1;
  const C = ".pswp",
    x = ".pswp__custom-close",
    _ = "iframe",
    P = ".pswp__custom-iframe",
    I = ".pswp__thumbs",
    M = "data-pswp-option-classes",
    z = "data-video-type",
    H = "data-disable-sound",
    F = "data-video-id",
    $ = "is-current",
    B = "pswp--custom-loader",
    W = "pswp--custom-opening",
    O = "pswp__loader",
    D = "loaded",
    N = `<div class="${O}"><div class="loader pswp__loader-line"><div class="loader-indeterminate"></div></div></div>`,
    V = [],
    R = (t, e, i) => {
      const s = {
          height: "720",
          width: "1280",
          events: {
            onReady: function (t) {
              t.target.getIframe().setAttribute("tabindex", "-1"),
                i ? t.target.mute() : t.target.unMute(),
                t.target.playVideo();
            },
            onStateChange: function (t) {
              0 == t.data && t.target.playVideo(),
                1 == t.data &&
                  t.target.getIframe().parentElement &&
                  t.target.getIframe().parentElement.classList.add(D);
            },
          },
        },
        o = Object.assign({}, s);
      (o.videoId = e), e.length && (V[t] = new YT.Player(t, o));
    },
    j = (t, e = "") => {
      const i = document.querySelectorAll(C)[0];
      if (
        (i.classList.add(W), i.classList.contains(B) && "" !== e && e.mainClass)
      ) {
        i.setAttribute(M, e.mainClass);
        let t = document.createElement("div");
        (t.innerHTML = N), (t = t.firstChild), i.appendChild(t);
      } else i.setAttribute(M, "");
      return T({ url: window.theme.assets.photoswipe })
        .then(() => {
          const s = window.themePhotoswipe.PhotoSwipe.default,
            o = window.themePhotoswipe.PhotoSwipeUI.default,
            n = i.querySelector(I);
          i.classList.contains(B) && i.classList.remove(B),
            i.classList.remove(W);
          let r = { history: !1, focus: !1, mainClass: "" };
          "" !== e && (r = e);
          const a = new s(i, o, t, r);
          a.init();
          const l = i.querySelector(P);
          if (l) {
            const t = l.getAttribute(z),
              e = l.getAttribute(F),
              i = "true" === l.getAttribute(H),
              s = l.id;
            "youtube" == t
              ? window.isYoutubeAPILoaded
                ? R(s, e, i)
                : (window.loadYoutubeAPI(),
                  document.body.addEventListener("youtubeAPIReady", () =>
                    R(s, e, i)
                  ))
              : "vimeo" == t &&
                ((t, e, i) => {
                  let s = "";
                  const o = {
                    url: "https://vimeo.com/" + t,
                    background: !1,
                    muted: i,
                    autoplay: !0,
                  };
                  for (let t in o)
                    s +=
                      encodeURIComponent(t) +
                      "=" +
                      encodeURIComponent(o[t]) +
                      "&";
                  fetch(`https://vimeo.com/api/oembed.json?${s}`)
                    .then(t => t.json())
                    .then(function (t) {
                      (e.innerHTML = t.html),
                        setTimeout(function () {
                          e.parentElement.classList.add(D);
                        }, 1e3);
                    })
                    .catch(function (t) {
                      console.log("error: ", t);
                    });
                })(e, l, i);
          }
          const c = i.querySelector(x);
          if (
            (c &&
              c.addEventListener("click", function () {
                a.close();
              }),
            a.listen("close", function () {
              const t = i.querySelector(_);
              if (
                (t && (t.setAttribute("src", ""), t.parentNode.removeChild(t)),
                n && n.firstChild)
              )
                for (; n.firstChild; ) n.removeChild(n.firstChild);
              i.setAttribute(M, "");
              const e = i.querySelector(`.${O}`);
              e && i.removeChild(e);
            }),
            n && n.firstChild)
          ) {
            const t = t => {
              t.stopPropagation();
            };
            n.addEventListener("wheel", t),
              n.addEventListener("mousewheel", t),
              n.addEventListener("DOMMouseScroll", t);
            const e = i.querySelectorAll(`${I} > *`);
            e.forEach((t, e) => {
              t.addEventListener("click", function (t) {
                t.preventDefault(),
                  this.parentElement.querySelector(`.${$}`).classList.remove($),
                  this.classList.add($),
                  a.goTo(e);
              });
            });
            const s = () => {
              const t = i.querySelector(`${I} > .${$}`);
              t && t.classList.remove($);
              const s = e[a.getCurrentIndex()],
                o = n.scrollLeft + n.offsetWidth,
                r = s.offsetLeft,
                l = r + s.offsetWidth;
              if ((s.classList.add($), o <= l || o > r)) {
                const t = parseInt(window.getComputedStyle(s).marginLeft);
                n.scrollTo({ top: 0, left: r - t, behavior: "smooth" });
              }
            };
            a.listen("imageLoadComplete", s), a.listen("beforeChange", s);
          }
        })
        .catch(t => console.error(t));
    };
  function U(t) {
    const e = t.querySelectorAll("[data-aria-toggle]");
    e.length &&
      e.forEach(t => {
        t.addEventListener("click", function (t) {
          t.preventDefault();
          const e = t.currentTarget;
          e.setAttribute(
            "aria-expanded",
            "false" == e.getAttribute("aria-expanded") ? "true" : "false"
          );
          const i = e.getAttribute("aria-controls");
          document.querySelector(`#${i}`).classList.toggle("expanding"),
            setTimeout(function () {
              document.querySelector(`#${i}`).classList.toggle("expanded");
            }, 40);
        });
      });
  }
  function Q(t) {
    const e = t.querySelectorAll("[data-video-popup]");
    e.length &&
      e.forEach(t => {
        t.addEventListener("click", function (e) {
          const i = t.getAttribute("data-video-popup");
          if ("" !== i.trim()) {
            e.preventDefault();
            j([{ html: i }]);
          }
        });
      });
  }
  window.addEventListener(
    "resize",
    v(function () {
      document.dispatchEvent(new CustomEvent("theme:resize", { bubbles: !0 }));
    }, 50)
  ),
    (function () {
      let t;
      window.addEventListener(
        "scroll",
        function () {
          t && window.cancelAnimationFrame(t),
            (t = window.requestAnimationFrame(function () {
              !(function () {
                const t = window.pageYOffset;
                t > g
                  ? ((w = !0), (b = !1))
                  : t < g
                  ? ((w = !1), (b = !0))
                  : ((b = null), (w = null)),
                  (g = t),
                  document.dispatchEvent(
                    new CustomEvent("theme:scroll", {
                      detail: { up: b, down: w, position: t },
                      bubbles: !1,
                    })
                  ),
                  b &&
                    !E &&
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:up", {
                        detail: { position: t },
                        bubbles: !1,
                      })
                    ),
                  w &&
                    !L &&
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:down", {
                        detail: { position: t },
                        bubbles: !1,
                      })
                    ),
                  (L = w),
                  (E = b);
              })();
            }));
        },
        { passive: !0 }
      ),
        window.addEventListener("theme:scroll:lock", k),
        window.addEventListener("theme:scroll:unlock", q);
    })(),
    document.addEventListener("lazyloaded", function (t) {
      const e = t.target.parentNode;
      e.classList.contains("lazy-image") && (e.style.backgroundImage = "none");
    }),
    (function () {
      const {
        windowHeight: t,
        announcementHeight: e,
        headerInitialHeight: i,
        headerHeight: s,
        footerHeight: o,
      } = d();
      document.documentElement.style.setProperty(
        "--announcement-height",
        `${e}px`
      ),
        document.documentElement.style.setProperty("--header-height", `${s}px`),
        document.documentElement.style.setProperty(
          "--header-initial-height",
          `${i}px`
        ),
        document.documentElement.style.setProperty("--footer-height", `${o}px`),
        document.documentElement.style.setProperty(
          "--content-full",
          t - s + "px"
        ),
        document.documentElement.style.setProperty(
          "--content-min",
          t - s - o + "px"
        ),
        document.documentElement.style.setProperty(
          "--scrollbar-width",
          `${(function () {
            const t = document.createElement("div");
            (t.style.visibility = "hidden"),
              (t.style.overflow = "scroll"),
              (t.style.msOverflowStyle = "scrollbar"),
              document.body.appendChild(t);
            const e = document.createElement("div");
            t.appendChild(e);
            const i = t.offsetWidth - e.offsetWidth;
            return t.parentNode.removeChild(t), i;
          })()}px`
        );
    })(),
    window.addEventListener("load", () => {
      document.addEventListener("theme:resize", h),
        c(document),
        y(document),
        Q(document),
        U(document);
    }),
    document.addEventListener("shopify:section:load", t => {
      const e = t.target;
      c(e),
        y(e),
        Q(e),
        U(document),
        document.dispatchEvent(
          new CustomEvent("theme:header:update", { bubbles: !0 })
        );
    }),
    document.addEventListener("shopify:section:reorder", () => {
      document.dispatchEvent(
        new CustomEvent("theme:header:update", { bubbles: !0 })
      );
    }),
    document.addEventListener("shopify:section:unload", () => {
      setTimeout(() => {
        document.dispatchEvent(
          new CustomEvent("theme:header:update", { bubbles: !0 })
        );
      }, 200);
    }),
    (function () {
      function t(t) {
        var e = window.innerWidth || document.documentElement.clientWidth,
          i = window.innerHeight || document.documentElement.clientHeight,
          s = t.getBoundingClientRect();
        return s.top >= 0 && s.bottom <= i && s.left >= 0 && s.right <= e;
      }
      function e(t) {
        var e = window.innerWidth || document.documentElement.clientWidth,
          i = window.innerHeight || document.documentElement.clientHeight,
          s = t.getBoundingClientRect(),
          o = (s.left >= 0 && s.left <= e) || (s.right >= 0 && s.right <= e),
          n = (s.top >= 0 && s.top <= i) || (s.bottom >= 0 && s.bottom <= i);
        return o && n;
      }
      window.visibilityHelper = {
        isElementTotallyVisible: t,
        isElementPartiallyVisible: e,
        inViewportPartially: function (t, i) {
          function s() {
            var s = e(t);
            s != o && ((o = s), "function" == typeof i && i(s, t));
          }
          var o = e(t);
          window.addEventListener("load", s),
            window.addEventListener("resize", s),
            window.addEventListener("scroll", s);
        },
        inViewportTotally: function (e, i) {
          function s() {
            var s = t(e);
            s != o && ((o = s), "function" == typeof i && i(s, e));
          }
          var o = t(e);
          window.addEventListener("load", s),
            window.addEventListener("resize", s),
            window.addEventListener("scroll", s);
        },
      };
    })();
  const K = (t, e = !1, i = "block") => {
      t && (e ? t.style.removeProperty("display") : (t.style.display = i));
    },
    X = "[data-api-content]",
    Y = "[data-product-template]";
  function J(t, e) {
    e = e || {};
    var i = t.tabIndex;
    (t.tabIndex = -1),
      (t.dataset.tabIndex = i),
      t.focus(),
      void 0 !== e.className && t.classList.add(e.className),
      t.addEventListener("blur", function s(o) {
        o.target.removeEventListener(o.type, s),
          (t.tabIndex = i),
          delete t.dataset.tabIndex,
          void 0 !== e.className && t.classList.remove(e.className);
      });
  }
  function G(t) {
    return Array.prototype.slice
      .call(
        t.querySelectorAll(
          "[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled"
        )
      )
      .filter(function (t) {
        return !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length);
      });
  }
  Shopify.Products = (function () {
    const t = {
      howManyToShow: 4,
      howManyToStoreInMemory: 10,
      wrapperId: "RecentlyViewed",
      onComplete: null,
    };
    let e = [],
      i = null,
      s = null;
    const o = {
        configuration: {
          expires: 90,
          path: "/",
          domain: window.location.hostname,
        },
        name: "shopify_recently_viewed",
        write: function (t) {
          const e = t.join(" ");
          document.cookie = `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
        },
        read: function () {
          let t = [],
            e = null;
          const i = document.querySelector(Y);
          if (
            (-1 !== document.cookie.indexOf("; ") &&
              document.cookie.split("; ").find(t => t.startsWith(this.name)) &&
              (e = document.cookie
                .split("; ")
                .find(t => t.startsWith(this.name))
                .split("=")[1]),
            null !== e && (t = e.split(" ")),
            i)
          ) {
            const e = i.getAttribute("data-product-handle");
            if (-1 != t.indexOf(e)) {
              const i = t.indexOf(e);
              t.splice(i, 1);
            }
          }
          return t;
        },
        destroy: function () {
          document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
        },
        remove: function (t) {
          const e = this.read(),
            i = e.indexOf(t);
          -1 !== i && (e.splice(i, 1), this.write(e));
        },
      },
      n = r => {
        e.length && r < t.howManyToShow
          ? fetch("/products/" + e[0] + "?section_id=api-product-grid-item")
              .then(t => t.text())
              .then(t => {
                const s = document.createElement("div");
                (s.innerHTML = t),
                  (i.innerHTML += s.querySelector(X).innerHTML),
                  e.shift(),
                  r++,
                  n(r);
              })
              .catch(() => {
                o.remove(e[0]), e.shift(), n(r);
              })
          : (() => {
              K(i, !0);
              const e = o.read().length;
              if (
                Shopify.recentlyViewed &&
                s &&
                e &&
                e < s &&
                i.children.length
              ) {
                let t = [],
                  e = [],
                  s = 0;
                for (const i in Shopify.recentlyViewed) {
                  s += 1;
                  const n = Shopify.recentlyViewed[i].split(" "),
                    r = parseInt(i.split("_")[1]);
                  (t = [...t, ...n]),
                    (o.read().length === r ||
                      (s === Object.keys(Shopify.recentlyViewed).length &&
                        !e.length)) &&
                      (e = [...e, ...n]);
                }
                for (let s = 0; s < i.children.length; s++) {
                  const o = i.children[s];
                  t.length && o.classList.remove(...t),
                    e.length && o.classList.add(...e);
                }
              }
              if (t.onComplete)
                try {
                  t.onComplete();
                } catch (t) {
                  console.log("error: ", t);
                }
            })();
      };
    return {
      showRecentlyViewed: function (r) {
        const a = r || {};
        Object.assign(t, a),
          (e = o.read()),
          (i = document.querySelector(`#${t.wrapperId}`)),
          (s = t.howManyToShow),
          (t.howManyToShow = Math.min(e.length, t.howManyToShow)),
          t.howManyToShow && i && n(0);
      },
      getConfig: function () {
        return t;
      },
      clearList: function () {
        o.destroy();
      },
      recordRecentlyViewed: function (e) {
        const i = e || {};
        Object.assign(t, i);
        let s = o.read();
        if (-1 !== window.location.pathname.indexOf("/products/")) {
          const e = decodeURIComponent(window.location.pathname)
              .match(
                /\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/
              )[0]
              .split("/products/")[1],
            i = s.indexOf(e);
          -1 === i
            ? (s.unshift(e), (s = s.splice(0, t.howManyToStoreInMemory)))
            : (s.splice(i, 1), s.unshift(e)),
            o.write(s);
        }
      },
      hasProducts: o.read().length > 0,
    };
  })();
  var Z = {};
  function tt() {
    document.removeEventListener("focusin", Z.focusin),
      document.removeEventListener("focusout", Z.focusout),
      document.removeEventListener("keydown", Z.keydown);
  }
  var et = Object.freeze({
    __proto__: null,
    forceFocus: J,
    focusHash: function (t) {
      t = t || {};
      var e = window.location.hash,
        i = document.getElementById(e.slice(1));
      if (i && t.ignore && i.matches(t.ignore)) return !1;
      e && i && J(i, t);
    },
    bindInPageLinks: function (t) {
      return (
        (t = t || {}),
        Array.prototype.slice
          .call(document.querySelectorAll('a[href^="#"]'))
          .filter(function (e) {
            if ("#" === e.hash || "" === e.hash) return !1;
            if (t.ignore && e.matches(t.ignore)) return !1;
            if (((i = e.hash.substr(1)), null === document.getElementById(i)))
              return !1;
            var i,
              s = document.querySelector(e.hash);
            return (
              !!s &&
              (e.addEventListener("click", function () {
                J(s, t);
              }),
              !0)
            );
          })
      );
    },
    focusable: G,
    trapFocus: function (t, e) {
      e = e || {};
      var i = G(t),
        s = e.elementToFocus || t,
        o = i[0],
        n = i[i.length - 1];
      tt(),
        (Z.focusin = function (e) {
          t === e.target || t.contains(e.target) || o.focus(),
            (e.target !== t && e.target !== n && e.target !== o) ||
              document.addEventListener("keydown", Z.keydown);
        }),
        (Z.focusout = function () {
          document.removeEventListener("keydown", Z.keydown);
        }),
        (Z.keydown = function (e) {
          9 === e.keyCode &&
            (e.target !== n || e.shiftKey || (e.preventDefault(), o.focus()),
            (e.target !== t && e.target !== o) ||
              !e.shiftKey ||
              (e.preventDefault(), n.focus()));
        }),
        document.addEventListener("focusout", Z.focusout),
        document.addEventListener("focusin", Z.focusin),
        J(s, e);
    },
    removeTrapFocus: tt,
    accessibleLinks: function (t, e) {
      if ("string" != typeof t) throw new TypeError(t + " is not a String.");
      if (0 !== (t = document.querySelectorAll(t)).length) {
        (e = e || {}).messages = e.messages || {};
        var i = {
            newWindow: e.messages.newWindow || "Opens in a new window.",
            external: e.messages.external || "Opens external website.",
            newWindowExternal:
              e.messages.newWindowExternal ||
              "Opens external website in a new window.",
          },
          s = e.prefix || "a11y",
          o = {
            newWindow: s + "-new-window-message",
            external: s + "-external-message",
            newWindowExternal: s + "-new-window-external-message",
          };
        t.forEach(function (t) {
          var e = t.getAttribute("target"),
            i = t.getAttribute("rel"),
            s = (function (t) {
              return t.hostname !== window.location.hostname;
            })(t),
            n = "_blank" === e,
            r = null === i || -1 === i.indexOf("noopener");
          if (n && r) {
            var a = null === i ? "noopener" : i + " noopener";
            t.setAttribute("rel", a);
          }
          s && n
            ? t.setAttribute("aria-describedby", o.newWindowExternal)
            : s
            ? t.setAttribute("aria-describedby", o.external)
            : n && t.setAttribute("aria-describedby", o.newWindow);
        }),
          (function (t) {
            var e = document.createElement("ul"),
              i = Object.keys(t).reduce(function (e, i) {
                return e + "<li id=" + o[i] + ">" + t[i] + "</li>";
              }, "");
            e.setAttribute("hidden", !0),
              (e.innerHTML = i),
              document.body.appendChild(e);
          })(i);
      }
    },
  });
  const it = (t, e = 500) => {
      (t.style.transitionProperty = "all"),
        (t.style.transitionDuration = e + "ms"),
        (t.style.boxSizing = "border-box"),
        (t.style.height = t.offsetHeight + "px"),
        t.offsetHeight,
        (t.style.overflow = "hidden"),
        (t.style.height = 0),
        (t.style.paddingTop = 0),
        (t.style.paddingBottom = 0),
        (t.style.marginTop = 0),
        (t.style.marginBottom = 0),
        window.setTimeout(() => {
          (t.style.display = "none"),
            t.style.removeProperty("height"),
            t.style.removeProperty("padding-top"),
            t.style.removeProperty("padding-bottom"),
            t.style.removeProperty("margin-top"),
            t.style.removeProperty("margin-bottom"),
            t.style.removeProperty("overflow"),
            t.style.removeProperty("transition-duration"),
            t.style.removeProperty("transition-property");
        }, e);
    },
    st = (t, e = 500, i = !0) => {
      let s = window.getComputedStyle(t).display;
      if (i && "none" !== s) return;
      t.style.removeProperty("display"),
        "none" === s && (s = "block"),
        (t.style.display = s);
      let o = t.offsetHeight;
      (t.style.overflow = "hidden"),
        (t.style.height = 0),
        (t.style.paddingTop = 0),
        (t.style.paddingBottom = 0),
        (t.style.marginTop = 0),
        (t.style.marginBottom = 0),
        t.offsetHeight,
        (t.style.boxSizing = "border-box"),
        (t.style.transitionProperty = "all"),
        (t.style.transitionDuration = e + "ms"),
        (t.style.height = o + "px"),
        t.style.removeProperty("padding-top"),
        t.style.removeProperty("padding-bottom"),
        t.style.removeProperty("margin-top"),
        t.style.removeProperty("margin-bottom"),
        window.setTimeout(() => {
          t.style.removeProperty("height"),
            t.style.removeProperty("overflow"),
            t.style.removeProperty("transition-duration"),
            t.style.removeProperty("transition-property");
        }, e);
    };
  function ot(t) {
    (this.status = t.status || null),
      (this.headers = t.headers || null),
      (this.json = t.json || null),
      (this.body = t.body || null);
  }
  ot.prototype = Error.prototype;
  const nt = {
    quantityHolder: "[data-quantity-holder], form.product__form",
    quantityField: "[data-quantity-field]",
    quantityButton: "[data-quantity-button]",
    quantityMinusButton: "[data-quantity-minus]",
    quantityPlusButton: "[data-quantity-plus]",
    quantityReadOnly: "read-only",
    isDisabled: "is-disabled",
  };
  class rt {
    constructor(t, e = !1) {
      (this.holder = t), (this.quantityUpdateCart = e);
    }
    init() {
      (this.settings = nt),
        (this.quantity = this.holder.querySelector(
          this.settings.quantityHolder
        )),
        (this.fields = this.quantity.querySelectorAll(this.settings.quantityField)),
        (this.buttons = this.quantity.querySelectorAll(
          this.settings.quantityButton
        )),
        (this.increaseButton = this.quantity.querySelector(
          this.settings.quantityPlusButton
        )),
        (this.quantityValue = Number(this.fields[0].value || 0)),
        (this.cartItemID = this.fields[0].getAttribute("data-id")),
        (this.maxValue =
          Number(this.fields[0].getAttribute("max")) > 0
            ? Number(this.fields[0].getAttribute("max"))
            : null),
        (this.minValue =
          Number(this.fields[0].getAttribute("min")) > 0
            ? Number(this.fields[0].getAttribute("min"))
            : 0),
        (this.disableIncrease = this.disableIncrease.bind(this)),
        (this.emptyField = !1),
        (this.updateQuantity = this.updateQuantity.bind(this)),
        (this.decrease = this.decrease.bind(this)),
        (this.increase = this.increase.bind(this)),
        this.disableIncrease(),
        this.quantity.classList.contains(this.settings.quantityReadOnly) ||
          (this.changeValueOnClick(), this.changeValueOnInput());
    }
    changeValueOnClick() {
      const t = this;
      this.buttons.forEach(e => {
        e.addEventListener("click", e => {
          e.preventDefault();
          const i = e.target,
            s =
              i.matches(t.settings.quantityMinusButton) ||
              i.closest(t.settings.quantityMinusButton),
            o =
              i.matches(t.settings.quantityPlusButton) ||
              i.closest(t.settings.quantityPlusButton);
          s && t.decrease(), o && t.increase(), t.updateQuantity();
        });
      });
    }
    changeValueOnInput() {
      const t = this;
      this.fields.forEach(field => {
        field.addEventListener(
          "input",
          function () {
            (t.quantityValue = this.value),
              "" === this.value && (t.emptyField = !0),
              t.updateQuantity();
          },
          this
        );
      });
    }
    updateQuantity() {
      this.maxValue < this.quantityValue &&
        null !== this.maxValue &&
        (this.quantityValue = this.maxValue),
        this.minValue > this.quantityValue &&
          (this.quantityValue = this.minValue),
        (this.fields.forEach(field => { field.value = this.quantityValue })),
        this.disableIncrease(),
        document.dispatchEvent(new CustomEvent("popout:updateValue")),
        this.quantityUpdateCart && this.updateCart();
    }
    decrease() {
      this.quantityValue > this.minValue
        ? this.quantityValue--
        : (this.quantityValue = 0);
    }
    increase() {
      this.quantityValue++;
    }
    disableIncrease() {
      this.increaseButton.classList.toggle(
        this.settings.isDisabled,
        this.quantityValue >= this.maxValue && null !== this.maxValue
      );
    }
    updateCart() {
      const t = new CustomEvent("cart:update", {
        bubbles: !0,
        detail: {
          id: this.cartItemID,
          quantity: this.quantityValue,
          valueIsEmpty: this.emptyField,
        },
      });
      this.holder.dispatchEvent(t);
    }
  }
  const at = {
    dimensions: { maxSize: 100 },
    times: { timeoutAddProduct: 1e3, closeDropdownAfter: 5e3 },
    classes: {
      template: "template-cart",
      hidden: "is-hidden",
      cartVisible: "cart--is-visible",
      open: "is-open",
      focused: "is-focused",
      visible: "is-visible",
      loading: "is-loading",
      disabled: "is-disabled",
      success: "product__form-submit--success",
      defaultSuccess: "is-success",
      cartEmpty: "cartToggle--empty",
      isAdded: "is-added",
    },
    attributes: {
      expanded: "aria-expanded",
      disabled: "disabled",
      dataId: "data-id",
    },
    elements: {
      apiContent: "[data-api-content]",
      html: "html",
      button: "button",
      buttonAddToCart: "[data-add-to-cart]",
      buttonAddToCartText: "[data-add-to-cart-text]",
      buttonHolder: "[data-foot-holder]",
      buttonUpdateCart: "[data-update-cart]",
      cart: "[data-cart]",
      cartContainer: "[data-cart-container]",
      cartTemplate: "[data-cart-template]",
      cartToggleElement: "[data-cart-toggle]",
      cartClose: "[data-cart-close]",
      cartItemRemove: "[data-item-remove]",
      cartItemsCount: "[data-cart-items-count]",
      cartTotal: "[data-cart-total]",
      cartErrors: "[data-cart-errors]",
      cartCloseError: "[data-cart-error-close]",
      cartOriginalTotal: "[data-cart-original-total]",
      cartOriginaTotalPrice: "[data-cart-original-total-price]",
      cartDiscountsHolder: "[data-cart-discounts-holder]",
      cartAcceptanceCheckbox: "[data-cart-acceptance-checkbox]",
      cartButtons: "[data-cart-buttons]",
      cartButtonsFieldset: "[data-cart-buttons-fieldset]",
      cartFormError: "[data-cart-error]",
      cartMessage: "data-cart-message",
      continueBtn: "[data-continue]",
      emptyMessage: "[data-empty-message]",
      errorMessage: "[data-error-message]",
      freeMessageLimit: "data-limit",
      input: "input",
      item: "[data-item]",
      itemsHolder: "[data-items-holder]",
      leftToSpend: "[data-left-to-spend]",
      popover: "[data-popover]",
      popoverTemplate: "[data-popover-template]",
      progressBar: "[data-cart-bar-progress]",
      qty: "[data-quantity-field]",
      quickAddHolder: "[data-quick-add-holder]",
    },
    formatMoney: moneyFormat,
    cartTotalDiscountsTemplate: "[data-cart-total-discount]",
  };
  window.cart = new (class {
    constructor() {
      "/password" !== window.location.pathname && this.init();
    }
    init() {
      (this.html = document.querySelector(at.elements.html)),
        (this.body = document.body),
        this.defineSelectors(),
        (this.accessibility = et),
        (this.ajaxEnabled = theme.settings.enableAjaxCart),
        (this.popoverTimer = ""),
        (this.scrollLockTimeout = 0),
        (this.cartFocusTimeout = 0),
        (this.form = null),
        (this.cartItemsCount = document.querySelector(
          at.elements.cartItemsCount
        )),
        (this.cartDrawerIsOpen = !1),
        (this.cartDiscounts = 0),
        (this.cartLimitErrorIsHidden = !0),
        (this.openCartDrawer = this.openCartDrawer.bind(this)),
        (this.closeCartDrawer = this.closeCartDrawer.bind(this)),
        (this.toggleCartDrawer = this.toggleCartDrawer.bind(this)),
        (this.cartKeyUpEvent = this.cartKeyUpEvent.bind(this)),
        this.ajaxEnabled && this.eventToggleCart(),
        this.initDefaultCartEvents(),
        this.addProductEvent();
    }
    renderCart() {
      (this.cartContainer.innerHTML = document.querySelector(
        at.elements.cartTemplate
      ).innerHTML),
        (this.totalItems = this.items.length),
        this.defineSelectors(),
        this.initDefaultCartEvents(),
        this.getCart();
    }
    defineSelectors() {
      (this.cartContainer = document.querySelector(at.elements.cartContainer)),
        (this.cartTemplate = document.querySelector(at.elements.cartTemplate)),
        (this.popover = document.querySelector(at.elements.popover)),
        (this.popoverTemplate =
          document.querySelector(at.elements.popoverTemplate) &&
          document.querySelector(at.elements.popoverTemplate).innerHTML),
        (this.cart = document.querySelector(at.elements.cart)),
        (this.emptyMessage = document.querySelector(at.elements.emptyMessage)),
        (this.buttonHolder = document.querySelector(at.elements.buttonHolder)),
        (this.itemsHolder = document.querySelector(at.elements.itemsHolder)),
        (this.items = document.querySelectorAll(at.elements.item)),
        (this.cartToggle = document.querySelector(
          at.elements.cartToggleElement
        )),
        (this.continueBtns = document.querySelectorAll(
          at.elements.continueBtn
        )),
        (this.cartTotal = document.querySelector(at.elements.cartTotal)),
        (this.cartOriginalTotal = document.querySelector(
          at.elements.cartOriginalTotal
        )),
        (this.cartOriginaTotalPrice = document.querySelector(
          at.elements.cartOriginaTotalPrice
        )),
        (this.cartDiscountHolder = document.querySelector(
          at.elements.cartDiscountsHolder
        )),
        (this.cartTotalDiscountTemplate = document.querySelector(
          at.cartTotalDiscountsTemplate
        ).innerHTML),
        (this.cartErrorHolder = document.querySelector(at.elements.cartErrors)),
        (this.cartClose = document.querySelector(at.elements.cartClose)),
        (this.cartCloseErrorMessage = document.querySelector(
          at.elements.cartCloseError
        )),
        (this.cartAcceptanceCheckbox = document.querySelector(
          at.elements.cartAcceptanceCheckbox
        )),
        (this.cartMessage = document.querySelector(
          `[${at.elements.cartMessage}]`
        )),
        (this.progressBar = document.querySelector(at.elements.progressBar)),
        (this.leftToSpend = document.querySelector(at.elements.leftToSpend));
    }
    initDefaultCartEvents() {
      this.ajaxEnabled
        ? (this.cartEvents(), this.customEventAddProduct())
        : this.items.length && this.noAjaxUpdate(),
        this.initQuantity(this.ajaxEnabled),
        this.cartMessage &&
          ((this.cartFreeLimitShipping = Number(
            this.cartMessage.getAttribute(at.elements.freeMessageLimit)
          )),
          this.cartBarProgress());
    }
    initQuantity(t) {
      (this.items = document.querySelectorAll(at.elements.item)),
        this.items.forEach(e => {
          new rt(e, !0).init(), t && this.customEventsHandle(e);
        });
    }
    noAjaxUpdate() {
      this.buttonHolder
        .querySelector(at.elements.buttonUpdateCart)
        .addEventListener("click", t => {
          t.preventDefault(),
            this.items.forEach(t => {
              const e = t.querySelector(`input[${at.attributes.dataId}]`);
              this.updateCart({
                id: e.getAttribute(at.attributes.dataId),
                quantity: e.value,
              });
            });
        });
    }
    customEventsHandle(t) {
      t.addEventListener(
        "cart:update",
        v(e => {
          this.updateCart(
            { id: e.detail.id, quantity: e.detail.quantity },
            t,
            e.detail.valueIsEmpty
          );
        }, 500)
      );
    }
    customEventAddProduct() {
      document.addEventListener(
        "cart:add-item",
        v(t => {
          this.cartToggle.classList.add(at.classes.isAdded),
            setTimeout(() => {
              this.cartToggle.classList.remove(at.classes.isAdded);
            }, 800);
        }, 500)
      );
    }
    cartEvents() {
      const t = document.querySelectorAll(at.elements.cartItemRemove);
      t &&
        t.forEach(t => {
          t.addEventListener("click", e => {
            e.preventDefault(),
              e.target
                .closest(at.elements.item)
                .classList.add(at.classes.loading),
              this.updateCart({
                id: t.getAttribute(at.attributes.dataId),
                quantity: 0,
              });
          });
        }),
        this.cartCloseErrorMessage &&
          this.cartCloseErrorMessage.addEventListener("click", t => {
            t.preventDefault(), it(this.cartErrorHolder, 400);
          }),
        this.continueBtns &&
          this.continueBtns.forEach(t => {
            t.addEventListener("click", t => {
              const e = document.referrer,
                i = window.location.origin + "/",
                s =
                  (window.innerWidth ||
                    document.documentElement.clientWidth ||
                    document.body.clientWidth) > theme.sizes.small;
              t.preventDefault(),
                !s || window.location.href.indexOf("/cart") > -1
                  ? e === i
                    ? (window.location.href = theme.routes.root_url)
                    : history.back(1)
                  : this.closeCartDrawer();
            });
          }),
        this.cartClose &&
          this.cartClose.addEventListener("click", this.closeCartDrawer),
        this.cartContainer &&
          this.cartContainer.addEventListener("keyup", this.cartKeyUpEvent),
        this.cartAcceptanceCheckbox &&
          (this.cart.addEventListener("click", t => {
            const e = t.target;
            (e.matches(at.elements.cartButtons) ||
              e.closest(at.elements.cartButtons)) &&
              this.termsAcceptance(t);
          }),
          this.cartAcceptanceCheckbox.addEventListener("change", t =>
            this.termsAcceptance(t)
          ),
          !1 === this.cartAcceptanceCheckbox.checked &&
            this.cart
              .querySelector(at.elements.cartButtonsFieldset)
              .setAttribute(at.attributes.disabled, !0));
    }
    cartKeyUpEvent(t) {
      (t.which || t.keyCode) === theme.keyboardKeys.ESCAPE &&
        this.cartDrawerIsOpen &&
        (this.closeCartDrawer(), this.popoverHide());
    }
    termsAcceptance(t) {
      const e = !1 === this.cartAcceptanceCheckbox.checked,
        i = this.cart.querySelector(at.elements.cartFormError),
        s = this.cart.querySelector(at.elements.cartButtonsFieldset);
      e
        ? (t.preventDefault(),
          s.setAttribute(at.attributes.disabled, !0),
          st(i))
        : (s.removeAttribute(at.attributes.disabled), it(i));
    }
    renderPopover(t, s) {
      let o = {},
        n = theme.assets.no_image,
        r = "";
      const a = e.formatMoney(t.final_price, at.formatMoney),
        l = t.selling_plan_allocation
          ? t.selling_plan_allocation.selling_plan.name
          : null;
      let c = "";
      if (
        (t.unit_price_measurement &&
          ((r = `${e.formatMoney(t.unit_price, at.formatMoney)} `),
          1 != t.unit_price_measurement.reference_value &&
            (r += t.unit_price_measurement.reference_value),
          (r += t.unit_price_measurement.reference_unit)),
        null != t.image &&
          (n = ((t, e) => {
            let i = "";
            return -1 != t.indexOf("blank.gif")
              ? t
              : ((i +=
                  t.replace("_1x1.", "_180x.") +
                  " 180w " +
                  Math.round(180 / e) +
                  "h,"),
                (i +=
                  t.replace("_1x1.", "_240x.") +
                  " 240w " +
                  Math.round(240 / e) +
                  "h,"),
                (i +=
                  t.replace("_1x1.", "_360x.") +
                  " 360w " +
                  Math.round(360 / e) +
                  "h,"),
                (i +=
                  t.replace("_1x1.", "_540x.") +
                  " 540w " +
                  Math.round(540 / e) +
                  "h,"),
                (i +=
                  t.replace("_1x1.", "_720x.") +
                  " 720w " +
                  Math.round(720 / e) +
                  "h,"),
                (i +=
                  t.replace("_1x1.", "_900x.") +
                  " 900w " +
                  Math.round(900 / e) +
                  "h,"),
                (i +=
                  t.replace("_1x1.", "_1080x.") +
                  " 1080w " +
                  Math.round(1080 / e) +
                  "h,"),
                (i +=
                  t.replace("_1x1.", "_1296x.") +
                  " 1296w " +
                  Math.round(1296 / e) +
                  "h,"),
                (i +=
                  t.replace("_1x1.", "_1512x.") +
                  " 1512w " +
                  Math.round(1512 / e) +
                  "h,"),
                (i +=
                  t.replace("_1x1.", "_1728x.") +
                  " 1728w " +
                  Math.round(1728 / e) +
                  "h,"),
                (i +=
                  t.replace("_1x1.", "_1950x.") +
                  " 1950w " +
                  Math.round(1950 / e) +
                  "h,"),
                (i += t + " 2048w " + Math.round(2048 / e) + "h"),
                i);
          })(
            t.image.replace(/(\.[^.]*)$/, "_1x1$1").replace("http:", ""),
            t.featured_image.aspect_ratio
          )),
        t.properties)
      )
        for (const e in t.properties)
          ({}).hasOwnProperty.call(t.properties, e) &&
            (c += "<p>" + e + ": " + t.properties[e] + "</p>");
      return (
        (o = {
          item_count: s,
          img: n,
          product_title: t.product_title,
          variation: !t.product_has_only_default_variant && t.variant_title,
          selling_plan_name: l,
          properties: c,
          price: t.price,
          price_formatted: a,
          unit_price: r,
        }),
        i.render(this.popoverTemplate, o)
      );
    }
    popoverShow(t, e) {
      (this.popover.innerHTML = this.renderPopover(t, e)),
        this.popover.classList.add(at.classes.visible),
        clearTimeout(this.popoverTimer),
        (this.popoverTimer = setTimeout(() => {
          this.popoverHide();
        }, at.times.closeDropdownAfter));
    }
    popoverHide() {
      this.popover.classList.remove(at.classes.visible),
        setTimeout(() => {
          this.popover.innerHtml = "";
        }, 300);
    }
    addProductEvent() {
      document.addEventListener("click", t => {
        if (t.target.matches(at.elements.buttonAddToCart)) {
          t.preventDefault();
          const e = t.target;
          if (e.hasAttribute(at.attributes.disabled)) return;
          e.setAttribute(at.attributes.disabled, !0),
            (this.form = e.closest("form"));
          const i = this.form.querySelector(at.elements.qty).value;
          let s = new FormData(this.form);
          if (
            ((s = new URLSearchParams(s).toString()),
            this.form.querySelector('[type="file"]'))
          )
            return;
          this.addToCart(s, null, e, i),
            document.dispatchEvent(
              new CustomEvent("cart:add-item", {
                bubbles: !0,
                detail: { selector: e },
              })
            );
        }
      });
    }
    getCart() {
      fetch("/cart.js")
        .then(this.handleErrors)
        .then(t => t.json())
        .then(
          t => (
            this.updateCounter(t.item_count),
            null !== this.cart &&
              ((this.newTotalItems = t.items.length),
              this.buildTotalPrice(t),
              (this.subtotal = t.total_price)),
            fetch("/cart?section_id=api-cart-items")
          )
        )
        .then(t => t.text())
        .then(t => {
          this.build(t), this.cartMessage && this.cartBarProgress();
        })
        .catch(t => console.log(t));
    }
    addToCart(t, e = null, i = null, s = 1) {
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: t,
      })
        .then(t => t.json())
        .then(t => {
          t.status
            ? null !== e
              ? this.addToCartError(t, e.element, i)
              : this.addToCartError(t, null, i)
            : this.ajaxEnabled
            ? (null !== this.cart ? this.getCart() : this.renderCart(),
              i &&
                (i.classList.remove(at.classes.loading),
                i.classList.add(at.classes.success)),
              setTimeout(() => {
                null !== i &&
                  (i.removeAttribute(at.attributes.disabled),
                  i.classList.remove(at.classes.success));
                (window.innerWidth ||
                  document.documentElement.clientWidth ||
                  document.body.clientWidth) >= theme.sizes.mobile &&
                  this.popoverShow(t, s);
              }, at.times.timeoutAddProduct))
            : (
              window.location.href = window.location.href + (window.location.href.indexOf('?') !== -1 ? '&' : '?') + 'productAdded'
            );
        })
        .catch(t => console.log(t));
    }
    updateCart(t = {}, e = null, i = !1) {
      let s = null,
        o = null,
        n = null,
        r = t.quantity;
      null !== e &&
        e.closest(at.elements.item).classList.add(at.classes.loading),
        this.items.forEach(t => {
          t.classList.add(at.classes.disabled),
            t
              .querySelector(at.elements.input)
              .setAttribute(at.attributes.disabled, !0),
            t.querySelector(at.elements.input).blur(),
            t.querySelectorAll(at.elements.button).forEach(t => {
              t.setAttribute(at.attributes.disabled, !0);
            });
        }),
        fetch("/cart.js")
          .then(this.handleErrors)
          .then(t => t.json())
          .then(e => {
            const i = e.items.findIndex(e => e.key === t.id);
            (o = e.item_count), (n = e.items[i].title);
            const s = { line: `${i + 1}`, quantity: r };
            return fetch("/cart/change.js", {
              method: "post",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(s),
            });
          })
          .then(this.handleErrors)
          .then(t => t.json())
          .then(e => {
            if (((s = e.item_count), i && (r = 1), this.ajaxEnabled))
              0 !== r &&
                ((this.cartLimitErrorIsHidden = s !== o),
                this.toggleLimitError(n)),
                this.updateCounter(s),
                this.buildTotalPrice(e),
                (this.cartDiscounts = e.total_discount),
                (this.subtotal = e.total_price),
                this.cartMessage && this.cartBarProgress(),
                this.getCart();
            else {
              const i = this.buttonHolder.closest("form");
              e.items.forEach(e => {
                e.key === t.id &&
                  (i.querySelector(
                    `[${at.attributes.dataId}="${e.key}"]`
                  ).value = e.quantity);
              }),
                i.submit();
            }
          })
          .catch(t => console.log(t));
    }
    toggleLimitError(t) {
      (this.cartErrorHolder.querySelector(at.elements.errorMessage).innerText =
        t),
        this.cartLimitErrorIsHidden
          ? it(this.cartErrorHolder, 400)
          : st(this.cartErrorHolder, 400);
    }
    handleErrors(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new ot({ status: t.statusText, headers: t.headers, json: e });
          });
    }
    addToCartError(t, e, i) {
      let s = this.popover;
      if (null !== i) {
        const t = i.querySelector(at.elements.buttonAddToCartText);
        (t.textContent = theme.translations.form_submit_error),
          i.setAttribute(at.attributes.disabled, at.attributes.disabled),
          setTimeout(() => {
            i.removeAttribute(at.attributes.disabled),
              (t.textContent = theme.translations.form_submit);
          }, 1e3);
      }
      clearTimeout(this.popoverTimer),
        s &&
          ((s.innerHTML = `<div class="popover-error">${t.message}: ${t.description}</div>`),
          s.classList.add(at.classes.visible)),
        e &&
          this.html.dispatchEvent(
            new CustomEvent("cart:add-to-error", {
              bubbles: !0,
              detail: {
                message: t.message,
                description: t.description,
                holder: e,
              },
            })
          ),
        (this.popoverTimer = setTimeout(() => {
          s.classList.remove(at.classes.visible);
        }, at.times.closeDropdownAfter));
    }
    openCartDrawer() {
      this.popoverHide(),
        null === this.cart && this.renderCart(),
        document.dispatchEvent(
          new CustomEvent("theme:drawer:close", { bubbles: !1 })
        ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", {
            bubbles: !0,
            detail: this.cart,
          })
        ),
        this.setCartClosePosition(),
        this.body.classList.add(at.classes.cartVisible),
        this.cart.classList.add(at.classes.open),
        this.cartToggle.setAttribute(at.attributes.expanded, !0),
        this.accessibility.removeTrapFocus(),
        (this.cartDrawerIsOpen = !0),
        this.cartFocusTimeout && clearTimeout(this.cartFocusTimeout),
        (this.cartFocusTimeout = setTimeout(() => {
          this.accessibility.trapFocus(this.cart, {
            elementToFocus: this.cart.querySelector("a, button, input"),
          });
        }, 500));
    }
    closeCartDrawer() {
      if (
        ((this.cartDrawerIsOpen = !1),
        document.dispatchEvent(
          new CustomEvent("theme:cart-close", { bubbles: !0 })
        ),
        this.accessibility.removeTrapFocus(),
        it(this.cartErrorHolder, 400),
        this.body.classList.contains(at.classes.focused))
      ) {
        const t = document.querySelector(`${at.elements.cartToggleElement}`);
        setTimeout(() => {
          t.focus();
        }, 200);
      }
      this.body.classList.remove(at.classes.cartVisible),
        this.cart.classList.remove(at.classes.open),
        this.cartToggle.setAttribute(at.attributes.expanded, !1),
        this.popoverHide(),
        this.scrollLockTimeout && clearTimeout(this.scrollLockTimeout),
        (this.scrollLockTimeout = setTimeout(() => {
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
          );
        }, 500));
    }
    toggleCartDrawer() {
      this.body.classList.contains(at.classes.template) ||
        (this.cartDrawerIsOpen
          ? this.closeCartDrawer()
          : this.openCartDrawer());
    }
    eventToggleCart() {
      document.addEventListener("click", t => {
        const e = t.target,
          i =
            window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth,
          s =
            e.matches(at.elements.cartToggleElement) ||
            e.closest(at.elements.cartToggleElement),
          o = e.matches(at.elements.popover) || e.closest(at.elements.popover);
        i > theme.sizes.small &&
          (s || o) &&
          (this.toggleCartDrawer(), t.preventDefault());
      });
    }
    toggleClassesOnContainers() {
      this.emptyMessage.classList.toggle(
        at.classes.hidden,
        this.hasItemsInCart()
      ),
        this.buttonHolder.classList.toggle(
          at.classes.hidden,
          !this.hasItemsInCart()
        ),
        this.itemsHolder.classList.toggle(
          at.classes.hidden,
          !this.hasItemsInCart()
        );
    }
    build(t) {
      if (null === this.cart) return void this.renderCart();
      this.totalItems !== this.newTotalItems &&
        ((this.totalItems = this.newTotalItems),
        this.toggleClassesOnContainers());
      const e = document.createElement("div");
      (e.innerHTML = t),
        (this.itemsHolder.innerHTML = e.querySelector(
          at.elements.apiContent
        ).innerHTML),
        this.cartEvents(),
        this.initQuantity(this.ajaxEnabled);
    }
    updateCounter(t) {
      t > 0
        ? this.cartToggle.classList.remove(at.classes.cartEmpty)
        : this.cartToggle.classList.add(at.classes.cartEmpty),
        this.cartItemsCount &&
          (this.cartItemsCount.innerText = t < 10 ? t : "9+");
    }
    hasItemsInCart() {
      return this.totalItems > 0;
    }
    buildTotalPrice(t) {
      if (null !== this.cart)
        if (
          (t.original_total_price > t.total_price &&
          t.cart_level_discount_applications.length > 0
            ? (this.cartOriginalTotal.classList.remove(at.classes.hidden),
              (this.cartOriginaTotalPrice.innerHTML = e.formatMoney(
                t.original_total_price,
                at.formatMoney
              )))
            : this.cartOriginalTotal.classList.add(at.classes.hidden),
          (this.cartTotal.innerHTML = e.formatMoney(
            t.total_price,
            at.formatMoney
          )),
          t.cart_level_discount_applications.length > 0)
        ) {
          const e = this.buildCartTotalDiscounts(
            t.cart_level_discount_applications
          );
          this.cartDiscountHolder.classList.remove(at.classes.hidden),
            (this.cartDiscountHolder.innerHTML = e);
        } else this.cartDiscountHolder.classList.add(at.classes.hidden);
    }
    buildCartTotalDiscounts(t) {
      let s = "";
      return (
        t.forEach(t => {
          s += i.render(this.cartTotalDiscountTemplate, {
            discount_title: t.title,
            discount_total_allocated_amount: e.formatMoney(
              t.total_allocated_amount,
              at.formatMoney
            ),
          });
        }),
        s
      );
    }
    setCartClosePosition() {
      if (this.cartToggle) {
        const t = this.cartToggle.getBoundingClientRect().top,
          e = 40;
        this.cartClose.style.top = t - e + "px";
      }
    }
    cartBarProgress() {
      if (void 0 === this.subtotal) return;
      let t = this.subtotal,
        i = e.formatMoney(
          this.cartFreeLimitShipping - this.subtotal,
          at.formatMoney
        );
      this.subtotal > 0 &&
        (t =
          at.dimensions.maxSize -
          ((this.cartFreeLimitShipping - this.subtotal) *
            at.dimensions.maxSize) /
            this.cartFreeLimitShipping),
        t > at.dimensions.maxSize && ((t = at.dimensions.maxSize), (i = "0")),
        (this.progressBar.style.width = `${t}%`),
        this.leftToSpend && (this.leftToSpend.innerHTML = i.replace(".00", "")),
        this.checkForFreeDelivery();
    }
    checkForFreeDelivery() {
      const t =
        this.cartMessage.hasAttribute(at.elements.cartMessageValue) &&
        "true" ===
          this.cartMessage.getAttribute(at.elements.cartMessageValue) &&
        0 !== this.subtotal
          ? ""
          : at.classes.defaultSuccess;
      this.cartMessage.classList.toggle(
        t,
        this.subtotal >= this.cartFreeLimitShipping || 0 === this.subtotal
      );
    }
  })();
  const lt = {
    elements: {
      html: "html",
      body: "body",
      inPageLink: "[data-skip-content]",
      linkesWithOnlyHash: 'a[href="#"]',
      triggerFocusElement: "[data-focus-element]",
      viewAll: "[data-view-all]",
    },
    classes: { focus: "is-focused" },
  };
  (window.accessibility = new (class {
    constructor() {
      this.init();
    }
    init() {
      (this.settings = lt),
        (this.window = window),
        (this.document = document),
        (this.a11y = et),
        (this.inPageLink = this.document.querySelector(
          this.settings.elements.inPageLink
        )),
        (this.linkesWithOnlyHash = this.document.querySelectorAll(
          `${this.settings.elements.linkesWithOnlyHash}:not(${this.settings.elements.viewAll})`
        )),
        (this.html = this.document.querySelector(this.settings.elements.html)),
        (this.body = this.document.querySelector(this.settings.elements.body)),
        (this.lastFocused = null),
        (this.isFocused = !1),
        this.a11y.focusHash(),
        this.a11y.bindInPageLinks(),
        this.clickEvents(),
        this.focusEvents(),
        this.focusEventsOff(),
        this.closeExpandedElements();
    }
    clickEvents() {
      this.inPageLink &&
        this.inPageLink.addEventListener("click", t => {
          t.preventDefault();
        }),
        this.linkesWithOnlyHash &&
          this.linkesWithOnlyHash.forEach(t => {
            t.addEventListener("click", t => {
              t.preventDefault();
            });
          });
    }
    focusEvents() {
      this.document.addEventListener("keyup", t => {
        t.keyCode === theme.keyboardKeys.TAB &&
          (this.body.classList.add(this.settings.classes.focus),
          (this.isFocused = !0));
      }),
        this.document.addEventListener("keyup", t => {
          if (!this.isFocused) return;
          const e = t.target,
            i =
              t.keyCode === theme.keyboardKeys.ENTER ||
              t.keyCode === theme.keyboardKeys.SPACE,
            s =
              e.matches(this.settings.elements.triggerFocusElement) ||
              e.closest(this.settings.elements.triggerFocusElement);
          i && s && null === this.lastFocused && (this.lastFocused = e);
        }),
        this.html.addEventListener("cart:add-item", t => {
          this.lastFocused = t.detail.selector;
        });
    }
    focusEventsOff() {
      this.document.addEventListener("mousedown", () => {
        this.body.classList.remove(this.settings.classes.focus),
          (this.isFocused = !1);
      });
    }
    closeExpandedElements() {
      document.addEventListener("keyup", t => {
        t.keyCode === theme.keyboardKeys.ESCAPE &&
          (this.a11y.removeTrapFocus(),
          null !== this.lastFocused &&
            setTimeout(() => {
              this.lastFocused.focus(), (this.lastFocused = null);
            }, 600));
      });
    }
  })()),
    i.filters.define("handle", function (t) {
      t = t.toLowerCase();
      for (
        var e = ['"', "'", "\\", "(", ")", "[", "]"], i = 0;
        i < e.length;
        ++i
      )
        t = t.replace(e[i], "");
      return (
        "-" == (t = t.replace(/\W+/g, "-")).charAt(t.length - 1) &&
          (t = t.replace(/-+\z/, "")),
        "-" == t.charAt(0) && (t = t.replace(/\A-+/, "")),
        t
      );
    }),
    i.filters.define("last", function (t) {
      const e = t.split("-");
      return e[e.length - 1];
    }),
    i.filters.define("asset_url", function (t) {
      let e = theme.assets.image;
      return (e = e.replace("image", t)), e;
    }),
    (window.isYoutubeAPILoaded = !1),
    (window.onYouTubeIframeAPIReady = function () {
      (window.isYoutubeAPILoaded = !0),
        document.body.dispatchEvent(new CustomEvent("youtubeAPIReady"));
    }),
    (window.loadYoutubeAPI = function () {
      if (!window.isYoutubeAPILoaded) {
        var t = document.createElement("script");
        t.src = "https://www.youtube.com/iframe_api";
        var e = document.getElementsByTagName("script")[0];
        e.parentNode.insertBefore(t, e);
      }
    }),
    (theme.ProductModel = (function () {
      let t = {},
        e = {},
        i = {};
      const s = "[data-product-single-media-wrapper]",
        o = "[data-shopify-xr]",
        n = "data-media-id",
        r = "data-shopify-model3d-id",
        a = "#ModelJson-",
        l = "media--hidden",
        c = "[data-deferred-media]",
        d = "[data-deferred-media-button]",
        h = "is-loading";
      function u(t, n) {
        if (t.querySelector(c).getAttribute("loaded")) return;
        t.classList.add(h);
        const r = document.createElement("div");
        r.appendChild(
          t.querySelector("template").content.firstElementChild.cloneNode(!0)
        );
        const a = r.querySelector("model-viewer"),
          l = t.querySelector(c);
        l.appendChild(a).focus(), l.setAttribute("loaded", !0);
        const d = t.dataset.mediaId,
          u = a.dataset.modelId,
          f = t.closest(s).querySelector(o);
        (i[n] = { element: f, defaultId: u }),
          (e[d] = {
            modelId: u,
            mediaId: d,
            sectionId: n,
            container: t,
            element: a,
          }),
          window.Shopify.loadFeatures([
            { name: "shopify-xr", version: "1.0", onLoad: p },
            { name: "model-viewer-ui", version: "1.0", onLoad: m },
          ]);
      }
      function p(e) {
        if (e) console.warn(e);
        else if (window.ShopifyXR) {
          for (const e in t)
            if (t.hasOwnProperty(e)) {
              const i = t[e];
              if (i.loaded) continue;
              const s = document.querySelector(`${a}${e}`);
              s &&
                (window.ShopifyXR.addModels(JSON.parse(s.innerHTML)),
                (i.loaded = !0));
            }
          window.ShopifyXR.setupXRElements();
        } else
          document.addEventListener("shopify_xr_initialized", function () {
            p();
          });
      }
      function m(t) {
        if (t) console.warn(t);
        else
          for (const t in e)
            if (e.hasOwnProperty(t)) {
              const i = e[t];
              i.modelViewerUi ||
                (i.modelViewerUi = new Shopify.ModelViewerUI(i.element)),
                f(i);
            }
      }
      function f(t) {
        const e = i[t.sectionId];
        t.container.addEventListener("mediaVisible", function () {
          e.element.setAttribute(r, t.modelId),
            y(t.mediaId),
            window.theme.touched || t.modelViewerUi.play();
        }),
          t.container.addEventListener("mediaHidden", function () {
            t.modelViewerUi.pause();
          }),
          t.container.addEventListener("xrLaunch", function () {
            t.modelViewerUi.pause();
          }),
          t.element.addEventListener("load", () => {
            t.container.classList.remove(h);
          }),
          t.element.addEventListener(
            "shopify_model_viewer_ui_toggle_play",
            function () {
              y(t.mediaId);
            }
          );
      }
      function y(t) {
        const e = `[${n}="${t}"]`,
          i = document.querySelector(`${s}${e}`),
          o = document.querySelectorAll(`${s}:not(${e})`);
        i.classList.remove(l),
          o.length &&
            o.forEach(t => {
              t.dispatchEvent(new CustomEvent("mediaHidden")),
                t.classList.add(l);
            });
      }
      return {
        init: function (e, i) {
          t[i] = { loaded: !1 };
          const s = e.querySelector(d);
          s && s.addEventListener("click", u.bind(this, e, i));
        },
        loadContent: u,
        removeSectionModels: function (i) {
          for (const t in e)
            if (e.hasOwnProperty(t)) {
              e[t].sectionId === i && delete e[t];
            }
          delete t[i], delete theme.mediaInstances[i];
        },
      };
    })());
  const ct = ".template-customers-addresses",
    dt = "[data-form]",
    ht = "[data-form-new]",
    ut = "[data-button-new]",
    pt = "[data-button-edit]",
    mt = "[data-button-delete]",
    ft = "[data-button-cancel]",
    yt = "data-form-id",
    vt = "Are you sure you wish to delete this address?",
    gt = "data-form-edit",
    bt = "AddressCountryNew",
    wt = "AddressProvinceNew",
    Et = "AddressProvinceContainerNew",
    Lt = "[data-country-option]",
    St = "AddressCountry",
    kt = "AddressProvince",
    qt = "AddressProvinceContainer",
    At = 'input[type="text"]:not(.optional)',
    Tt = "is-hidden",
    Ct = "validation--showup";
  class xt {
    constructor(t) {
      (this.section = t),
        (this.addressNewForm = this.section.querySelector(ht)),
        (this.accountForms = this.section.querySelectorAll(dt)),
        this.init(),
        this.validate();
    }
    init() {
      if (this.addressNewForm) {
        const t = this.section,
          e = this.addressNewForm;
        this.customerAddresses();
        const i = t.querySelectorAll(ut);
        i.length &&
          i.forEach(t => {
            t.addEventListener("click", function (i) {
              i.preventDefault(), t.classList.add(Tt), e.classList.remove(Tt);
            });
          });
        const s = t.querySelectorAll(pt);
        s.length &&
          s.forEach(e => {
            e.addEventListener("click", function (e) {
              e.preventDefault();
              const i = this.getAttribute(yt);
              t.querySelector(`[${gt}="${i}"]`).classList.toggle(Tt);
            });
          });
        const o = t.querySelectorAll(mt);
        o.length &&
          o.forEach(t => {
            t.addEventListener("click", function (t) {
              t.preventDefault();
              const e = this.getAttribute(yt);
              confirm(vt) &&
                Shopify.postLink("/account/addresses/" + e, {
                  parameters: { _method: "delete" },
                });
            });
          });
        const n = t.querySelectorAll(ft);
        n.length &&
          n.forEach(t => {
            t.addEventListener("click", function (t) {
              t.preventDefault(),
                this.closest(dt).classList.add(Tt),
                document.querySelector(ut).classList.remove(Tt);
            });
          });
      }
    }
    customerAddresses() {
      Shopify.CountryProvinceSelector &&
        new Shopify.CountryProvinceSelector(bt, wt, { hideElement: Et });
      this.section.querySelectorAll(Lt).forEach(t => {
        const e = t.getAttribute(yt),
          i = `${St}_${e}`,
          s = `${kt}_${e}`,
          o = `${qt}_${e}`;
        Shopify.CountryProvinceSelector &&
          new Shopify.CountryProvinceSelector(i, s, { hideElement: o });
      });
    }
    validate() {
      this.accountForms.forEach(t => {
        const e = t.querySelector("form"),
          i = e.querySelectorAll(At);
        e.addEventListener("submit", t => {
          let e = !1;
          i.forEach(t => {
            t.value
              ? t.nextElementSibling.classList.remove(Ct)
              : (t.nextElementSibling.classList.add(Ct), (e = !0));
          }),
            e && t.preventDefault();
        });
      });
    }
  }
  const _t = document.querySelector(ct);
  _t && new xt(_t);
  const Pt = "[data-account-form]",
    It = "[data-show-reset]",
    Mt = "[data-hide-reset]",
    zt = "[data-recover-password]",
    Ht = "[data-login-form]",
    Ft = "#recover",
    $t = "is-hidden";
  class Bt {
    constructor(t) {
      (this.form = t),
        (this.showButton = t.querySelector(It)),
        (this.hideButton = t.querySelector(Mt)),
        (this.recover = t.querySelector(zt)),
        (this.login = t.querySelector(Ht)),
        this.init();
    }
    init() {
      window.location.hash == Ft
        ? this.showRecoverPasswordForm()
        : this.hideRecoverPasswordForm(),
        this.showButton.addEventListener(
          "click",
          function (t) {
            t.preventDefault(), this.showRecoverPasswordForm();
          }.bind(this),
          !1
        ),
        this.hideButton.addEventListener(
          "click",
          function (t) {
            t.preventDefault(), this.hideRecoverPasswordForm();
          }.bind(this),
          !1
        );
    }
    showRecoverPasswordForm() {
      return (
        this.recover.classList.remove($t),
        this.login.classList.add($t),
        (window.location.hash = Ft),
        !1
      );
    }
    hideRecoverPasswordForm() {
      return (
        this.login.classList.remove($t),
        this.recover.classList.add($t),
        (window.location.hash = ""),
        !1
      );
    }
  }
  const Wt = document.querySelector(Pt);
  Wt && new Bt(Wt),
    (window.Shopify = window.Shopify || {}),
    (window.Shopify.theme = window.Shopify.theme || {}),
    (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
    (window.Shopify.theme.sections.registered =
      window.Shopify.theme.sections.registered || {}),
    (window.Shopify.theme.sections.instances =
      window.Shopify.theme.sections.instances || []);
  const Ot = window.Shopify.theme.sections.registered,
    Dt = window.Shopify.theme.sections.instances,
    Nt = "data-section-id",
    Vt = "data-section-type";
  class Rt {
    constructor(t = null, e = []) {
      (this.type = t),
        (this.components = (function (t) {
          if ((void 0 !== t && "object" != typeof t) || null === t)
            throw new TypeError(
              "Theme Sections: The components object provided is not a valid"
            );
          return t;
        })(e)),
        (this.callStack = {
          onLoad: [],
          onUnload: [],
          onSelect: [],
          onDeselect: [],
          onBlockSelect: [],
          onBlockDeselect: [],
          onReorder: [],
        }),
        e.forEach(t => {
          for (const [e, i] of Object.entries(t)) {
            const t = this.callStack[e];
            Array.isArray(t) && "function" == typeof i
              ? t.push(i)
              : (console.warn(
                  `Unregisted function: '${e}' in component: '${this.type}'`
                ),
                console.warn(i));
          }
        });
    }
    getStack() {
      return this.callStack;
    }
  }
  class jt {
    constructor(t, e) {
      (this.container = (function (t) {
        if (!(t instanceof Element))
          throw new TypeError(
            "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
          );
        if (null === t.getAttribute(Nt))
          throw new Error(
            "Theme Sections: The section container provided does not have an id assigned to the " +
              Nt +
              " attribute."
          );
        return t;
      })(t)),
        (this.id = t.getAttribute(Nt)),
        (this.type = e.type),
        (this.callStack = e.getStack());
      try {
        this.onLoad();
      } catch (t) {
        console.warn(`Error in section: ${this.id}`),
          console.warn(this),
          console.warn(t);
      }
    }
    callFunctions(t, e = null) {
      this.callStack[t].forEach(t => {
        const i = { id: this.id, type: this.type, container: this.container };
        e ? t.call(i, e) : t.call(i);
      });
    }
    onLoad() {
      this.callFunctions("onLoad");
    }
    onUnload() {
      this.callFunctions("onUnload");
    }
    onSelect(t) {
      this.callFunctions("onSelect", t);
    }
    onDeselect(t) {
      this.callFunctions("onDeselect", t);
    }
    onBlockSelect(t) {
      this.callFunctions("onBlockSelect", t);
    }
    onBlockDeselect(t) {
      this.callFunctions("onBlockDeselect", t);
    }
    onReorder(t) {
      this.callFunctions("onReorder", t);
    }
  }
  function Ut(t, e) {
    if ("string" != typeof t)
      throw new TypeError(
        "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
      );
    if (void 0 !== Ot[t])
      throw new Error(
        'Theme Sections: A section of type "' +
          t +
          '" has already been registered. You cannot register the same section type twice'
      );
    Array.isArray(e) || (e = [e]);
    const i = new Rt(t, e);
    return (Ot[t] = i), Ot;
  }
  function Qt(t, e) {
    (t = Yt(t)),
      void 0 === e && (e = document.querySelectorAll("[" + Vt + "]")),
      (e = Jt(e)),
      t.forEach(function (t) {
        const i = Ot[t];
        void 0 !== i &&
          (e = e.filter(function (e) {
            return (
              !(Kt(e).length > 0) &&
              null !== e.getAttribute(Vt) &&
              (e.getAttribute(Vt) !== t || (Dt.push(new jt(e, i)), !1))
            );
          }));
      });
  }
  function Kt(t) {
    var e = [];
    if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var i = t[0];
    if (t instanceof Element || i instanceof Element)
      Jt(t).forEach(function (t) {
        e = e.concat(
          Dt.filter(function (e) {
            return e.container === t;
          })
        );
      });
    else if ("string" == typeof t || "string" == typeof i) {
      Yt(t).forEach(function (t) {
        e = e.concat(
          Dt.filter(function (e) {
            return e.type === t;
          })
        );
      });
    }
    return e;
  }
  function Xt(t) {
    for (var e, i = 0; i < Dt.length; i++)
      if (Dt[i].id === t) {
        e = Dt[i];
        break;
      }
    return e;
  }
  function Yt(t) {
    return (
      "*" === t
        ? (t = Object.keys(Ot))
        : "string" == typeof t
        ? (t = [t])
        : t.constructor === jt
        ? (t = [t.prototype.type])
        : Array.isArray(t) &&
          t[0].constructor === jt &&
          (t = t.map(function (t) {
            return t.type;
          })),
      (t = t.map(function (t) {
        return t.toLowerCase();
      }))
    );
  }
  function Jt(t) {
    return (
      NodeList.prototype.isPrototypeOf(t) && t.length > 0
        ? (t = Array.prototype.slice.call(t))
        : (NodeList.prototype.isPrototypeOf(t) && 0 === t.length) || null === t
        ? (t = [])
        : !Array.isArray(t) && t instanceof Element && (t = [t]),
      t
    );
  }
  window.Shopify.designMode &&
    (document.addEventListener("shopify:section:load", function (t) {
      var e = t.detail.sectionId,
        i = t.target.querySelector("[" + Nt + '="' + e + '"]');
      null !== i && Qt(i.getAttribute(Vt), i);
    }),
    document.addEventListener("shopify:section:reorder", function (t) {
      var e = t.detail.sectionId,
        i = t.target.querySelector("[" + Nt + '="' + e + '"]');
      "object" == typeof Kt(i)[0] &&
        Kt(i).forEach(function (t) {
          t.onReorder();
        });
    }),
    document.addEventListener("shopify:section:unload", function (t) {
      var e = t.detail.sectionId,
        i = t.target.querySelector("[" + Nt + '="' + e + '"]');
      "object" == typeof Kt(i)[0] &&
        Kt(i).forEach(function (t) {
          var e = Dt.map(function (t) {
            return t.id;
          }).indexOf(t.id);
          Dt.splice(e, 1), t.onUnload();
        });
    }),
    document.addEventListener("shopify:section:select", function (t) {
      var e = Xt(t.detail.sectionId);
      "object" == typeof e && e.onSelect(t);
    }),
    document.addEventListener("shopify:section:deselect", function (t) {
      var e = Xt(t.detail.sectionId);
      "object" == typeof e && e.onDeselect(t);
    }),
    document.addEventListener("shopify:block:select", function (t) {
      var e = Xt(t.detail.sectionId);
      "object" == typeof e && e.onBlockSelect(t);
    }),
    document.addEventListener("shopify:block:deselect", function (t) {
      var e = Xt(t.detail.sectionId);
      "object" == typeof e && e.onBlockDeselect(t);
    }));
  const Gt = "data-aos",
    Zt = t => {
      t.querySelectorAll(`[${Gt}]`).forEach(t => {
        t.removeAttribute(Gt);
      });
    },
    te = "[data-badge]",
    ee = "data-aspectratio",
    ie = t => {
      t.forEach(t => {
        const e = t.querySelector(te);
        if (null === e) return;
        const i = parseFloat(t.getAttribute(ee)),
          s = t.offsetWidth,
          o = t.offsetHeight;
        let n = 0,
          r = 0;
        i < s / o ? (r = (s - o * i) / 2) : (n = (o - s / i) / 2),
          (e.style.cssText = `top: ${n}px; left: ${r}px`);
      });
    };
  function se(t) {
    const e = `${theme.routes.root_url}products/${t}.js`;
    return window
      .fetch(e)
      .then(t => t.json())
      .catch(t => {
        console.error(t);
      });
  }
  const oe = { color: "ash" },
    ne = "data-swatch",
    re = "[data-swatch-color]",
    ae = "[data-grid-swatches]",
    le = "[data-swatch-template]",
    ce = "data-swatch-handle",
    de = "data-swatch-label";
  class he {
    constructor(t = {}) {
      (this.settings = { ...oe, ...t }), (this.match = this.init());
    }
    getColor() {
      return this.match;
    }
    init() {
      return T({ json: theme.assets.swatches })
        .then(t => this.matchColors(t, this.settings.color))
        .catch(t => {
          console.log("failed to load swatch colors script"), console.log(t);
        });
    }
    matchColors(t, e) {
      let i = "#E5E5E5",
        s = null;
      const o = theme.assets.base || "/",
        n = e.toLowerCase().replace(/\s/g, ""),
        r = t.colors;
      if (r) {
        let t = null;
        if (
          r.filter((e, i) => {
            if (
              Object.keys(e).toString().toLowerCase().replace(/\s/g, "") === n
            )
              return (t = i), e;
          }).length &&
          null !== t
        ) {
          const e = Object.values(r[t])[0];
          (i = e),
            (e.includes(".jpg") ||
              e.includes(".jpeg") ||
              e.includes(".png") ||
              e.includes(".svg")) &&
              ((s = `${o}${e}`), (i = "#888888"));
        }
      }
      return { color: this.settings.color, path: s, hex: i };
    }
  }
  class ue {
    constructor(t) {
      (this.element = t),
        (this.swatchColor = this.element.querySelector(re)),
        (this.colorString = t.getAttribute(ne));
      new he({ color: this.colorString }).getColor().then(t => {
        (this.colorMatch = t), this.init();
      });
    }
    init() {
      this.colorMatch &&
        this.colorMatch.hex &&
        this.swatchColor.style.setProperty(
          "--swatch",
          `${this.colorMatch.hex}`
        ),
        this.colorMatch &&
          this.colorMatch.path &&
          this.swatchColor.style.setProperty(
            "background-image",
            `url(${this.colorMatch.path})`
          );
    }
  }
  class pe {
    constructor(t, e) {
      (this.template = document.querySelector(le).innerHTML),
        (this.wrap = t),
        (this.container = e),
        (this.handle = t.getAttribute(ce));
      const i = t.getAttribute(de).trim().toLowerCase();
      se(this.handle).then(t => {
        (this.product = t),
          (this.colorOption = t.options.find(function (t) {
            return t.name.toLowerCase() === i || null;
          })),
          this.colorOption &&
            ((this.swatches = this.colorOption.values), this.init());
      });
    }
    init() {
      (this.wrap.innerHTML = ""),
        this.swatches.forEach(t => {
          let e = this.product.variants.find(e => e.options.includes(t));
          e &&
            (this.wrap.innerHTML += i.render(this.template, {
              color: t,
              uniq: `${this.product.id}-${e.id}`,
              variant: e.id,
              variantUrl: `${this.product.url}?variant=${e.id}`,
            }));
        }),
        (this.swatchElements = this.wrap.querySelectorAll(`[${ne}]`)),
        this.swatchElements.forEach(t => {
          new ue(t);
        });
    }
  }
  const me = t => {
      t.querySelectorAll(ae).forEach(t => {
        new pe(t, void 0);
      });
    },
    fe = {
      onLoad() {
        this.swatches = [];
        this.container.querySelectorAll(`[${ne}]`).forEach(t => {
          this.swatches.push(new ue(t));
        });
      },
    },
    ye = {
      onLoad() {
        me(this.container);
      },
    },
    ve = (t, e) => {
      let i, s;
      return function o(...n) {
        const r = Date.now();
        (s = clearTimeout(s)),
          !i || r - i >= e
            ? (t.apply(null, n), (i = r))
            : (s = setTimeout(o.bind(null, ...n), e - (r - i)));
      };
    },
    ge = "[data-custom-scrollbar-items]",
    be = "[data-custom-scrollbar]",
    we = "[data-custom-scrollbar-track]";
  class Ee {
    constructor(t) {
      (this.itemsParent = t.querySelector(ge)),
        (this.scrollbar = t.querySelector(be)),
        (this.scrollbarTrack = t.querySelector(we)),
        (this.trackWidth = 0),
        (this.scrollEvent = ve(() => this.calculatePosition(), 50)),
        (this.resizeEvent = v(() => this.calculateTrackWidth(), 250)),
        this.scrollbar &&
          this.itemsParent &&
          (this.events(), this.calculateTrackWidth());
    }
    events() {
      this.itemsParent.addEventListener("scroll", this.scrollEvent),
        document.addEventListener("theme:resize", this.resizeEvent);
    }
    calculateTrackWidth() {
      (this.trackWidth = 100 / this.itemsParent.children.length),
        (this.trackWidth = this.trackWidth < 5 ? 5 : this.trackWidth),
        this.scrollbar.style.setProperty(
          "--track-width",
          `${this.trackWidth}%`
        );
    }
    calculatePosition() {
      const t = this.scrollbar.clientWidth * ((100 - this.trackWidth) / 100);
      let e =
        this.itemsParent.scrollLeft /
        (this.itemsParent.scrollWidth - this.itemsParent.clientWidth);
      (e *= t),
        this.scrollbar.style.setProperty("--position", `${Math.round(e)}px`);
    }
    destroy() {
      this.itemsParent.removeEventListener("scroll", this.scrollEvent),
        document.removeEventListener("theme:resize", this.resizeEvent);
    }
  }
  const Le = "[data-product-container]",
    Se = "[data-product-slideshow]",
    ke = "[data-product-single-media-wrapper]",
    qe = "[data-product-single-media-thumbs]",
    Ae = "[data-thumbnail]",
    Te = "[data-thumbnail-id]",
    Ce = "[data-deferred-media-button]",
    xe = "data-type",
    _e = "data-arrows",
    Pe = "data-dots",
    Ie = "product--layout-scrollable",
    Me = "media--hidden",
    ze = "is-focused",
    He = "product__images__slider-nav--arrows",
    Fe = "is-moving";
  class $e {
    constructor(t) {
      (this.container = t.container),
        (this.productContainer = this.container.querySelector(Le)),
        (this.scrollable = this.productContainer.classList.contains(Ie)),
        (this.slideshow = this.container.querySelector(Se)),
        (this.productImages = this.container.querySelectorAll(ke)),
        (this.thumbs = this.container.querySelector(qe)),
        (this.flkty = null),
        (this.flktyNav = null),
        (this.sliderResizeEvent = v(() => this.flickityResizeEvent(), 250)),
        (this.thumbsResizeEvent = v(() => this.checkThumbsWidth(), 250)),
        (this.scrollableResizeEvent = v(
          () => this.toggleCustomScrollbar(),
          250
        )),
        this.productImages.length > 1 && this.init();
    }
    init() {
      this.createSlider(), this.createSliderNav(), this.createScrollable();
    }
    createSlider() {
      if (!this.slideshow) return;
      const t = this,
        e = this.slideshow.querySelectorAll(`[${xe}]`)[0],
        i = "true" === this.slideshow.getAttribute(_e),
        s = "true" === this.slideshow.getAttribute(Pe),
        n = {
          autoPlay: !1,
          arrowShape: theme.icons.arrowNavSlider,
          prevNextButtons: i,
          contain: !0,
          pageDots: s,
          adaptiveHeight: !0,
          wrapAround: !0,
          resize: !1,
        };
      if (((this.flkty = new o(this.slideshow, n)), e)) {
        const t = e.getAttribute(xe);
        ("model" !== t && "video" !== t && "external_video" !== t) ||
          ((this.flkty.options.draggable = !1), this.flkty.updateDraggable());
      }
      this.flkty.on("dragStart", function () {
        t.slideshow.classList.add(Fe),
          (document.ontouchmove = t => t.preventDefault());
      }),
        this.flkty.on("dragEnd", () => (document.ontouchmove = () => !0)),
        this.flkty.on("change", function (t) {
          const e = this.cells[t].element,
            i = this.selectedElement;
          e.dispatchEvent(new CustomEvent("mediaHidden")),
            i.classList.remove(Me);
        }),
        this.flkty.on("settle", function () {
          const e = this.selectedElement,
            i = e.getAttribute(xe);
          "model" === i || "video" === i || "external_video" === i
            ? ((t.flkty.options.draggable = !1), t.flkty.updateDraggable())
            : ((t.flkty.options.draggable = !0), t.flkty.updateDraggable()),
            t.switchMedia(e),
            t.slideshow.classList.remove(Fe),
            t.flkty.resizeQueued &&
              ((t.flkty.resizeQueued = !1), t.flkty.onresize());
        }),
        window.addEventListener("resize", this.sliderResizeEvent);
    }
    createSliderNav() {
      if (!this.thumbs || !this.slideshow) return;
      const t = {
        asNavFor: this.slideshow,
        pageDots: !1,
        prevNextButtons: !0,
        arrowShape: theme.icons.arrowNavSlider,
        groupCells: !0,
        contain: !0,
        resize: !1,
      };
      (this.flktyNav = new o(this.thumbs, t)),
        this.flktyNav.on(
          "dragStart",
          () => (document.ontouchmove = t => t.preventDefault())
        ),
        this.flktyNav.on("dragEnd", () => (document.ontouchmove = () => !0)),
        this.flktyNav.on("settle", () => {
          this.flktyNav.resizeQueued &&
            ((this.flktyNav.resizeQueued = !1), this.flktyNav.onresize());
        }),
        this.checkThumbsWidth(),
        window.addEventListener("resize", this.thumbsResizeEvent),
        this.thumbs.querySelectorAll(Te).forEach(t => {
          t.addEventListener("click", t => {
            t.preventDefault();
          });
        });
    }
    checkThumbsWidth() {
      const t = this.thumbs.querySelectorAll(Ae),
        e =
          2 *
          parseInt(
            window.getComputedStyle(this.thumbs).paddingLeft.replace("px", "")
          ),
        i = this.thumbs.offsetWidth - e;
      let s = 0;
      t.forEach(t => {
        s += t.offsetWidth;
      }),
        i < s
          ? this.thumbs.classList.add(He)
          : this.thumbs.classList.remove(He);
    }
    flickityResizeEvent() {
      this.flkty &&
        (this.flkty.isAnimating
          ? (this.flkty.resizeQueued = !0)
          : this.flkty.onresize()),
        this.flktyNav &&
          (this.flktyNav.isAnimating
            ? (this.flktyNav.resizeQueued = !0)
            : this.flktyNav.onresize());
    }
    createScrollable() {
      this.scrollable &&
        (this.toggleCustomScrollbar(),
        window.addEventListener("resize", this.scrollableResizeEvent));
    }
    toggleCustomScrollbar() {
      window.innerWidth < window.theme.sizes.small
        ? (this.customScrollbar = new Ee(this.container))
        : this.customScrollbar && this.customScrollbar.destroy();
    }
    switchMedia(t) {
      const e = Array.prototype.filter.call(
        t.parentNode.children,
        function (e) {
          return e !== t;
        }
      );
      document.body.classList.contains(ze) &&
        t.dispatchEvent(new Event("focus")),
        e.length &&
          e.forEach(t => {
            t.classList.add(Me),
              t.dispatchEvent(new CustomEvent("mediaHidden"));
          }),
        t.classList.remove(Me),
        t.dispatchEvent(new CustomEvent("mediaVisible"));
      const i = t.querySelector("deferred-media");
      i &&
        !0 !== i.getAttribute("loaded") &&
        t.querySelector(Ce).dispatchEvent(new Event("click", { bubbles: !1 }));
    }
  }
  const Be = "[data-product-container]",
    We = "[data-product-slideshow]",
    Oe = "[data-zoom-wrapper]",
    De = "data-image-width",
    Ne = "data-image-height",
    Ve = "data-lightbox",
    Re = "pswp-zoom-gallery",
    je = "pswp-zoom-gallery--single",
    Ue = "is-moving";
  class Qe {
    constructor(t) {
      (this.container = t.container),
        (this.productContainer = this.container.querySelector(Be)),
        (this.slideshow = this.container.querySelector(We)),
        (this.zoomWrappers = this.container.querySelectorAll(Oe)),
        (this.zoomEnable = "true" === this.productContainer.getAttribute(Ve)),
        this.zoomEnable && this.init();
    }
    init() {
      this.zoomWrappers.length &&
        this.zoomWrappers.forEach((t, e) => {
          t.addEventListener("click", t => {
            t.preventDefault();
            (this.slideshow && this.slideshow.classList.contains(Ue)) ||
              this.createZoom(e);
          }),
            t.addEventListener("keyup", t => {
              t.keyCode === theme.keyboardKeys.ENTER &&
                (t.preventDefault(), this.createZoom(e));
            });
        });
    }
    createZoom(t) {
      const e = this;
      let i = [],
        s = 0;
      this.zoomWrappers.forEach(o => {
        const n = o.getAttribute("href"),
          r = parseInt(o.getAttribute(De)),
          a = parseInt(o.getAttribute(Ne));
        if (
          (i.push({ src: n, w: r, h: a, msrc: n }),
          (s += 1),
          e.zoomWrappers.length === s)
        ) {
          let e = `${Re}`;
          1 === s && (e = `${Re} ${je}`);
          j(i, {
            barsSize: { top: 0, bottom: "auto" },
            history: !1,
            focus: !1,
            index: t,
            mainClass: e,
            showHideOpacity: !0,
            showAnimationDuration: 250,
            hideAnimationDuration: 250,
            closeOnScroll: !1,
            closeOnVerticalDrag: !1,
            captionEl: !1,
            closeEl: !0,
            closeElClasses: ["caption-close"],
            tapToClose: !1,
            clickToCloseNonZoomable: !1,
            maxSpreadZoom: 2,
            loop: !0,
            spacing: 0,
            allowPanToNext: !0,
            pinchToClose: !1,
          });
        }
      });
    }
  }
  const Ke = "html5",
    Xe = "youtube",
    Ye = "[data-deferred-media]",
    Je = "[data-deferred-media-button]",
    Ge = "[data-product-single-media-wrapper]",
    Ze = "[data-video]",
    ti = "data-media-id",
    ei = "media--hidden";
  theme.mediaInstances = {};
  class ii {
    constructor(t) {
      (this.section = t),
        (this.container = t.container),
        (this.id = t.id),
        (this.players = {}),
        this.init();
    }
    init() {
      this.container.querySelectorAll(Ze).forEach(t => {
        const e = t.querySelector(Je);
        e && e.addEventListener("click", this.loadContent.bind(this, t));
      });
    }
    loadContent(t) {
      if (t.querySelector(Ye).getAttribute("loaded")) return;
      const e = document.createElement("div");
      e.appendChild(
        t.querySelector("template").content.firstElementChild.cloneNode(!0)
      );
      const i = t.dataset.mediaId,
        s = e.querySelector("video, iframe"),
        o = this.hostFromVideoElement(s),
        n = t.querySelector(Ye);
      n.appendChild(s).focus(),
        n.setAttribute("loaded", !0),
        (this.players[i] = {
          mediaId: i,
          sectionId: this.id,
          container: t,
          element: s,
          host: o,
          ready: () => {
            this.createPlayer(i);
          },
        });
      const r = this.players[i];
      switch (r.host) {
        case Ke:
          this.loadVideo(r, Ke);
          break;
        case Xe:
          window.isYoutubeAPILoaded
            ? this.loadVideo(r, Xe)
            : T({ url: "https://www.youtube.com/iframe_api" }).then(() =>
                this.loadVideo(r, Xe)
              );
      }
    }
    hostFromVideoElement(t) {
      return "VIDEO" === t.tagName
        ? Ke
        : "IFRAME" === t.tagName &&
          /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
            t.src
          )
        ? Xe
        : null;
    }
    loadVideo(t, e) {
      t.host === e && t.ready();
    }
    createPlayer(t) {
      const e = this.players[t],
        i = e.container.dataset.enableVideoLooping;
      switch (e.host) {
        case Ke:
          e.element.play(),
            e.element.addEventListener("play", () => {
              this.pauseOtherMedia(t);
            }),
            e.container.addEventListener("mediaHidden", t => this.onHidden(t)),
            e.container.addEventListener("xrLaunch", t => this.onHidden(t)),
            e.container.addEventListener("mediaVisible", t =>
              this.onVisible(t)
            ),
            this.observeVideo(e);
          break;
        case Xe:
          if (e.host == Xe && e.player) return;
          YT.ready(() => {
            const s = e.container.dataset.videoId;
            (this.players[t].player = new YT.Player(e.element, {
              videoId: s,
              events: {
                onReady: t => {
                  t.target.playVideo();
                },
                onStateChange: e => {
                  0 === e.data && i && e.target.seekTo(0),
                    1 === e.data && this.pauseOtherMedia(t),
                    e.data;
                },
              },
            })),
              (window.isYoutubeAPILoaded = !0),
              e.container.addEventListener("mediaHidden", t =>
                this.onHidden(t)
              ),
              e.container.addEventListener("xrLaunch", t => this.onHidden(t)),
              e.container.addEventListener("mediaVisible", t =>
                this.onVisible(t)
              ),
              this.observeVideo(e);
          });
      }
    }
    observeVideo(t) {
      new IntersectionObserver(
        (e, i) => {
          e.forEach(e => {
            1 != e.intersectionRatio ? this.pauseVideo(t) : this.playVideo(t);
          });
        },
        { threshold: 1 }
      ).observe(t.element);
    }
    playVideo(t) {
      t.player && t.player.playVideo
        ? t.player.playVideo()
        : t.element && t.element.play && t.element.play();
    }
    pauseVideo(t) {
      t.player && t.player.pauseVideo
        ? t.player.pauseVideo()
        : t.element && t.element.pause && t.element.pause();
    }
    onHidden(t) {
      if (void 0 !== t.target.dataset.mediaId) {
        const e = t.target.dataset.mediaId,
          i = this.players[e];
        this.pauseVideo(i);
      }
    }
    onVisible(t) {
      if (void 0 !== t.target.dataset.mediaId) {
        const e = t.target.dataset.mediaId,
          i = this.players[e];
        this.playVideo(i);
      }
    }
    pauseOtherMedia(t) {
      const e = `[${ti}="${t}"]`,
        i = document.querySelector(`${Ge}${e}`),
        s = document.querySelectorAll(`${Ge}:not(${e})`);
      i.classList.remove(ei),
        s.length &&
          s.forEach(t => {
            t.dispatchEvent(new CustomEvent("mediaHidden")),
              t.classList.add(ei);
          });
    }
  }
  theme.mediaInstances = {};
  const si = "[data-model]",
    oi = "media--hidden";
  class ni {
    constructor(t) {
      (this.section = t), (this.id = t.id), (this.container = t.container);
    }
    init() {
      this.detect3d(),
        this.launch3d(),
        new ii(this.section),
        new Qe(this.section),
        new $e(this.section);
    }
    detect3d() {
      const t = this.container.querySelectorAll(si);
      t.length &&
        t.forEach(t => {
          theme.ProductModel.init(t, this.id);
        });
    }
    launch3d() {
      const t = this;
      document.addEventListener("shopify_xr_launch", function () {
        t.container
          .querySelector(`${si}:not(.${oi})`)
          .dispatchEvent(new CustomEvent("xrLaunch"));
      });
    }
  }
  const ri = "[data-store-availability-list]",
    ai = {
      close: ".js-modal-close",
      open: ".js-modal-open-store-availability-modal",
      openClass: "modal--is-active",
      openBodyClass: "modal--is-visible",
      closeModalOnClick: !1,
    };
  class li {
    constructor(t, e) {
      if (
        ((this.modal = document.getElementById(t)),
        (this.accessibility = et),
        !this.modal)
      )
        return !1;
      (this.nodes = {
        parents: [document.querySelector("html"), document.body],
      }),
        (this.config = Object.assign(ai, e)),
        (this.modalIsOpen = !1),
        (this.focusOnOpen = this.config.focusOnOpen
          ? document.getElementById(this.config.focusOnOpen)
          : this.modal),
        (this.openElement = document.querySelector(this.config.open)),
        this.init();
    }
    init() {
      this.openElement.addEventListener("click", this.open.bind(this)),
        this.modal
          .querySelector(this.config.close)
          .addEventListener("click", this.closeModal.bind(this));
    }
    open(t) {
      var e = this,
        i = !1;
      this.modalIsOpen ||
        (t ? t.preventDefault() : (i = !0),
        t && t.stopPropagation && t.stopPropagation(),
        this.modalIsOpen && !i && this.closeModal(),
        this.modal.classList.add(this.config.openClass),
        this.nodes.parents.forEach(function (t) {
          t.classList.add(e.config.openBodyClass);
        }),
        (this.modalIsOpen = !0),
        (this.scrollableElement = document.querySelector(ri)),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", {
            bubbles: !0,
            detail: this.scrollableElement,
          })
        ),
        this.accessibility.trapFocus(this.modal),
        this.bindEvents());
    }
    closeModal() {
      if (this.modalIsOpen) {
        document.activeElement.blur(),
          this.modal.classList.remove(this.config.openClass);
        var t = this;
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        ),
          this.nodes.parents.forEach(function (e) {
            e.classList.remove(t.config.openBodyClass);
          }),
          (this.modalIsOpen = !1),
          this.accessibility.removeTrapFocus(),
          this.openElement.focus(),
          this.unbindEvents();
      }
    }
    bindEvents() {
      (this.keyupHandler = this.keyupHandler.bind(this)),
        (this.clickHandler = this.clickHandler.bind(this)),
        document.body.addEventListener("keyup", this.keyupHandler),
        document.body.addEventListener("click", this.clickHandler);
    }
    unbindEvents() {
      document.body.removeEventListener("keyup", this.keyupHandler),
        document.body.removeEventListener("click", this.clickHandler);
    }
    keyupHandler(t) {
      27 === t.keyCode && this.closeModal();
    }
    clickHandler(t) {
      this.config.closeModalOnClick &&
        !this.modal.contains(t.target) &&
        this.closeModal();
    }
  }
  const ci = "body",
    di = "[data-store-availability-modal]",
    hi = "[data-store-availability-modal-open]",
    ui = "[data-store-availability-modal-close]",
    pi = "[data-store-availability-modal-product-title]",
    mi = "store-availabilities-modal--active";
  class fi {
    constructor(t) {
      this.container = t;
    }
    updateContent(t, e) {
      this._fetchStoreAvailabilities(t, e);
    }
    clearContent() {
      this.container.innerHTML = "";
    }
    _initModal() {
      return new li("StoreAvailabilityModal", {
        close: ui,
        open: hi,
        closeModalOnClick: !0,
        openClass: mi,
      });
    }
    _fetchStoreAvailabilities(t, e) {
      const i = `/variants/${t}/?section_id=store-availability`;
      this.clearContent();
      const s = this;
      fetch(i)
        .then(function (t) {
          return t.text();
        })
        .then(function (t) {
          if ("" === t.trim()) return;
          const i = document.querySelector(ci);
          let o = i.querySelector(di);
          o && o.remove(),
            (s.container.innerHTML = t),
            (s.container.innerHTML = s.container.firstElementChild.innerHTML);
          s.container.querySelector(hi) &&
            ((s.modal = s._initModal()),
            s._updateProductTitle(e),
            (o = s.container.querySelector(di)),
            o && i.appendChild(o));
        });
    }
    _updateProductTitle(t) {
      this.container.querySelector(pi).textContent = t;
    }
  }
  function yi() {
    this.entries = [];
  }
  function vi(t, e) {
    gi(t);
    var i = (function (t, e) {
      gi(t),
        (function (t) {
          if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
          if (0 === t.length) throw new Error(t + " is empty.");
          if (!t[0].hasOwnProperty("name"))
            throw new Error(t[0] + "does not contain name key.");
          if ("string" != typeof t[0].name)
            throw new TypeError(
              "Invalid value type passed for name of option " +
                t[0].name +
                ". Value should be string."
            );
        })(e);
      var i = [];
      return (
        e.forEach(function (e) {
          for (var s = 0; s < t.options.length; s++) {
            if (
              (t.options[s].name || t.options[s]).toLowerCase() ===
              e.name.toLowerCase()
            ) {
              i[s] = e.value;
              break;
            }
          }
        }),
        i
      );
    })(t, e);
    return (function (t, e) {
      return (
        gi(t),
        (function (t) {
          if (Array.isArray(t) && "object" == typeof t[0])
            throw new Error(t + "is not a valid array of options.");
        })(e),
        t.variants.filter(function (t) {
          return e.every(function (e, i) {
            return t.options[i] === e;
          });
        })[0] || null
      );
    })(t, i);
  }
  function gi(t) {
    if ("object" != typeof t) throw new TypeError(t + " is not an object.");
    if (0 === Object.keys(t).length && t.constructor === Object)
      throw new Error(t + " is empty.");
  }
  (yi.prototype.add = function (t, e, i) {
    this.entries.push({ element: t, event: e, fn: i }),
      t.addEventListener(e, i);
  }),
    (yi.prototype.removeAll = function () {
      this.entries = this.entries.filter(function (t) {
        return t.element.removeEventListener(t.event, t.fn), !1;
      });
    });
  var bi = '[name="id"]',
    wi = '[name^="options"]',
    Ei = '[name^="properties"]';
  function Li(t, e, i) {
    (this.element = t),
      (this.product = (function (t) {
        if ("object" != typeof t) throw new TypeError(t + " is not an object.");
        if (void 0 === t.variants[0].options)
          throw new TypeError(
            "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route"
          );
        return t;
      })(e)),
      (i = i || {}),
      (this._listeners = new yi()),
      this._listeners.add(this.element, "submit", this._onSubmit.bind(this, i)),
      (this.optionInputs = this._initInputs(wi, i.onOptionChange)),
      (this.propertyInputs = this._initInputs(Ei, i.onPropertyChange));
  }
  function Si(t, e) {
    return t.reduce(function (t, i) {
      return (
        (i.checked || ("radio" !== i.type && "checkbox" !== i.type)) &&
          t.push(e({ name: i.name, value: i.value })),
        t
      );
    }, []);
  }
  (Li.prototype.destroy = function () {
    this._listeners.removeAll();
  }),
    (Li.prototype.options = function () {
      return Si(this.optionInputs, function (t) {
        return (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t;
      });
    }),
    (Li.prototype.variant = function () {
      return vi(this.product, this.options());
    }),
    (Li.prototype.properties = function () {
      return Si(this.propertyInputs, function (t) {
        return (t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2]), t;
      });
    }),
    (Li.prototype.quantity = function () {
      return this.quantityInputs[0]
        ? Number.parseInt(this.quantityInputs[0].value, 10)
        : 1;
    }),
    (Li.prototype._setIdInputValue = function (t) {
      var e = this.element.querySelector(bi);
      e ||
        (((e = document.createElement("input")).type = "hidden"),
        (e.name = "id"),
        this.element.appendChild(e)),
        (e.value = t.toString());
    }),
    (Li.prototype._onSubmit = function (t, e) {
      (e.dataset = this._getProductFormEventData()),
        this._setIdInputValue(e.dataset.variant.id),
        t.onFormSubmit && t.onFormSubmit(e);
    }),
    (Li.prototype._onFormEvent = function (t) {
      return void 0 === t
        ? Function.prototype
        : function (e) {
            (e.dataset = this._getProductFormEventData()), t(e);
          }.bind(this);
    }),
    (Li.prototype._initInputs = function (t, e) {
      return Array.prototype.slice.call(this.element.querySelectorAll(t)).map(
        function (t) {
          return this._listeners.add(t, "change", this._onFormEvent(e)), t;
        }.bind(this)
      );
    }),
    (Li.prototype._getProductFormEventData = function () {
      return {
        options: this.options(),
        variant: this.variant(),
        properties: this.properties(),
      };
    });
  const ki = "[data-product-container]",
    qi = "[data-product-form-container]",
    Ai = "[data-add-to-cart]",
    Ti = "[data-add-to-cart-text]",
    Ci = "[data-compare-price]",
    xi = "[data-product-select]",
    _i = "[data-price-wrapper]",
    Pi = "[data-product-slideshow]",
    Ii = "[data-custom-scrollbar-items]",
    Mi = "[data-product-single-media-wrapper]",
    zi = "[data-product-json]",
    Hi = "[data-product-price]",
    Fi = "[data-product-unit-price]",
    $i = "[data-product-base]",
    Bi = "[data-product-unit]",
    Wi = "[data-store-availability-container]",
    Oi = "_preorder",
    Di = "data-id",
    Ni = '[name="id"]',
    Vi = "[data-notification-form]",
    Ri = "[data-color-label]",
    ji = "[data-option]",
    Ui = "[data-show-quantity]",
    Qi = "[data-shop-bar-image-active]",
    Ki = "data-shop-bar-image-active",
    Xi = "[data-variant-id]",
    Yi = "data-variant-id",
    Ji = "product__price--hidden",
    Gi = "visually-hidden",
    Zi = "hidden",
    ts = "product__price--sale",
    es = "product--layout-scrollable",
    is = "flickity-enabled",
    ss = "onboarding-product",
    os = "shop-bar__image--shown";
  class ns {
    constructor(t) {
      if (
        ((this.section = t),
        (this.container = t.container),
        (this.product = this.container.querySelector(ki)),
        (this.onboarding = this.product.classList.contains(ss)),
        (this.scrollable = this.product.classList.contains(es)),
        (this.storeAvailabilityContainer = this.container.querySelector(Wi)),
        this.product && !this.onboarding)
      ) {
        if (
          ((this.productForm = this.container.querySelector(qi)),
          this.product.querySelector(Ui))
        ) {
          new rt(this.container).init();
        }
        this.init(), (this.hasUnitPricing = this.container.querySelector(Bi));
      }
    }
    init() {
      let t = null;
      const e = this.container.querySelector(zi);
      if (
        (e && (t = e.innerHTML),
        t
          ? ((this.productJSON = JSON.parse(t)), this.linkForm())
          : console.error("Missing product JSON"),
        this.storeAvailabilityContainer)
      ) {
        this.storeAvailability = new fi(this.storeAvailabilityContainer);
        let t = this.productForm.product.variants[0].id;
        this.productForm.product.variants.length > 1 &&
          (t = this.productForm.variant().id),
          this.storeAvailability.updateContent(
            t,
            this.productForm.product.title
          );
      }
    }
    destroy() {
      this.productForm.destroy();
    }
    linkForm() {
      this.productForm = new Li(this.productForm, this.productJSON, {
        onOptionChange: this.onOptionChange.bind(this),
      });
    }
    onOptionChange(t) {
      this.updateAddToCartState(t),
        this.updateProductImage(t),
        this.updateProductPrices(t),
        this.updateColorName(t),
        this.updateHiddenSelect(t),
        this.updateShopBarImage(t),
        this.storeAvailability && this.updateStoreAvailability(t);
    }
    updateHiddenSelect(t) {
      const e = t.dataset.variant;
      if (e) {
        let t = this.container.querySelector(Ni);
        t ||
          ((t = document.createElement("input")),
          (t.type = "hidden"),
          (t.name = "id"),
          this.element.appendChild(t)),
          (t.value = e.id.toString()),
          t.dispatchEvent(new Event("change", { bubbles: !0 }));
      }
    }
    updateAddToCartState(t) {
      const e = t.dataset.variant,
        i = this.container.querySelectorAll(Vi),
        s = this.container.querySelectorAll(Ai),
        o = this.container.querySelectorAll(Ti),
        n = this.container.querySelectorAll(xi);
      let r = theme.translations.add_to_cart;
      this.productJSON.tags.includes(Oi) && (r = theme.translations.pre_order),
        i.length &&
          i.forEach(t => {
            e && e.available ? t.classList.add(Zi) : t.classList.remove(Zi);
          }),
        s.length &&
          s.forEach(t => {
            e && e.available ? (t.disabled = !1) : (t.disabled = !0);
          }),
        o.length &&
          o.forEach(t => {
            e
              ? e.available
                ? (t.innerHTML = r)
                : (t.innerHTML = theme.translations.sold_out)
              : (t.innerHTML = theme.translations.unavailable);
          }),
        n &&
          e &&
          n.forEach(t => {
            t.value = e.id;
          });
    }
    updateStoreAvailability(t) {
      t.dataset.variant
        ? this.storeAvailability.updateContent(
            t.dataset.variant.id,
            t.dataset.variant.title
          )
        : this.storeAvailability.clearContent();
    }
    getBaseUnit(t) {
      return 1 === t.unit_price_measurement.reference_value
        ? t.unit_price_measurement.reference_unit
        : t.unit_price_measurement.reference_value +
            t.unit_price_measurement.reference_unit;
    }
    updateProductPrices(t) {
      const i = t.dataset.variant;
      this.container.querySelectorAll(_i).forEach(t => {
        const s = t.querySelector(Ci),
          o = t.querySelector(Hi);
        i
          ? (t.classList.remove(Ji),
            (o.innerHTML = e.formatMoney(i.price, moneyFormat)))
          : t.classList.add(Ji),
          i && i.compare_at_price > i.price
            ? ((s.innerHTML = e.formatMoney(i.compare_at_price, moneyFormat)),
              s.classList.remove(Gi),
              o.classList.add(ts))
            : s &&
              ((s.innerHTML = ""), s.classList.add(Gi), o.classList.remove(ts));
      }),
        this.hasUnitPricing && this.updateProductUnits(t);
    }
    updateProductUnits(t) {
      const i = t.dataset.variant;
      if (void 0 !== i.unit_price) {
        const t = e.formatMoney(i.unit_price, moneyFormat),
          s = this.getBaseUnit(i);
        (this.container.querySelector(Fi).innerHTML = t),
          (this.container.querySelector($i).innerHTML = s),
          K(this.container.querySelector(Bi));
      } else
        (s = this.container.querySelector(Bi)) && (s.style.display = "none");
      var s;
    }
    updateColorName(t) {
      const e = t.target,
        i = e.closest(ji).querySelector(Ri);
      "INPUT" === e.tagName && null !== i && (i.innerText = e.value);
    }
    updateProductImage(t) {
      const e = t.dataset.variant;
      if (e && e.featured_media) {
        const t = this.container.querySelector(
          `${Mi}[${Di}*="${e.featured_media.id}"]`
        );
        if (t) {
          const e = this.container.querySelector(Pi);
          if (e && e.classList.contains(is)) {
            const i = Array.from(t.parentElement.children).indexOf(t);
            o.data(e).select(i);
          }
          if (this.scrollable)
            if (window.innerWidth > window.theme.sizes.small) {
              const e = 60;
              window.scrollTo({
                top: t.getBoundingClientRect().top + window.scrollY - e,
                left: 0,
                behavior: "smooth",
              });
            } else {
              const e = this.container.querySelector(Ii);
              e.scrollTo({
                top: 0,
                left: t.getBoundingClientRect().left + e.scrollLeft,
                behavior: "smooth",
              });
            }
        }
      }
    }
    updateShopBarImage(t) {
      const e = t.dataset.variant,
        i = this.container.querySelectorAll(Xi),
        s = this.container.querySelector(Qi);
      null !== e.featured_image &&
        (s && (s.classList.remove(os), s.removeAttribute(Ki)),
        i.forEach(t => {
          Number(e.id) === Number(t.getAttribute(Yi)) &&
            (t.classList.add(os), t.setAttribute(Ki, ""));
        }));
    }
  }
  const rs = {
      onLoad() {
        this.section = new ns(this);
      },
    },
    as = "[data-api-content]",
    ls = "[data-quickview-wrap]",
    cs = "[data-quickview-close]",
    ds = "[data-collection-featured-block]",
    hs = "[data-product-block]",
    us = "[data-product-container]",
    ps = "[data-product-single-media-wrapper]",
    ms = "[data-add-to-cart]",
    fs = "data-trigger-quickview",
    ys = "[data-product-slideshow]",
    vs = "[data-swatch]",
    gs = "data-video-looping",
    bs = "data-quickview-id",
    ws = "is-loading",
    Es = "is-visible",
    Ls = "is-active",
    Ss = "is-loaded",
    ks = "is-focused",
    qs = "flickity-enabled",
    As = "media--hidden",
    Ts = "button--alt",
    Cs = "product-block--quickview";
  class xs {
    constructor(t, e) {
      (this.button = t),
        (this.id = e),
        (this.handle = this.button.getAttribute(fs)),
        (this.productBlock = this.button.closest(hs)),
        (this.quickviewWrap = null),
        (this.quickviewClose = null),
        (this.quickviewWrapHeight = 0),
        (this.isQuickViewLoading = !1),
        (this.accessibility = et),
        (this.swatches = []),
        (this.form = {}),
        this.init();
    }
    init() {
      this.initButton(), this.initFetch();
    }
    initFetch() {
      this.productBlock.addEventListener(
        "quickview",
        () => {
          this.renderProduct();
        },
        !1
      );
    }
    renderProduct() {
      const t = this;
      fetch(
        `${theme.routes.root_url}products/${t.handle}?section_id=api-quickview`
      )
        .then(function (t) {
          return t.text();
        })
        .then(function (e) {
          const i = document.createElement("div");
          (i.innerHTML = e.replaceAll("||collection-index||", t.handle)),
            t.productBlock.insertAdjacentHTML(
              "beforeend",
              i.querySelector(as).innerHTML
            ),
            t.productBlock.classList.add(Ss),
            (t.quickviewWrap = t.productBlock.querySelector(ls)),
            (t.quickviewClose = t.quickviewWrap.querySelector(cs)),
            (t.quickviewWrapHeight =
              t.quickviewWrap.querySelector(us).offsetHeight),
            t.onLoaded(),
            t.show();
        })
        .catch(function (t) {
          console.log("error: ", t);
        });
    }
    initButton() {
      const t = this,
        e = this.productBlock.querySelectorAll(`[${fs}='${this.handle}']`);
      e.length &&
        e.forEach(e => {
          e.addEventListener("click", e => {
            const i = this.productBlock.classList.contains(Ss),
              s = this.productBlock.classList.contains(Es),
              o = null !== this.productBlock.parentNode.querySelector(`.${Es}`),
              n = new CustomEvent("quickview", { handle: this.handle });
            this.isQuickViewLoading ||
              ((this.isQuickViewLoading = !0),
              this.productBlock.classList.add(ws),
              i && s
                ? t.hide()
                : !i || s || o
                ? i && !s && o
                  ? (t.hide(),
                    setTimeout(() => {
                      t.show();
                    }, 200))
                  : o
                  ? (t.hide(),
                    setTimeout(() => {
                      t.productBlock.dispatchEvent(n);
                    }, 200))
                  : t.productBlock.dispatchEvent(n)
                : t.show()),
              e.preventDefault();
          });
        });
    }
    show() {
      const t = (window.innerHeight - this.quickviewWrapHeight) / 2,
        e =
          this.quickviewWrap.getBoundingClientRect().top +
          window.scrollY -
          t -
          theme.dimensions.headerScrolled,
        i = u(ds),
        s = document.body.classList.contains(ks),
        o = "api-quickview",
        n = this.productBlock.querySelectorAll('[id*="api-quickview"]'),
        r = this.productBlock.querySelectorAll('[for*="api-quickview"]');
      document.documentElement.style.setProperty(
        "--collection-featured-block-height",
        `${i}px`
      ),
        n.forEach(t => {
          const e = t.id.replace(o, this.id);
          t.id = e;
        }),
        r.forEach(t => {
          const e = t.getAttribute("for").replace(o, this.id);
          t.setAttribute("for", e);
        }),
        this.productBlock.classList.add(Ls),
        this.productBlock.classList.remove(ws),
        window.scrollTo({ top: e, left: 0, behavior: "smooth" }),
        this.productBlock.classList.add(Es),
        (this.isQuickViewLoading = !1),
        s &&
          this.accessibility.trapFocus(this.quickviewWrap, {
            elementToFocus: this.quickviewClose,
          });
    }
    hide() {
      const t = this.productBlock.parentNode.querySelectorAll(hs),
        e = [ws, Es, Ls, Cs],
        i = document.body.classList.contains(ks);
      if (
        (t.forEach(t => {
          if (t.classList.contains(Es)) {
            const i = t.querySelector(`${ps}.is-selected`);
            null !== i &&
              (i.dispatchEvent(new CustomEvent("mediaHidden")),
              i.classList.remove(As)),
              t.classList.remove(...e);
          }
        }),
        (this.isQuickViewLoading = !1),
        this.accessibility.removeTrapFocus(),
        i)
      ) {
        const t = document.querySelector(`[${fs}="${this.handle}"]`);
        setTimeout(() => {
          document.documentElement.style.setProperty(
            "--collection-featured-block-height",
            "none"
          ),
            t.focus();
        }, 300);
      }
    }
    onLoaded() {
      const t = `${this.id}-${this.quickviewWrap.getAttribute(bs)}`,
        e = this.quickviewWrap.querySelector(ys).classList.contains(qs),
        i = { id: t, container: this.quickviewWrap, type: "quickview" };
      if (
        (theme.settings.enableVideoLooping &&
          this.quickviewWrap.setAttribute(gs, !0),
        e
          ? window.dispatchEvent(new Event("resize"))
          : void 0 === theme.mediaInstances[this.id]
          ? ((theme.mediaInstances[t] = new ni(i)),
            theme.mediaInstances[t].init())
          : theme.mediaInstances[t].initSlider(),
        (this.form = new ns(i)),
        theme.settings.showQuantity)
      ) {
        new rt(i.container).init();
      }
      i.container.querySelectorAll(vs).forEach(t => {
        this.swatches.push(new ue(t));
      }),
        this.quickviewClose.addEventListener("click", t => {
          t.preventDefault(), this.hide();
        }),
        document.addEventListener("keyup", t => {
          t.keyCode === theme.keyboardKeys.ESCAPE &&
            document.querySelectorAll(`${hs}.${Es}`).length &&
            this.hide();
        });
      const s = new CustomEvent("quickview-is-loaded", { bubbles: !0 });
      this.productBlock.dispatchEvent(s), this.initPaymentButton();
    }
    initPaymentButton() {
      const t = theme.settings.enablePaymentButton,
        e = theme.settings.enableAcceptTerms,
        i = this.quickviewWrap.querySelector(ms);
      t && !e
        ? (i.classList.add(Ts),
          "undefined" != typeof Shopify &&
            void 0 !== Shopify.PaymentButton &&
            void 0 !== Shopify.PaymentButton.init &&
            Shopify.PaymentButton.init())
        : i.classList.remove(Ts);
    }
  }
  const _s = "[data-trigger-quickview]",
    Ps = "is-init";
  let Is = {};
  class Ms {
    constructor(t) {
      (this.container = t),
        (this.id = this.container.dataset.sectionId),
        theme.settings.showQuickView && this.init();
    }
    init() {
      Is[this.id] = [];
      const t = this.container.querySelectorAll(_s);
      t.length &&
        t.forEach(t => {
          t.classList.contains(Ps) ||
            (Is[this.id].push(new xs(t, this.id)), t.classList.add(Ps));
        });
    }
  }
  const zs = {
      onLoad() {
        this.section = new Ms(this.container);
      },
    },
    Hs = "[data-infinity]",
    Fs = "[data-pagination]",
    $s = "[data-product-image]",
    Bs = "data-section-id";
  let Ws = {};
  class Os {
    constructor(t) {
      (this.container = t),
        (this.infinityContainer = this.container.querySelector(Hs)),
        (this.endlessScroll = null),
        this.infinityContainer && this.init();
    }
    init() {
      const t = this,
        e = this.container.getAttribute(Bs);
      this.fix(),
        (this.endlessScroll = new s({
          container: `section[${Bs}="${e}"] ${Hs}`,
          pagination: `section[${Bs}="${e}"] ${Fs}`,
          callback: function () {
            t.setBadge(), me(t.container), new Ms(t.container);
          },
        }));
    }
    fix() {
      s.prototype.loadMore = function () {
        (this.request = new XMLHttpRequest()),
          (this.request.onreadystatechange = function () {
            if (!this.request.responseXML) return;
            if (4 === !this.request.readyState || 200 === !this.request.status)
              return;
            const t = this.request.responseXML.querySelector(
                this.settings.container
              ),
              e = this.request.responseXML.querySelector(
                this.settings.pagination
              );
            this.containerElement.insertAdjacentHTML("beforeend", t.innerHTML),
              null == e
                ? this.removePaginationElement()
                : ((this.paginationElement.innerHTML = e.innerHTML),
                  this.settings.callback &&
                    "function" == typeof this.settings.callback &&
                    this.settings.callback(this.request.responseXML),
                  this.initialize());
          }.bind(this)),
          this.request.open("GET", this.nextPageUrl, !0),
          (this.request.responseType = "document"),
          this.request.send();
      };
    }
    setBadge() {
      const t = this.infinityContainer.querySelectorAll($s),
        e = v(() => ie(t), 50);
      "contain" === theme.settings.imageBackgroundSize &&
        t &&
        (ie(t),
        window.removeEventListener("resize", e),
        window.addEventListener("resize", e));
    }
    unload() {
      this.endlessScroll && this.endlessScroll.destroy();
    }
  }
  const Ds = {
      onLoad() {
        Ws = new Os(this.container);
      },
      onUnload: function () {
        "function" == typeof Ws.unload && Ws.unload();
      },
    },
    Ns = {};
  class Vs {
    constructor(t) {
      (this.container = t.container),
        (this.resizeEvent = v(() => this.checkWindowWidth(), 200)),
        this.init();
    }
    init() {
      this.checkWindowWidth(),
        window.addEventListener("resize", this.resizeEvent);
    }
    checkWindowWidth() {
      (window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth) <= theme.sizes.small && Zt(this.container);
    }
    onUnload() {
      window.removeEventListener("resize", this.resizeEvent);
    }
  }
  const Rs = {
    onLoad() {
      Ns[this.id] = new Vs(this);
    },
    onUnload(t) {
      Ns[this.id].onUnload(t);
    },
  };
  Ut("blog", [Rs, Ds]), Ut("featured-blog", Rs);
  const js = "[data-popout]",
    Us = "[data-popout-list]",
    Qs = "[data-popout-toggle]",
    Ks = "[data-popout-input]",
    Xs = "[data-popout-option]",
    Ys = "data-popout-prevent",
    Js = "data-quantity-field",
    Gs = "data-value",
    Zs = "data-name",
    to = "aria-expanded",
    eo = "aria-current",
    io = "popout-list--visible",
    so = "--current",
    oo = "popout-container--alt";
  let no = {};
  class ro {
    constructor(t) {
      (this.container = t),
        (this.popoutList = this.container.querySelector(Us)),
        (this.popoutToggle = this.container.querySelector(Qs)),
        (this.popoutInput = this.container.querySelector(Ks)),
        (this.popoutOptions = this.container.querySelectorAll(Xs)),
        (this.popoutPrevent = "true" === this.container.getAttribute(Ys)),
        this._connectOptions(),
        this._connectToggle(),
        this._onFocusOut(),
        this.popoutInput &&
          this.popoutInput.hasAttribute(Js) &&
          document.addEventListener(
            "popout:updateValue",
            this.updatePopout.bind(this)
          );
    }
    unload() {
      this.popoutOptions.length &&
        this.popoutOptions.forEach(t => {
          t.removeEventListener(
            "clickDetails",
            this.popupOptionsClick.bind(this)
          ),
            t.removeEventListener(
              "click",
              this._connectOptionsDispatch.bind(this)
            );
        }),
        this.popoutToggle.removeEventListener(
          "click",
          this.popupToggleClick.bind(this)
        ),
        this.popoutToggle.removeEventListener(
          "focusout",
          this.popupToggleFocusout.bind(this)
        ),
        this.popoutList.removeEventListener(
          "focusout",
          this.popupListFocusout.bind(this)
        ),
        this.container.removeEventListener(
          "keyup",
          this.containerKeyup.bind(this)
        );
    }
    popupToggleClick(t) {
      const e = "true" === t.currentTarget.getAttribute(to);
      t.currentTarget.setAttribute(to, !e),
        this.popoutList.classList.toggle(io);
    }
    popupToggleFocusout(t) {
      this.container.contains(t.relatedTarget) || this._hideList();
    }
    popupListFocusout(t) {
      const e = t.currentTarget.contains(t.relatedTarget);
      this.popoutList.classList.contains(io) && !e && this._hideList();
    }
    popupOptionsClick(t) {
      t.preventDefault();
      let e = "";
      if (
        (t.currentTarget.getAttribute(Gs) &&
          (e = t.currentTarget.getAttribute(Gs)),
        (this.popoutInput.value = e),
        this.popoutPrevent)
      ) {
        (e = t.currentTarget.getAttribute(Zs)),
          this.popoutInput.dispatchEvent(new Event("change")),
          !t.detail.preventTrigger &&
            this.popoutInput.hasAttribute(Js) &&
            this.popoutInput.dispatchEvent(new Event("input"));
        const i = this.popoutList.querySelector(`[class*="${so}"]`);
        let s = so;
        if (i && i.classList.length)
          for (const t of i.classList)
            if (t.includes(so)) {
              s = t;
              break;
            }
        const o = this.popoutList.querySelector(`.${s}`);
        o &&
          (o.classList.remove(`${s}`),
          t.currentTarget.parentElement.classList.add(`${s}`));
        const n = this.popoutList.querySelector(`[${eo}]`);
        n &&
          n.hasAttribute(`${eo}`) &&
          (n.removeAttribute(`${eo}`),
          t.currentTarget.setAttribute(`${eo}`, "true")),
          "" !== e && (this.popoutToggle.textContent = e),
          this.popupToggleFocusout(t),
          this.popupListFocusout(t);
      } else this._submitForm(e);
    }
    updatePopout(t) {
      const e = this.popoutList.querySelector(
        `[${Gs}="${this.popoutInput.value}"]`
      );
      e
        ? (e.dispatchEvent(
            new CustomEvent("clickDetails", {
              cancelable: !0,
              bubbles: !0,
              detail: { preventTrigger: !0 },
            })
          ),
          e.parentElement.nextSibling || this.container.classList.add(oo))
        : this.container.classList.add(oo);
    }
    containerKeyup(t) {
      t.which === theme.keyboardKeys.ESCAPE &&
        (this._hideList(), this.popoutToggle.focus());
    }
    bodyClick(t) {
      const e = this.container.contains(t.target);
      this.popoutList.classList.contains(io) && !e && this._hideList();
    }
    _connectToggle() {
      this.popoutToggle.addEventListener(
        "click",
        this.popupToggleClick.bind(this)
      );
    }
    _connectOptions() {
      this.popoutOptions.length &&
        this.popoutOptions.forEach(t => {
          t.addEventListener("clickDetails", this.popupOptionsClick.bind(this)),
            t.addEventListener(
              "click",
              this._connectOptionsDispatch.bind(this)
            );
        });
    }
    _connectOptionsDispatch(t) {
      const e = new CustomEvent("clickDetails", {
        cancelable: !0,
        bubbles: !0,
        detail: { preventTrigger: !1 },
      });
      t.target.dispatchEvent(e) || t.preventDefault();
    }
    _onFocusOut() {
      this.popoutToggle.addEventListener(
        "focusout",
        this.popupToggleFocusout.bind(this)
      ),
        this.popoutList.addEventListener(
          "focusout",
          this.popupListFocusout.bind(this)
        ),
        this.container.addEventListener(
          "keyup",
          this.containerKeyup.bind(this)
        ),
        document.body.addEventListener("click", this.bodyClick.bind(this));
    }
    _submitForm(t) {
      const e = this.container.closest("form");
      e && e.submit();
    }
    _hideList() {
      this.popoutList.classList.remove(io),
        this.popoutToggle.setAttribute(to, !1);
    }
  }
  const ao = {
      onLoad() {
        no[this.id] = [];
        this.container.querySelectorAll(js).forEach(t => {
          no[this.id].push(new ro(t));
        });
      },
      onUnload() {
        no[this.id].forEach(t => {
          "function" == typeof t.unload && t.unload();
        });
      },
    },
    lo = "[data-newsletter-form]",
    co = "sign-up-posted",
    ho = {};
  class uo {
    constructor(t) {
      (this.sessionStorage = window.sessionStorage),
        (this.newsletter = t),
        (this.stopSubmit = !0),
        (this.isChallengePage = !1),
        (this.formID = null),
        this.checkForChallengePage(),
        (this.newsletterSubmit = t => this.newsletterSubmitEvent(t)),
        this.isChallengePage || this.init();
    }
    init() {
      this.newsletter.addEventListener("submit", this.newsletterSubmit),
        this.showMessage();
    }
    newsletterSubmitEvent(t) {
      this.stopSubmit &&
        (t.preventDefault(),
        this.removeStorage(),
        this.writeStorage(),
        (this.stopSubmit = !1),
        this.newsletter.submit());
    }
    checkForChallengePage() {
      this.isChallengePage = "/challenge" === window.location.pathname;
    }
    writeStorage() {
      void 0 !== this.sessionStorage &&
        this.sessionStorage.setItem("newsletter_form_id", this.newsletter.id);
    }
    readStorage() {
      this.formID = this.sessionStorage.getItem("newsletter_form_id");
    }
    removeStorage() {
      this.sessionStorage.removeItem("newsletter_form_id");
    }
    showMessage() {
      if ((this.readStorage(), this.newsletter.id === this.formID)) {
        const t = document.getElementById(this.formID);
        -1 !== window.location.search.indexOf("?customer_posted=true")
          ? (document.body.classList.add(co), this.scrollToForm(t))
          : -1 !== window.location.search.indexOf("accepts_marketing") &&
            document.body.classList.remove(co);
      }
    }
    scrollToForm(t) {
      const e = t.getBoundingClientRect();
      (e.top >= 0 &&
        e.left >= 0 &&
        e.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        e.right <=
          (window.innerWidth || document.documentElement.clientWidth)) ||
        setTimeout(() => {
          window.scroll({ top: e.top, left: 0, behavior: "smooth" });
        }, 400);
    }
    unload() {
      this.newsletter.removeEventListener("submit", this.newsletterSubmit);
    }
  }
  Ut("footer", [
    ao,
    {
      onLoad() {
        var t = document.querySelector("[data-powered-link] a");
        t && t.setAttribute("rel", "noopener");
      },
    },
    {
      onLoad() {
        ho[this.id] = [];
        this.container.querySelectorAll(lo).forEach(t => {
          ho[this.id].push(new uo(t));
        });
      },
      onUnload() {
        ho[this.id].forEach(t => {
          "function" == typeof t.unload && t.unload();
        });
      },
    },
  ]);
  const po = "[data-collapsible-trigger]",
    mo = "[data-collapsible-content]",
    fo = "[data-hamburger-scrollable]",
    yo = "data-header",
    vo = "aria-expanded",
    go = "aria-controls",
    bo = "aria-hidden",
    wo = "is-expanded",
    Eo = {};
  class Lo {
    constructor(t) {
      (this.section = t),
        (this.triggers = this.section.querySelectorAll(po)),
        (this.resetHeight = 0),
        (this._listeners = new yi()),
        this.init();
    }
    init() {
      const t = document.querySelector(fo);
      this.section.hasAttribute(yo) &&
        (this.triggers = [...this.triggers, ...t.querySelectorAll(po)]),
        this.triggers.forEach(t => {
          this._listeners.add(t, "click", e =>
            this.collapsibleToggleEvent(e, t)
          ),
            this._listeners.add(t, "keyup", e =>
              this.collapsibleToggleEvent(e, t)
            );
        });
    }
    collapsibleToggleEvent(t, e) {
      t.preventDefault();
      const i = e.getAttribute(go),
        s = document.getElementById(i),
        o = e.parentNode,
        n = o.classList.contains(wo),
        r = t.keyCode === theme.keyboardKeys.SPACE,
        a = t.keyCode === theme.keyboardKeys.ESCAPE;
      let l = s.querySelector(mo).offsetHeight;
      (!t.keyCode || r || a) &&
        ((!n && a) ||
          (n &&
            setTimeout(() => {
              (l = 0), this.setDropdownHeight(s, l, n);
            }, 0),
          e.setAttribute(vo, !n),
          o.classList.toggle(wo, !n),
          this.setDropdownHeight(s, l, n)));
    }
    setDropdownHeight(t, e, i) {
      (t.style.maxHeight = `${e}px`), t.setAttribute(bo, i);
      let s = "none";
      this.resetHeight && clearTimeout(this.resetHeight),
        0 === e && (s = null),
        (this.resetHeight = setTimeout(() => {
          t.style.maxHeight = s;
        }, 500));
    }
    onUnload() {
      this._listeners.removeAll();
    }
  }
  const So = {
      onLoad() {
        Eo[this.id] = new Lo(this.container);
      },
      onUnload(t) {
        Eo[this.id].onUnload(t);
      },
    },
    ko = "[data-range-slider]",
    qo = "[data-range-left]",
    Ao = "[data-range-right]",
    To = "[data-range-line]",
    Co = "[data-range-holder]",
    xo = "data-se-min",
    _o = "data-se-max",
    Po = "data-se-min-value",
    Io = "data-se-max-value",
    Mo = "data-se-step",
    zo = "data-range-filter-update",
    Ho = "[data-field-price-min]",
    Fo = "[data-field-price-max]",
    $o = "is-initialized";
  class Bo {
    constructor(t) {
      (this.container = t.container),
        (this.slider = t.querySelector(ko)),
        (this.resizeFilters = v(() => this.reset(), 50)),
        this.slider &&
          ((this.onMoveEvent = t => this.onMove(t)),
          (this.onStopEvent = t => this.onStop(t)),
          (this.onStartEvent = t => this.onStart(t)),
          (this.startX = 0),
          (this.x = 0),
          (this.touchLeft = this.slider.querySelector(qo)),
          (this.touchRight = this.slider.querySelector(Ao)),
          (this.lineSpan = this.slider.querySelector(To)),
          (this.min = parseFloat(this.slider.getAttribute(xo))),
          (this.max = parseFloat(this.slider.getAttribute(_o))),
          (this.step = 0),
          (this.normalizeFact = 26),
          this.init());
    }
    init() {
      let t = this.min;
      this.slider.hasAttribute(Po) &&
        (t = parseFloat(this.slider.getAttribute(Po)));
      let e = this.max;
      this.slider.hasAttribute(Io) &&
        (e = parseFloat(this.slider.getAttribute(Io))),
        t < this.min && (t = this.min),
        e > this.max && (e = this.max),
        t > e && (t = e),
        this.slider.getAttribute(Mo) &&
          (this.step = Math.abs(parseFloat(this.slider.getAttribute(Mo)))),
        this.reset(),
        window.addEventListener("resize", this.resizeFilters),
        (this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth),
        (this.selectedTouch = null),
        (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact),
        this.setMinValue(t),
        this.setMaxValue(e),
        this.touchLeft.addEventListener("mousedown", this.onStartEvent),
        this.touchRight.addEventListener("mousedown", this.onStartEvent),
        this.touchLeft.addEventListener("touchstart", this.onStartEvent),
        this.touchRight.addEventListener("touchstart", this.onStartEvent),
        this.slider.classList.add($o);
    }
    reset() {
      (this.touchLeft.style.left = "0px"),
        (this.touchRight.style.left =
          this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
        (this.lineSpan.style.marginLeft = "0px"),
        (this.lineSpan.style.width =
          this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
        (this.startX = 0),
        (this.x = 0);
    }
    setMinValue(t) {
      const e = (t - this.min) / (this.max - this.min);
      (this.touchLeft.style.left =
        Math.ceil(
          e *
            (this.slider.offsetWidth -
              (this.touchLeft.offsetWidth + this.normalizeFact))
        ) + "px"),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.slider.setAttribute(Po, t);
    }
    setMaxValue(t) {
      const e = (t - this.min) / (this.max - this.min);
      (this.touchRight.style.left =
        Math.ceil(
          e *
            (this.slider.offsetWidth -
              (this.touchLeft.offsetWidth + this.normalizeFact)) +
            this.normalizeFact
        ) + "px"),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.slider.setAttribute(Io, t);
    }
    onStart(t) {
      t.preventDefault();
      let e = t;
      t.touches && (e = t.touches[0]),
        t.currentTarget === this.touchLeft
          ? (this.x = this.touchLeft.offsetLeft)
          : (this.x = this.touchRight.offsetLeft),
        (this.startX = e.pageX - this.x),
        (this.selectedTouch = t.currentTarget),
        this.slider.addEventListener("mousemove", this.onMoveEvent),
        this.slider.addEventListener("mouseup", this.onStopEvent),
        this.slider.addEventListener("touchmove", this.onMoveEvent),
        this.slider.addEventListener("touchend", this.onStopEvent);
    }
    onMove(t) {
      let e = t;
      if (
        (t.touches && (e = t.touches[0]),
        (this.x = e.pageX - this.startX),
        this.selectedTouch === this.touchLeft
          ? (this.x >
            this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10
              ? (this.x =
                  this.touchRight.offsetLeft -
                  this.selectedTouch.offsetWidth +
                  10)
              : this.x < 0 && (this.x = 0),
            (this.selectedTouch.style.left = this.x + "px"))
          : this.selectedTouch === this.touchRight &&
            (this.x <
            this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10
              ? (this.x =
                  this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10)
              : this.x > this.maxX && (this.x = this.maxX),
            (this.selectedTouch.style.left = this.x + "px")),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.calculateValue(),
        this.slider.getAttribute("on-change"))
      ) {
        new Function("min, max", this.slider.getAttribute("on-change"))(
          this.slider.getAttribute(Po),
          this.slider.getAttribute(Io)
        );
      }
      this.onChange(this.slider.getAttribute(Po), this.slider.getAttribute(Io));
    }
    onStop(t) {
      this.slider.removeEventListener("mousemove", this.onMoveEvent),
        this.slider.removeEventListener("mouseup", this.onStopEvent),
        this.slider.removeEventListener("touchmove", this.onMoveEvent),
        this.slider.removeEventListener("touchend", this.onStopEvent),
        (this.selectedTouch = null),
        this.calculateValue(),
        this.onChanged(
          this.slider.getAttribute(Po),
          this.slider.getAttribute(Io)
        );
    }
    onChange(t, e) {
      const i = this.slider.closest(Co);
      if (i) {
        const s = i.querySelector(Ho),
          o = i.querySelector(Fo);
        s && o && ((s.value = t), (o.value = e));
      }
    }
    onChanged(t, e) {
      this.slider.hasAttribute(zo) &&
        this.slider.dispatchEvent(
          new CustomEvent("range:filter:update", { bubbles: !0 })
        );
    }
    calculateValue() {
      const t =
        (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
      let e = this.lineSpan.offsetLeft / this.initialValue,
        i = e + t;
      if (
        ((e = e * (this.max - this.min) + this.min),
        (i = i * (this.max - this.min) + this.min),
        0 !== this.step)
      ) {
        let t = Math.floor(e / this.step);
        (e = this.step * t),
          (t = Math.floor(i / this.step)),
          (i = this.step * t);
      }
      this.selectedTouch === this.touchLeft && this.slider.setAttribute(Po, e),
        this.selectedTouch === this.touchRight &&
          this.slider.setAttribute(Io, i);
    }
    onUnload() {
      this.resizeFilters &&
        window.removeEventListener("resize", this.resizeFilters);
    }
  }
  const Wo = {},
    Oo = "aria-expanded",
    Do = "aria-hidden",
    No = "[data-product-image]",
    Vo = "[data-collection-grid-wrapper]",
    Ro = "[data-collection-products]",
    jo = "[data-collection-sort]",
    Uo = "[data-collection-wrapper]",
    Qo = "data-collection",
    Ko = "data-count",
    Xo = "data-filter-mode",
    Yo = "data-sort",
    Jo = "data-tag",
    Go = "data-tags",
    Zo = "[data-filter]",
    tn = "[data-filter-container]",
    en = "[data-filter-count]",
    sn = "[data-filter-tag-button]",
    on = "[data-collapsible-trigger]",
    nn = "[data-filters]",
    rn = "[data-filters-reset]",
    an = "[data-filters-reset-button]",
    ln = "data-filters-enable",
    cn = "[data-filters-form]",
    dn = "[data-filter-reset-button]",
    hn = "input, select, label, textarea",
    un = "[data-pagination]",
    pn = "[data-field-price-min]",
    mn = "[data-field-price-max]",
    fn = "[data-se-min-value]",
    yn = "[data-se-max-value]",
    vn = "data-se-min-value",
    gn = "data-se-max-value",
    bn = "data-swatch",
    wn = "collection__filters--top",
    En = "collection__filters--has-tags-selected",
    Ln = "has-tags-expanded",
    Sn = "is-active",
    kn = "is-expanded",
    qn = "is-loading";
  class An {
    constructor(t) {
      (this.container = t.container),
        (this.collectionGridWrapper = this.container.querySelector(Vo)),
        (this.collectionSort = this.container.querySelector(jo)),
        (this.collectionProducts = this.container.querySelector(Ro)),
        (this.collectionWrapper = this.container.querySelector(Uo)),
        (this.pagination = this.container.querySelector(un)),
        (this.filterMode = this.container.getAttribute(Xo)),
        (this.filters = this.container.querySelector(nn)),
        (this.filtersEnable = "true" === this.container.getAttribute(ln)),
        (this.filtersForm = this.container.querySelector(cn)),
        (this.filtersResets = this.container.querySelector(rn)),
        (this.filtersInputs = []),
        (this.sort = null),
        (this.tags = null),
        (this.collection = null),
        (this.reset = null),
        (this.badgesResizeEvent = null),
        (this.resizeFiltersEvent = v(() => this.checkFiltersPosition(), 250)),
        (this.documentClick = t => this.closeOnOutsideClick(t)),
        this.init();
    }
    init() {
      if ((this.collectionSort && this.initSort(), this.collectionProducts)) {
        this.collection = this.collectionProducts.getAttribute(Qo);
        const t = this.collectionProducts.querySelectorAll(No);
        (this.badgesResizeEvent = v(() => ie(t), 250)),
          "contain" === theme.settings.imageBackgroundSize &&
            t &&
            (ie(t), window.addEventListener("resize", this.badgesResizeEvent));
      }
      this.filtersEnable &&
        (("tag" !== this.filterMode && "group" !== this.filterMode) ||
          ((this.tags = JSON.parse(this.collectionProducts.getAttribute(Go))),
          this.initFilters()),
        "default" === this.filterMode && this.initFacetedFilters()),
        this.initFilterToggleButtons(),
        this.checkFiltersPosition(),
        window.addEventListener("resize", this.resizeFiltersEvent);
    }
    initSort() {
      this.collectionSort.addEventListener("change", t => {
        const e = new window.URL(window.location.href),
          i = t.currentTarget.value,
          s = e.searchParams;
        s.set("sort_by", i),
          (e.search = s.toString()),
          this.collectionProducts.setAttribute(Yo, i),
          this.requestFilteredProducts(e.toString());
      });
    }
    initFilterToggleButtons() {
      if (!this.filters) return;
      this.filters.querySelectorAll(on).forEach(t => {
        t.addEventListener("click", () => {
          this.toggleTitle(t);
        }),
          this.isTopPosition() &&
            (t.setAttribute(Oo, !1),
            t.parentNode.classList.remove(kn),
            t.parentNode.querySelector(tn).setAttribute(Do, !0));
      }),
        document.addEventListener("click", this.documentClick);
    }
    initFacetedFilters() {
      new Bo(this.filtersForm),
        (this.filtersInputs = this.filtersForm.querySelectorAll(hn)),
        this.filtersInputs.length &&
          this.filtersInputs.forEach(t => {
            t.addEventListener(
              "input",
              v(() => {
                this.filtersForm &&
                  "function" == typeof this.filtersForm.submit &&
                  this.submitForm();
              }, 500)
            );
          }),
        this.filtersForm.addEventListener("range:filter:update", () =>
          this.updateRange()
        ),
        this.initResets();
    }
    submitForm() {
      const t = new FormData(this.filtersForm),
        e = new URLSearchParams(t);
      this.requestFilteredProducts(`${this.collection}${e.toString()}`);
    }
    initFilters() {
      this.filters.querySelectorAll(sn).forEach(t => {
        t.addEventListener("click", e => {
          this.toggleFilter(t), e.preventDefault();
        });
      }),
        this.initResets();
    }
    initResets() {
      const t = this.container.querySelectorAll(dn);
      (this.resetAlt = this.collectionProducts.querySelector(an)),
        t.length &&
          t.forEach(t => {
            t.addEventListener("click", t => this.bindResetButton(t));
          }),
        this.resetAlt &&
          this.resetAlt.addEventListener("click", t => this.bindResetButton(t));
    }
    toggleTitle(t) {
      const e = t.parentNode,
        i =
          ((s = e),
          Array.prototype.filter.call(s.parentNode.children, function (t) {
            return t !== s;
          }));
      var s;
      const o = "true" === t.getAttribute("aria-expanded");
      this.filters.classList.toggle(Ln, !o),
        this.isTopPosition() &&
          i.forEach(t => {
            t.classList.remove(kn),
              t.querySelector(tn) && t.querySelector(tn).setAttribute(Do, !0),
              t.querySelector(on) && t.querySelector(on).setAttribute(Oo, !1);
          });
    }
    toggleFilter(t) {
      const e = t.parentNode,
        i = t.getAttribute(Jo),
        s = e.classList.contains(Sn),
        o = e.parentNode.parentNode.previousElementSibling;
      this.sort = this.collectionProducts.getAttribute(Yo);
      let n = "";
      if (s) {
        const t = this.tags.indexOf(i);
        e.classList.remove(Sn), t > -1 && this.tags.splice(t, 1);
      } else e.classList.add(Sn), this.tags.push(i);
      this.collectionProducts.setAttribute(Go, this.tags);
      const r = e.parentNode.querySelectorAll(`.${Sn}`).length;
      o.querySelector(en).setAttribute(Ko, r),
        (this.isTopPosition() || s) && o.dispatchEvent(new Event("click")),
        this.sort && (n = `?sort_by=${this.sort}`);
      const a = `${this.collection}/${this.tags.join("+")}${n}`;
      this.requestFilteredProducts(a);
    }
    updateRange() {
      if (this.filtersForm && "function" == typeof this.filtersForm.submit) {
        const t = this.filtersForm.querySelector(fn),
          e = this.filtersForm.querySelector(yn),
          i = this.filtersForm.querySelector(pn),
          s = this.filtersForm.querySelector(mn);
        if (t && e && i && s && t.hasAttribute(vn) && e.hasAttribute(gn)) {
          const o = parseInt(i.placeholder),
            n = parseInt(s.placeholder),
            r = parseInt(t.getAttribute(vn)),
            a = parseInt(e.getAttribute(gn));
          (o === r && n === a) ||
            ((i.value = r), (s.value = a), this.submitForm());
        }
      }
    }
    closeOnOutsideClick(t) {
      const e = this.filters.contains(t.target),
        i = this.filters.classList.contains(Ln);
      if (!e && i && this.isTopPosition()) {
        this.filters
          .querySelector(`${Zo}.${kn}`)
          .querySelector(on)
          .dispatchEvent(new Event("click"));
      }
    }
    requestFilteredProducts(t) {
      const e = parseInt(
        Math.ceil(this.collectionWrapper.offsetTop) -
          theme.dimensions.headerScrolled
      );
      this.collectionWrapper.classList.add(qn),
        window.scrollTo({ top: e, left: 0, behavior: "smooth" }),
        history.replaceState && window.history.pushState({ path: t }, "", t),
        fetch(t)
          .then(t => t.text())
          .then(t => {
            const e = document.createElement("div");
            e.innerHTML = t;
            const i = e.querySelector(Ro).innerHTML,
              s = e.querySelector(un),
              o = e.querySelector(nn);
            if (
              ((this.collectionProducts.innerHTML = i),
              this.pagination &&
                (this.pagination.innerHTML = null !== s ? s.innerHTML : ""),
              this.pagination ||
                null === s ||
                (this.collectionGridWrapper.appendChild(s),
                (this.pagination =
                  this.collectionGridWrapper.querySelector(un))),
              o)
            ) {
              const t = o.innerHTML;
              (this.filters.innerHTML = t),
                (this.filtersForm = this.filters.querySelector(cn)),
                ("tag" !== this.filterMode && "group" !== this.filterMode) ||
                  (this.initFilters(),
                  this.tags.length > 0
                    ? this.filters.classList.add(En)
                    : this.filters.classList.remove(En)),
                "default" === this.filterMode && this.initFacetedFilters(),
                this.checkFiltersPosition(),
                this.initFilterToggleButtons(),
                this.bindSwatchFilters(),
                new Lo(this.container);
            }
            Ds.onUnload(),
              new Os(this.container),
              me(this.container),
              new Ms(this.container);
            const n = this.collectionProducts.querySelectorAll(No);
            "contain" === theme.settings.imageBackgroundSize && n && ie(n);
          })
          .catch(t => {
            this.collectionWrapper.classList.remove(qn);
          })
          .finally(() => {
            setTimeout(() => {
              this.collectionWrapper.classList.remove(qn);
            }, 450);
          });
    }
    checkFiltersPosition() {
      if (!this.filters) return;
      const t = this.filters.querySelectorAll(Zo);
      this.isTopPosition() &&
        (this.filters.classList.remove(Ln),
        t.forEach(t => {
          t.classList.contains(kn) &&
            (t.classList.remove(kn),
            t.querySelector(tn) &&
              (t.querySelector(tn).setAttribute(Do, !0),
              (t.querySelector(tn).style.maxHeight = 0)),
            t.querySelector(on) && t.querySelector(on).setAttribute(Oo, !1));
        }));
    }
    isTopPosition() {
      return (
        (window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth) <= theme.sizes.widescreen ||
        this.filters.classList.contains(wn)
      );
    }
    bindSwatchFilters() {
      this.swatches = [];
      this.container.querySelectorAll(`[${bn}]`).forEach(t => {
        this.swatches.push(new ue(t));
      });
    }
    bindResetButton(t) {
      if (
        (t.preventDefault(),
        "tag" === this.filterMode || "group" === this.filterMode)
      ) {
        const e = t.currentTarget;
        if (e.getAttribute(Jo)) {
          const t = e.dataset.tag,
            i = this.tags.indexOf(t);
          i > -1 && this.tags.splice(i, 1);
        } else this.tags = [];
        this.collectionProducts.setAttribute(Go, this.tags);
      }
      this.requestFilteredProducts(t.currentTarget.href);
    }
    onUnload() {
      document.removeEventListener("click", this.documentClick),
        window.removeEventListener("resize", this.resizeFiltersEvent),
        this.badgesResizeEvent &&
          window.removeEventListener("resize", this.badgesResizeEvent);
    }
  }
  const Tn = {
    onLoad() {
      Wo[this.id] = new An(this);
    },
    onUnload(t) {
      Wo[this.id].onUnload(t);
    },
  };
  Ut("collection", [Tn, So, zs, Ds, ye, fe, ao]),
    Ut("search-template", [Tn, So, zs, Ds, ye, fe, ao]);
  const Cn = {},
    xn = "[data-collection-slider]",
    _n = "[data-prev-arrow]",
    Pn = "[data-next-arrow]",
    In = "[data-product-block]",
    Mn = "[data-product-image]",
    zn = "[data-quickview-wrap]",
    Hn = "[data-trigger-quickview]",
    Fn = "product-block--quickview",
    $n = "is-visible",
    Bn = "flickity-enabled";
  class Wn {
    constructor(t) {
      (this.container = t.container),
        (this.slideshow = this.container.querySelector(xn)),
        (this.productBlocks = this.container.querySelectorAll(In)),
        (this.productImages = this.container.querySelectorAll(Mn)),
        (this.slideshowPrev = this.container.querySelector(_n)),
        (this.slideshowNext = this.container.querySelector(Pn)),
        (this.resizeEvent = v(() => {
          this.sliderInit(),
            this.setArrowPosition(),
            this.setQuickViewPosition();
        }, 200)),
        (this.resizeBadge = null),
        (this.flkty = null),
        this.slideshow && this.init(),
        this.productImages &&
          "contain" === theme.settings.imageBackgroundSize &&
          ((this.resizeBadge = v(() => ie(this.productImages), 50)),
          ie(this.productImages),
          window.addEventListener("resize", this.resizeBadge));
    }
    init() {
      this.slideshowPrev.addEventListener(
        "click",
        this.goToPrevSlide.bind(this)
      ),
        this.slideshowNext.addEventListener(
          "click",
          this.goToNextSlide.bind(this)
        ),
        Zt(this.container),
        this.sliderInit(),
        this.productBlocks.forEach(t => {
          t.addEventListener("quickview-is-loaded", () => {
            t.classList.add(Fn), this.setQuickViewPosition();
          });
        }),
        window.addEventListener("resize", this.resizeEvent);
    }
    sliderInit() {
      const t =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth,
        e = this.slideshow.classList.contains(Bn);
      t > theme.sizes.small
        ? e ||
          (this.flkty = new n(this.slideshow, {
            groupCells: "100%",
            setGallerySize: !1,
            autoPlay: !1,
            prevNextButtons: !1,
            pageDots: !1,
            wrapAround: !1,
            cellAlign: "left",
            contain: !0,
            on: {
              ready: () => {
                this.setArrowPosition();
              },
              change: function () {
                const t = this.element.querySelector(`${In}.${$n}`);
                null !== t &&
                  t.querySelector(Hn).dispatchEvent(new Event("click"));
              },
            },
          }))
        : e && this.flkty.destroy();
    }
    goToPrevSlide(t) {
      t.preventDefault(), this.flkty.previous(!0);
    }
    goToNextSlide(t) {
      t.preventDefault(), this.flkty.next(!0);
    }
    setArrowPosition() {
      let t = this.slideshow.querySelector(Mn).offsetHeight / 2;
      (t -= this.slideshowPrev.offsetHeight / 2),
        (this.slideshowPrev.style.top = `${t}px`),
        (this.slideshowNext.style.top = `${t}px`);
    }
    setQuickViewPosition() {
      const t = this.slideshow.querySelector(`.${Fn}`);
      if (null === t) return;
      const e = t.querySelector(zn),
        i = parseInt(
          window.getComputedStyle(this.slideshow).paddingLeft.replace("px", "")
        ),
        s = this.slideshow.offsetWidth - 2 * i;
      let o = t.offsetLeft;
      o >= s && (o %= s),
        (e.style.left = `calc(${t.style.left} - ${o}px)`),
        (e.style.width = "100%");
    }
    onUnload() {
      if (this.slideshow) {
        this.slideshow.classList.contains(Bn) && this.flkty.destroy();
      }
      this.resizeBadge &&
        window.removeEventListener("resize", this.resizeBadge),
        window.removeEventListener("resize", this.resizeEvent);
    }
  }
  Ut("featured-collection", [
    {
      onLoad() {
        Cn[this.id] = new Wn(this);
      },
      onUnload(t) {
        Cn[this.id].onUnload(t);
      },
    },
    zs,
    ye,
  ]);
  const On = " is-sale",
    Dn = " is-sold-out",
    Nn = " product-status-flag--",
    Vn = " product-status-flag--custom";
  const Rn = "data-search-input",
    jn = "[product-grid-item-template]",
    Un = "[page-item-template]",
    Qn = "[noresult-item-template]",
    Kn = "[data-products-wrap]",
    Xn = "[data-articles-wrap]",
    Yn = "[data-pages-wrap]",
    Jn = "[data-product-wrap-outer]",
    Gn = "[data-view-all]",
    Zn = "[data-product-image]",
    tr = "nav-search",
    er = "is-searching",
    ir = "results--visible",
    sr = "is-hidden",
    or = "is-focused";
  class nr {
    constructor(t) {
      (this.input = t), (this.key = this.input.getAttribute(Rn));
      const e = `[id="${this.key}"]`;
      (this.append = document.querySelector(e)),
        (this.productTemplate = document.querySelector(jn).innerHTML),
        (this.pageTemplate = document.querySelector(Un).innerHTML),
        (this.noresultTemplate = document.querySelector(Qn).innerHTML),
        (this.productsWrapper = this.append.querySelector(Kn)),
        (this.pagesWrapper = this.append.querySelector(Yn)),
        (this.articlesWrapper = this.append.querySelector(Xn)),
        (this.focusedContainer = this.productsWrapper),
        (this.viewAll = this.append.querySelector(Gn)),
        (this.popdown = document.getElementById(tr)),
        (this.productWrapperOuter = this.popdown.querySelector(Jn)),
        (this.result = null),
        (this.accessibility = et),
        this.initSearch();
    }
    initSearch() {
      this.input.addEventListener(
        "input",
        v(
          function (t) {
            const e = t.target.value;
            e && e.length > 1
              ? (this.productWrapperOuter.classList.add(er), this.render(e))
              : this.reset();
          }.bind(this),
          300
        )
      ),
        this.input.addEventListener("clear", this.reset.bind(this));
    }
    render(t) {
      const e = theme.settings.searchType;
      fetch(
        `/search/suggest.json?q=${encodeURIComponent(
          t
        )}&resources[type]=${e}&resources[limit]=10&resources[options][unavailable_products]=last`
      )
        .then(this.handleErrors)
        .then(t => t.json())
        .then(
          t => (
            (this.result = t.resources.results),
            this.fetchProducts(this.result.products)
          )
        )
        .then(e => {
          this.popdown.classList.add(ir),
            this.reset(!1),
            void 0 !== this.result.articles &&
              (0 === this.result.articles.length
                ? this.injectHTML(this.articlesWrapper, this.renderNoResult())
                : (this.injectHTML(
                    this.articlesWrapper,
                    this.fetchPages(this.result.articles)
                  ),
                  (this.focusedContainer = this.articlesWrapper))),
            void 0 !== this.result.pages &&
              (0 === this.result.pages.length
                ? this.injectHTML(this.pagesWrapper, this.renderNoResult())
                : (this.injectHTML(
                    this.pagesWrapper,
                    this.fetchPages(this.result.pages)
                  ),
                  (this.focusedContainer = this.pagesWrapper))),
            "" === e
              ? (this.viewAll.classList.add(sr),
                this.injectHTML(this.productsWrapper, this.renderNoResult()))
              : (this.viewAll.classList.remove(sr),
                this.viewAll.setAttribute(
                  "href",
                  `${theme.routes.search_url}?type=product&q=${t}&options[prefix]=last`
                ),
                this.injectHTML(this.productsWrapper, e)),
            this.productWrapperOuter.classList.remove(er);
          const i = this.productWrapperOuter.querySelectorAll(Zn);
          "contain" === theme.settings.imageBackgroundSize && i && ie(i);
          document.body.classList.contains(or) &&
            this.accessibility.trapFocus(this.popdown, {
              elementToFocus: this.focusedContainer,
            });
        })
        .catch(t => {
          console.error(t);
        });
    }
    reset(t = !0) {
      (this.productsWrapper.innerHTML = ""),
        null !== this.pagesWrapper && (this.pagesWrapper.innerHTML = ""),
        null !== this.articlesWrapper && (this.articlesWrapper.innerHTML = ""),
        (this.input.val = ""),
        this.accessibility.removeTrapFocus(),
        t && this.popdown.classList.remove(ir);
    }
    injectHTML(t, e) {
      t.innerHTML += e;
    }
    fetchProducts(t) {
      const i = [];
      return (
        t.slice(0, 4).forEach(t => {
          i.push(
            se(t.handle).then(t => {
              const i = (function (t) {
                const i = theme.settings.productBadgeStyle,
                  s = t.price <= t.compare_at_price_min,
                  o = !t.available;
                let n,
                  r = `${Nn}${i}`,
                  a = !1,
                  l = !1;
                for (let e = 0; e < t.tags.length; e++) {
                  if (t.tags[e].includes("_badge_")) {
                    (a = !0),
                      (n = t.tags[e]
                        .replace("_badge_", "")
                        .split("_")
                        .join(" ")),
                      (r += Vn);
                    break;
                  }
                  if (t.tags[e].includes("_preorder")) {
                    l = !0;
                    break;
                  }
                }
                if (
                  (a ||
                    (o
                      ? ((n = theme.translations.sold_out), (r += Dn))
                      : l
                      ? ((n = theme.translations.pre_order), (r += Vn))
                      : s && ((n = theme.translations.on_sale), (r += On))),
                  "circle" == i && n && (n = n.replace(" ", "<br>")),
                  (t.price = e.formatMoney(t.price, moneyFormat)),
                  (t.price_with_from = t.price),
                  t.price_varies)
                ) {
                  let i = e.formatMoney(t.price_min, moneyFormat);
                  t.price_with_from = `${theme.translations.from} ${i}`;
                }
                return (
                  t.compare_at_price &&
                    (t.compare_at_price = e.formatMoney(
                      t.compare_at_price,
                      moneyFormat
                    )),
                  { ...t, badgeClasses: r, badgeText: n }
                );
              })(t);
              return this.renderProduct(i);
            })
          );
        }),
        Promise.all(i).then(t => {
          let e = "";
          return (
            t.forEach(t => {
              e += t;
            }),
            e
          );
        })
      );
    }
    fetchPages(t) {
      let e = "";
      return (
        t.forEach(t => {
          e += this.renderPage(t);
        }),
        e
      );
    }
    renderProduct(t) {
      const e = t.title.replace(/(<([^>]+)>)/gi, "");
      let s = null,
        o = "",
        n = theme.assets.blank;
      void 0 !== t.media && (s = t.media[0]),
        (o = s
          ? {
              thumb: r.getSizedImageUrl(s.preview_image.src, "800x800"),
              alt: s.preview_image.alt,
              aspectRatio: s.preview_image.aspect_ratio,
              src: n,
            }
          : { thumb: theme.assets.no_image, alt: "", aspectRatio: 1, src: n });
      const a = { ...t, title: e, image: o };
      return i.render(this.productTemplate, { product: a });
    }
    renderPage(t) {
      const e = t.title.replace(/(<([^>]+)>)/gi, ""),
        s = { ...t, title: e };
      return i.render(this.pageTemplate, { page: s });
    }
    renderNoResult() {
      const t = { text: theme.translations.no_results };
      return i.render(this.noresultTemplate, { item: t });
    }
    handleErrors(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new ot({ status: t.statusText, headers: t.headers, json: e });
          });
    }
  }
  const rr = "[data-body-wrap]",
    ar = "[data-menu-toggle]",
    lr = "[data-hamburger-icon]",
    cr = "[data-hamburger-scrollable]",
    dr = "[data-header-icons]",
    hr = "[data-nav-main]",
    ur = "[data-nav-search]",
    pr = "[data-search-toggle]",
    mr = "[data-search-input]",
    fr = "[data-search-submit]",
    yr = "[data-nav-search-scroller]",
    vr = "[data-view-all]",
    gr = "[data-site-alert]",
    br = "[data-shop-bar]",
    wr = "[data-dropdown-parent]",
    Er = "data-collapsible-trigger",
    Lr = "data-menu-item-link",
    Sr = "data-visible-link",
    kr = "aria-expanded",
    qr = "href",
    Ar = "tabindex",
    Tr = "nav--is-visible",
    Cr = "nav--is-hiding",
    xr = "header--search-visible",
    _r = "header--search-hiding",
    Pr = "header--megamenu-visible",
    Ir = "header--is-hamburger",
    Mr = "menu-item--dropdown",
    zr = "is-expanded",
    Hr = "is-active",
    Fr = "open";
  let $r = {};
  class Br {
    constructor(t) {
      (this.header = t),
        (this.body = document.body),
        (this.bodyWrap = document.querySelector(rr)),
        (this.siteAlert = document.querySelector(gr)),
        (this.shopBar = document.querySelector(br)),
        (this.transformedElements = [
          this.header,
          this.siteAlert,
          this.bodyWrap,
          this.shopBar,
        ]),
        (this.menuToggles = document.querySelectorAll(ar)),
        (this.headerIcons = this.header.querySelector(dr)),
        (this.navStandard = this.header.querySelector(hr)),
        (this.hamburger = this.header.querySelector(lr)),
        (this.search = this.header.querySelector(ur)),
        (this.searchScroller = this.header.querySelector(yr)),
        (this.scrollableElement = document.querySelector(cr)),
        (this.hamburgerNavLinks =
          this.scrollableElement.parentNode.querySelectorAll("button, a")),
        (this.resizeTransform = v(() => this.transformHeaderElements(), 100)),
        (this.documentClick = t => this.hideOnOutsideClick(t)),
        (this.documentKeyup = t => this.hideOnKeyUp(t)),
        (this.searchPredictive = null),
        (this.scrollLockTimeout = 0),
        (this.resetHeight = 0),
        (this.accessibility = et),
        null !== this.search &&
          ((this.searchToggles = this.header.querySelectorAll(pr)),
          (this.searchOpen = this.headerIcons.querySelector(pr)),
          (this.searchInput = this.search.querySelector(mr))),
        this.init();
    }
    init() {
      this.hide(),
        this.bindings(),
        this.activeLinks(),
        null !== this.search && this.bindingsSearch();
    }
    bindings() {
      const t = this.navStandard.querySelectorAll(wr),
        e = document.querySelectorAll(`${hr} a[href^="#"]:not(${vr})`),
        i = [...document.querySelectorAll(`${hr} [${Er}]`), ...e];
      this.menuToggles.forEach(t => {
        t.addEventListener("click", t => {
          t.preventDefault(),
            this.body.classList.contains(Tr) ? this.hide() : this.show();
        });
      }),
        t.forEach(t => {
          const e = t.querySelectorAll(`[${Sr}]`);
          t.addEventListener("mouseenter", () => {
            theme.touched ||
              (t.classList.contains(Mr) || this.header.classList.add(Pr),
              t.classList.add(zr),
              e.forEach(t => {
                t.removeAttribute(Ar),
                  t.hasAttribute(kr) && t.setAttribute(kr, !0);
              }));
          }),
            t.addEventListener("mouseleave", () => {
              t.classList.contains(Mr) || this.header.classList.remove(Pr),
                t.classList.remove(zr),
                e.forEach(t => {
                  t.setAttribute(Ar, "-1"),
                    t.hasAttribute(kr) && t.setAttribute(kr, !1);
                });
            });
        }),
        i.forEach(t => {
          t.addEventListener("click", () => {
            t.parentNode.classList.contains(zr)
              ? this.submenuClose(t.parentNode)
              : this.submenuOpen(t.parentNode);
          }),
            t.addEventListener("keyup", e => {
              e.keyCode === theme.keyboardKeys.SPACE
                ? t.parentNode.classList.contains(zr)
                  ? this.submenuClose(t.parentNode)
                  : this.submenuOpen(t.parentNode)
                : e.keyCode === theme.keyboardKeys.ESCAPE &&
                  this.submenuClose(t.parentNode);
            });
        }),
        document.addEventListener("click", this.documentClick),
        document.addEventListener("keyup", this.documentKeyup);
    }
    bindingsSearch() {
      (this.searchPredictive = new nr(this.searchInput)),
        this.searchToggles.forEach(t => {
          t.addEventListener("click", t => {
            t.preventDefault(), this.searchToggle();
          });
        });
    }
    hideOnOutsideClick(t) {
      const e = this.headerIcons.querySelector(ar),
        i = this.header.classList.contains(xr),
        s = e.contains(t.target),
        o = document.querySelector(cr).parentNode.contains(t.target),
        n = this.header.classList.contains(Ir);
      if (null !== this.search) {
        const e = this.searchOpen.contains(t.target);
        this.search.contains(t.target) || e || !i || this.searchToggle();
      }
      s || o || !n || this.hide();
    }
    hideOnKeyUp(t) {
      const e = t.which || t.keyCode,
        i = t.target,
        s = document.querySelectorAll(hr)[1],
        o = this.header.classList.contains(xr),
        n = this.hamburger.classList.contains(Fr),
        r = document.querySelector(`${wr}.${zr}`);
      (e !== theme.keyboardKeys.TAB && e !== theme.keyboardKeys.ESCAPE) ||
        (e === theme.keyboardKeys.TAB
          ? (i.hasAttribute(Lr) &&
              null !== r &&
              r.querySelector(`[${Er}]`).dispatchEvent(new Event("click")),
            !s.contains(i) && n && this.hide(),
            null !== this.search &&
              !this.search.contains(i) &&
              o &&
              this.searchToggle())
          : e === theme.keyboardKeys.ESCAPE &&
            (null !== r &&
              r.querySelector(`[${Er}]`).dispatchEvent(new Event("click")),
            o && this.searchToggle(),
            n && this.hide()));
    }
    show() {
      const t = this.headerIcons.querySelectorAll(`a:not(${ar})`);
      document.dispatchEvent(
        new CustomEvent("theme:scroll:lock", {
          bubbles: !0,
          detail: this.scrollableElement,
        })
      ),
        this.hamburger.classList.add(Fr),
        this.body.classList.add(Tr),
        t.forEach(t => t.setAttribute(Ar, "-1")),
        this.hamburgerNavLinks.forEach(t => t.removeAttribute(Ar)),
        this.menuToggles.forEach(t => t.setAttribute(kr, !0)),
        this.transformHeaderElements(),
        window.addEventListener("resize", this.resizeTransform);
    }
    transformHeaderElements() {
      this.header.classList.contains(Ir) &&
        this.transformedElements.forEach(t => {
          null !== t &&
            (t.style.transform = `translateX(${this.scrollableElement.parentNode.offsetWidth}px)`);
        });
    }
    hide() {
      const t = this.headerIcons.querySelectorAll("a");
      this.body.classList.contains(Tr) &&
        (this.hamburger.classList.remove(Fr),
        this.body.classList.add(Cr),
        this.body.classList.remove(Tr),
        this.transformedElements.forEach(t => {
          null !== t && (t.style.transform = "none");
        }),
        this.scrollLockTimeout && clearTimeout(this.scrollLockTimeout),
        (this.scrollLockTimeout = setTimeout(() => {
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
          ),
            this.body.classList.remove(Cr);
        }, 500)),
        window.removeEventListener("resize", this.resizeTransform),
        t.forEach(t => t.removeAttribute(Ar)),
        this.hamburgerNavLinks.forEach(t => t.setAttribute(Ar, "-1")),
        this.menuToggles.forEach(t => t.setAttribute(kr, !1)));
    }
    activeLinks() {
      const t = this.navStandard.querySelectorAll(`[${Lr}]`),
        e = this.navStandard.querySelectorAll(`[${Sr}]`);
      let i = !1;
      t.forEach(t => {
        t.getAttribute(qr) === window.location.pathname &&
          (t.parentNode.classList.add(Hr), (i = !0));
      }),
        i ||
          e.forEach(t => {
            t.getAttribute(qr) === window.location.pathname &&
              (t.parentNode.classList.add(Hr), t.closest(wr).classList.add(Hr));
          });
    }
    submenuClose(t) {
      t.querySelectorAll(`[${Sr}]`).forEach(t => {
        t.setAttribute(Ar, "-1"), t.hasAttribute(kr) && t.setAttribute(kr, !1);
      }),
        t.classList.contains(Mr) || this.header.classList.remove(Pr);
    }
    submenuOpen(t) {
      t.querySelectorAll(`[${Sr}]`).forEach(t => {
        t.removeAttribute(Ar), t.hasAttribute(kr) && t.setAttribute(kr, !0);
      }),
        t.classList.contains(Mr) || this.header.classList.add(Pr);
    }
    searchToggle() {
      const t = this.search.querySelector(pr),
        e = this.search.querySelector(fr),
        i = [this.searchInput, e, t];
      this.header.classList.contains(xr)
        ? (this.searchToggles.forEach(t => t.setAttribute(kr, !1)),
          i.forEach(t => t.setAttribute(Ar, "-1")),
          this.header.classList.add(_r),
          this.header.classList.remove(xr),
          this.accessibility.removeTrapFocus(),
          this.scrollLockTimeout && clearTimeout(this.scrollLockTimeout),
          (this.scrollLockTimeout = setTimeout(() => {
            this.header.classList.remove(_r),
              this.body.classList.contains("cart--is-visible") ||
                this.header.classList.contains(xr) ||
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                );
          }, 250)))
        : (this.scrollLockTimeout && clearTimeout(this.scrollLockTimeout),
          this.header.classList.add(xr),
          this.searchToggles.forEach(t => t.setAttribute(kr, !0)),
          i.forEach(t => t.removeAttribute(Ar)),
          this.accessibility.removeTrapFocus(),
          this.accessibility.trapFocus(this.search, {
            elementToFocus: this.searchInput,
          }),
          this.searchInput.select(),
          document.dispatchEvent(
            new CustomEvent("theme:scroll:lock", {
              bubbles: !0,
              detail: this.searchScroller,
            })
          ));
    }
    unload() {
      window.removeEventListener("resize", this.resizeTransform),
        document.removeEventListener("click", this.documentClick),
        document.removeEventListener("keyup", this.documentKeyup);
    }
  }
  const Wr = {
      onLoad() {
        $r = new Br(this.container);
      },
      onUnload: function () {
        "function" == typeof $r.unload && $r.unload();
      },
      onSelect() {
        "function" == typeof $r.hide && $r.hide();
      },
      onDeselect() {
        "function" == typeof $r.hide && $r.hide();
      },
    },
    Or = "body",
    Dr = "[data-body-wrap]",
    Nr = ".main-content",
    Vr = "[data-nav-main]",
    Rr = ".menu > .menu-item",
    jr = ".container > .row",
    Ur = "[data-header-icons]",
    Qr = '[data-header-style="transparent"]',
    Kr = "[data-logo-image]",
    Xr = "data-width",
    Yr = "[data-logo-text]",
    Jr = "[data-hamburger-icon]",
    Gr = "[data-site-alert]",
    Zr = "[data-shop-bar]",
    ta = "[data-cart-close]",
    ea = "data-transparent",
    ia = "shopify-section-header--fixed",
    sa = "header--full",
    oa = "header--has-scrolled____disabling-scroll-mode",
    na = "header--is-standard",
    ra = "header--is-hamburger",
    aa = "header--search-visible",
    la = "header--transparent",
    ca = "header--logo_center_links_center",
    da = "header--logo_left_links_center",
    ha = "header--logo_center_links_left",
    ua = "header--logo_left_links_left",
    pa = "has-transparent-header",
    ma = "nav--is-visible",
    fa = "cart--is-visible",
    ya = "open";
  let va = {};
  class ga {
    constructor(t) {
      (this.header = t),
        (this.headerContainer = this.header.parentNode),
        (this.body = document.querySelector(Or)),
        (this.bodyWrap = document.querySelector(Dr)),
        (this.scrollEvent = ve(() => this.stickyHeaderState(), 50)),
        (this.resizeEvent = v(() => this.checkNavigationOverlapping(), 250)),
        (this.checkTransparentHeaderEvent = t =>
          this.checkTransparentHeader(t)),
        (this.checkNavigationOverlappingEvent =
          this.checkNavigationOverlapping()),
        this.init();
    }
    init() {
      this.resetHeader(),
        this.checkTransparentHeader(),
        this.checkNavigationOverlapping(),
        this.stickyHeaderState(),
        window.addEventListener("load", this.checkNavigationOverlappingEvent),
        window.addEventListener("scroll", this.scrollEvent),
        window.addEventListener("resize", this.resizeEvent),
        document.addEventListener(
          "theme:header:update",
          this.checkTransparentHeaderEvent
        );
    }
    stickyHeaderState() {
      const t = window.scrollY;
      let e = 0;
      t > e
        ? (this.headerContainer.classList.add(ia),
          this.header.classList.add(oa),
          this.header.classList.remove(la))
        : (this.headerContainer.classList.remove(ia),
          this.header.classList.remove(oa),
          this.isHeaderTransparent() && this.header.classList.add(la));
    }
    checkNavigationOverlapping() {
      const t =
          (window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth) > theme.sizes.large,
        e = [na, aa];
      this.header.classList.remove(ra),
        this.header.classList.add(na),
        (!this.getNavigationOverlapping() && t) ||
          (this.header.classList.remove(...e), this.header.classList.add(ra));
    }
    checkTransparentHeader() {
      this.isHeaderTransparent()
        ? (this.body.classList.add(pa), this.header.classList.add(la))
        : (this.body.classList.remove(pa), this.header.classList.remove(la));
    }
    getNavigationOverlapping() {
      return false;
      const t = this.header.querySelector(jr).offsetWidth,
        e = this.getMenuItemsWidth(),
        i = this.header.classList,
        s = i.contains(ca) || i.contains(da),
        o = i.contains(ha) || i.contains(ua);
      let n = !1,
        r = this.header.querySelector(Ur).offsetWidth,
        a = this.getLogoWidth();
      return (
        s && ((a = a < r ? r : a), (a *= 2), (r = 0)),
        (n = parseInt(t) < parseInt(e + a + r + 40)),
        o && a && (n = parseInt((t - a) / 2) < parseInt(e)),
        n
      );
    }
    getLogoWidth() {
      const t = this.header.querySelector(Kr),
        e = this.header.querySelector(Yr);
      let i = 0;
      return (
        null !== t && (i = parseInt(t.getAttribute(Xr))),
        null !== e && (i += e.offsetWidth),
        i
      );
    }
    getMenuItemsWidth() {
      let t = 0;
      return (
        this.header
          .querySelector(Vr)
          .querySelectorAll(Rr)
          .forEach(e => {
            t += (t => {
              const e = getComputedStyle(t);
              let i = t.offsetWidth;
              return (i += parseInt(e.marginLeft) + parseInt(e.marginRight)), i;
            })(e);
          }),
        t
      );
    }
    isHeaderTransparent() {
      const t = document.querySelector(Nr).firstElementChild,
        e = t.classList.contains(sa),
        i = null !== t.querySelector(Qr);
      return "true" === this.header.getAttribute(ea) && (e || i);
    }
    resetHeader() {
      const t = document.querySelector(Gr),
        e = document.querySelector(Zr),
        i = this.header.querySelector(Jr),
        s = [this.header, t, this.bodyWrap, e],
        o = document.body;
      o.classList.remove(ma),
        this.bodyWrap.removeAttribute("style"),
        s.forEach(t => {
          null !== t && (t.style.transform = "none");
        }),
        i.classList.remove(ya),
        o.classList.contains(fa) && document.querySelector(ta).click(),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        );
    }
    unload() {
      window.removeEventListener("load", this.checkNavigationOverlappingEvent),
        window.removeEventListener("scroll", this.scrollEvent),
        window.removeEventListener("resize", this.resizeEvent),
        document.removeEventListener(
          "theme:header:update",
          this.checkTransparentHeaderEvent
        );
    }
    onselect() {
      this.resetHeader(), this.init();
    }
  }
  Ut("header", [
    {
      onLoad() {
        va = new ga(this.container);
      },
      onUnload() {
        "function" == typeof va.unload && va.unload();
      },
      onSelect() {
        "function" == typeof va.onselect && va.onselect();
      },
    },
    Wr,
    So,
  ]);
  const ba = "[data-qty-adjust]",
    wa = "data-qty-adjust-plus",
    Ea = "[data-qty]",
    La = (t, e) => {
      if ("keyup" === t.type && 13 !== t.keyCode) return;
      const i = e,
        s = i.parentElement.querySelector(Ea);
      let o = parseInt(s.value.replace(/\D/g, ""));
      (parseFloat(o) != parseInt(o) || isNaN(o)) && (o = 1),
        i.hasAttribute(wa) ? (o += 1) : ((o -= 1), o <= 1 && (o = 1)),
        (s.value = o),
        s.dispatchEvent(new Event("click"));
    };
  const Sa = "[data-product-container]",
    ka = "[data-add-to-cart]",
    qa = "[data-shop-bar]",
    Aa = "[data-product-json]",
    Ta = "[data-product-form-container]",
    Ca = "[data-single-option-selector]",
    xa = "[data-footer]",
    _a = "[data-color-label]",
    Pa = "[data-color-swatch]",
    Ia = "[data-option]",
    Ma = "data-section-id",
    za = "select",
    Ha = "data-index",
    Fa = "onboarding-product",
    $a = "shop-bar--is-visible",
    Ba = "site-footer--push";
  let Wa = {};
  class Oa {
    constructor(t) {
      if (
        ((this.section = t),
        (this.container = t.container),
        (this.id = this.container.getAttribute(Ma)),
        (this.productContainer = this.container.querySelector(Sa)),
        (this.footer = document.querySelector(xa)),
        (this.onboarding = this.productContainer.classList.contains(Fa)),
        (this.shopBar = document.querySelector(qa)),
        (this.scrollEvent = ve(() => this.shopBarShow(), 100)),
        this.onboarding)
      )
        document.querySelectorAll(ba).forEach(t => {
          t.addEventListener("click", function (e) {
            La(e, t);
          }),
            t.addEventListener("keyup", function (e) {
              La(e, t);
            });
        }),
          document.querySelectorAll(Ea).forEach(t => {
            t.addEventListener("keyup", function (t) {
              t.keyCode, t.keyCode;
            });
          }),
          this.productContainer.querySelectorAll(Pa).forEach(t => {
            t.addEventListener("change", t => {
              this.updateColorName(t);
            });
          });
      else {
        const t = this.container.querySelector(Aa);
        if ((t && !t.innerHTML) || !t) return;
        Shopify.Products.recordRecentlyViewed(),
          (this.form = this.container.querySelector(Ta)),
          this.init(),
          this.shopBar && this.initShopBar();
      }
    }
    init() {
      (theme.mediaInstances[this.id] = new ni(this.section)),
        theme.mediaInstances[this.id].init();
    }
    initShopBar() {
      const t = this.shopBar.querySelectorAll(za),
        e = this.form.querySelectorAll(Ca);
      this.shopBar.querySelector(ka).addEventListener("click", t => {
        t.preventDefault();
      }),
        t.length &&
          t.forEach(t => {
            t.addEventListener("change", () => {
              const e = t.getAttribute(Ha),
                i = t.value,
                s = this.form.querySelectorAll(`${Ca}[${Ha}="${e}"]`);
              if ("INPUT" === s[0].tagName)
                for (const t of s) {
                  const s = t.getAttribute(Ha),
                    o = t.value;
                  if (s === e && o === i) {
                    (t.checked = !0), t.dispatchEvent(new Event("change"));
                    break;
                  }
                }
              else {
                const t = s[0];
                (t.value = i), t.dispatchEvent(new Event("change"));
              }
            });
          }),
        e.length &&
          e.forEach(t => {
            t.addEventListener("change", () => {
              const e = t.getAttribute(Ha),
                i = t.value;
              this.shopBar.querySelector(`[${Ha}="${e}"]`).value = i;
            });
          }),
        this.shopBarShow(),
        window.addEventListener("scroll", this.scrollEvent);
    }
    shopBarShow() {
      const t = window.scrollY,
        e = this.productContainer.getBoundingClientRect().top + t;
      t > e
        ? (this.shopBar.classList.add($a), this.footer.classList.add(Ba))
        : t < e - theme.dimensions.headerScrolled &&
          (this.shopBar.classList.remove($a), this.footer.classList.remove(Ba));
    }
    updateColorName(t) {
      const e = t.target,
        i = e.closest(Ia).querySelector(_a);
      "INPUT" === e.tagName && null !== i && (i.innerText = e.value);
    }
    unload() {
      window.removeEventListener("scroll", this.scrollEvent);
    }
  }
  Ut("product", [
    rs,
    {
      onLoad() {
        Wa = new Oa(this);
      },
      onUnload: function () {
        "function" == typeof Wa.unload && Wa.unload();
      },
    },
    fe,
  ]),
    Ut("collection-grid", [Ds]);
  const Da = {},
    Na = '[data-section-type="related-products"]',
    Va = "[data-product-block]",
    Ra = "[data-product-image]",
    ja = "data-section-id",
    Ua = "data-product-id",
    Qa = "data-limit";
  class Ka {
    constructor(t) {
      (this.container = t.container), (this.resizeEvent = null), this.init();
    }
    init() {
      const t = this,
        e = this.container,
        i = e.getAttribute(ja),
        s = e.getAttribute(Ua),
        o = e.getAttribute(Qa),
        n = `${theme.routes.product_recommendations_url}?section_id=${i}&limit=${o}&product_id=${s}`;
      fetch(n)
        .then(function (t) {
          return t.text();
        })
        .then(function (i) {
          const s = document.createElement("div");
          s.innerHTML = i;
          const o = s.querySelector(Na);
          if (o.querySelector(Va)) {
            (e.innerHTML = o.innerHTML), me(e), new Ms(e);
            const i = e.querySelectorAll(Ra);
            (t.resizeEvent = v(() => ie(i), 50)),
              "contain" === theme.settings.imageBackgroundSize &&
                i &&
                (ie(i), window.addEventListener("resize", t.resizeEvent));
          }
        });
    }
    onUnload() {
      this.resizeEvent &&
        window.removeEventListener("resize", this.resizeEvent);
    }
  }
  Ut("related-products", {
    onLoad() {
      Da[this.id] = new Ka(this);
    },
    onUnload(t) {
      Da[this.id].onUnload(t);
    },
  });
  const Xa = {},
    Ya = "#RecentlyViewed",
    Ja = "data-limit",
    Ga = "[data-product-block]",
    Za = "[data-product-image]",
    tl = "[data-badge]";
  class el {
    constructor(t) {
      (this.section = t),
        (this.container = t.container),
        (this.limit = parseInt(this.container.getAttribute(Ja))),
        (this.recentlyViewed = this.container.querySelector(Ya)),
        (this.resizeEvent = null),
        this.recentlyViewed && this.init();
    }
    init() {
      Shopify.Products.showRecentlyViewed({
        howManyToShow: this.limit,
        onComplete: () => {
          if (this.container.querySelectorAll(Ga).length > 0) {
            me(this.container), new Ms(this.container);
            const t = this.container.querySelectorAll(Za);
            (this.resizeEvent = v(() => ie(t), 50)),
              "contain" === theme.settings.imageBackgroundSize &&
                t &&
                (ie(t), window.addEventListener("resize", this.resizeEvent)),
              t.forEach(t => {
                lazySizes.loader.unveil(t);
              }),
              "circle" === theme.settings.productBadgeStyle &&
                this.container.querySelectorAll(tl).forEach(t => {
                  let e = t.innerText;
                  (e = e.replace(" ", "<br>")), (t.innerHTML = e);
                });
          }
        },
      });
    }
    onUnload() {
      this.resizeEvent &&
        window.removeEventListener("resize", this.resizeEvent);
    }
  }
  Ut("recently-viewed-products", {
    onLoad() {
      Xa[this.id] = new el(this);
    },
    onUnload(t) {
      Xa[this.id].onUnload(t);
    },
  });
  const il = {},
    sl = "[data-logo-list-slider]",
    ol = "[data-logo-list-slide]",
    nl = "data-logo-list-slide",
    rl = "data-slide-index",
    al = "flickity-enabled";
  class ll {
    constructor(t) {
      (this.container = t.container),
        (this.slideshow = this.container.querySelector(sl)),
        (this.sliderInitEvent = v(() => this.sliderInit(), 250)),
        (this.sliderResizeEvent = v(() => this.flickityResizeEvent(), 250)),
        (this.flkty = null),
        this.init();
    }
    init() {
      this.sliderInit(),
        window.addEventListener("resize", this.sliderInitEvent);
    }
    sliderInit() {
      const t = this.slideshow.querySelectorAll(ol).length,
        e = document.documentElement.clientWidth || document.body.clientWidth,
        i = 220 * t,
        s = this.slideshow.classList.contains(al);
      e < i
        ? s ||
          ((this.flkty = new n(this.slideshow, {
            autoPlay: 4e3,
            prevNextButtons: !1,
            pageDots: !1,
            wrapAround: !0,
            resize: !1,
          })),
          this.flkty.on(
            "dragStart",
            () => (document.ontouchmove = t => t.preventDefault())
          ),
          this.flkty.on("dragEnd", () => (document.ontouchmove = () => !0)),
          window.addEventListener("resize", this.sliderResizeEvent))
        : s &&
          (this.flkty.destroy(),
          window.removeEventListener("resize", this.sliderResizeEvent));
    }
    flickityResizeEvent() {
      this.flkty &&
        (this.flkty.isAnimating
          ? (this.flkty.resizeQueued = !0)
          : this.flkty.onresize());
    }
    onUnload() {
      this.slideshow.classList.contains(al) && this.flkty.destroy(),
        window.removeEventListener("resize", this.sliderInitEvent),
        window.removeEventListener("resize", this.sliderResizeEvent);
    }
    onBlockSelect(t) {
      const e = this.slideshow.querySelector(`[${nl}="${t.detail.blockId}"]`),
        i = parseInt(e.getAttribute(rl));
      this.slideshow.classList.contains(al) &&
        (this.flkty.select(i), this.flkty.pausePlayer());
    }
    onBlockDeselect() {
      this.slideshow.classList.contains(al) && this.flkty.unpausePlayer();
    }
  }
  Ut("logo-list", {
    onLoad() {
      il[this.id] = new ll(this);
    },
    onUnload(t) {
      il[this.id].onUnload(t);
    },
    onBlockSelect(t) {
      il[this.id].onBlockSelect(t);
    },
    onBlockDeselect() {
      il[this.id].onBlockDeselect();
    },
  });
  const cl = {},
    dl = "[data-collapsible-trigger]",
    hl = "is-expanded";
  class ul {
    triggerClick(t) {
      t.target.querySelector(dl).dispatchEvent(new Event("click"));
    }
  }
  Ut("faq", [
    {
      onLoad() {
        cl[this.id] = new ul(this);
      },
      onBlockSelect(t) {
        t.target.classList.contains(hl) || cl[this.id].triggerClick(t);
      },
      onBlockDeselect(t) {
        t.target.classList.contains(hl) && cl[this.id].triggerClick(t);
      },
    },
    So,
  ]);
  const pl = {},
    ml = ".shopify-section",
    fl = "[data-prev-arrow]",
    yl = "[data-next-arrow]",
    vl = "data-options",
    gl = "data-style",
    bl = "data-current-style",
    wl = "data-slide",
    El = "data-slide-index",
    Ll = "[data-button-scroll]",
    Sl = "hero--is-loading",
    kl = "is-selected",
    ql = "flickity-enabled";
  class Al {
    constructor(t) {
      (this.container = t.container),
        (this.options = this.container.getAttribute(vl)),
        (this.parentContainer = this.container.closest(ml)),
        (this.slideshowPrev = this.parentContainer.querySelector(fl)),
        (this.slideshowNext = this.parentContainer.querySelector(yl)),
        (this.scrollBtn = this.parentContainer.querySelector(Ll)),
        (this.scrollEvent = ve(() => this.checkSliderVisibility(), 150)),
        (this.resizeEvent = v(() => this.flickityResizeEvent(), 250)),
        (this.flkty = null),
        this.init();
    }
    init() {
      let t = JSON.parse(this.options.replace(/'/g, '"'));
      (t = {
        ...t,
        resize: !1,
        on: {
          ready: () => {
            this.container.classList.remove(Sl), this.slideActions();
          },
        },
      }),
        (this.flkty = new a(this.container, t)),
        this.flkty.on(
          "dragStart",
          () => (document.ontouchmove = t => t.preventDefault())
        ),
        this.flkty.on("dragEnd", () => (document.ontouchmove = () => !0)),
        this.flkty.on("change", () => {
          this.slideActions();
        }),
        this.flkty.on("settle", () => {
          this.flkty.resizeQueued &&
            ((this.flkty.resizeQueued = !1), this.flkty.onresize());
        }),
        this.slideshowPrev &&
          this.slideshowPrev.addEventListener("click", () =>
            this.flkty.previous(!0)
          ),
        this.slideshowNext &&
          this.slideshowNext.addEventListener("click", () =>
            this.flkty.next(!0)
          ),
        this.scrollBtn &&
          this.scrollBtn.addEventListener("click", t => {
            t.preventDefault();
            const e = this.parentContainer.offsetTop,
              i = this.parentContainer.offsetHeight;
            scroll({ top: e + i - 59, behavior: "smooth" });
          }),
        window.addEventListener("scroll", this.scrollEvent),
        window.addEventListener("resize", this.resizeEvent);
    }
    flickityResizeEvent() {
      this.flkty &&
        (this.flkty.isAnimating
          ? (this.flkty.resizeQueued = !0)
          : this.flkty.onresize());
    }
    isAutoplay() {
      return !1 !== this.flkty.options.autoPlay;
    }
    checkSliderVisibility() {
      const t = this.container.classList.contains(ql);
      (visibilityHelper.isElementPartiallyVisible(this.container) ||
        visibilityHelper.isElementTotallyVisible(this.container)) &&
      t &&
      this.isAutoplay()
        ? this.flkty.playPlayer()
        : this.flkty.stopPlayer();
    }
    slideActions() {
      const t = this.container.querySelector(`.${kl}`).getAttribute(gl);
      this.container.setAttribute(bl, t);
    }
    onUnload() {
      this.flkty.destroy(),
        window.removeEventListener("scroll", this.scrollEvent),
        window.removeEventListener("resize", this.resizeEvent);
    }
    onBlockSelect(t) {
      const e = this.container.querySelector(`[${wl}="${t.detail.blockId}"]`),
        i = parseInt(e.getAttribute(El));
      this.flkty.select(i), this.flkty.stopPlayer();
    }
    onBlockDeselect() {
      this.isAutoplay() && this.flkty.playPlayer();
    }
  }
  Ut("slideshow", {
    onLoad() {
      pl[this.id] = new Al(this);
    },
    onUnload(t) {
      pl[this.id].onUnload(t);
    },
    onBlockSelect(t) {
      pl[this.id].onBlockSelect(t);
    },
    onBlockDeselect(t) {
      pl[this.id].onBlockDeselect(t);
    },
  });
  const Tl = {},
    Cl = "[data-gallery-slider]",
    xl = "[data-slider]",
    _l = "[data-prev-arrow]",
    Pl = "[data-next-arrow]",
    Il = "data-options",
    Ml = "data-slide",
    zl = "data-slide-index",
    Hl = "gallery-slider--is-loading",
    Fl = "flickity-enabled";
  class $l {
    constructor(t) {
      (this.container = t.container),
        (this.slider = this.container.querySelector(Cl)),
        (this.slideshow = this.container.querySelector(xl)),
        (this.options = this.slideshow.getAttribute(Il)),
        (this.slideshowPrev = this.container.querySelector(_l)),
        (this.slideshowNext = this.container.querySelector(Pl)),
        (this.scrollEvent = ve(() => this.checkSliderVisibility(), 150)),
        (this.sliderResizeEvent = v(() => this.flickityResizeEvent(), 150)),
        (this.flkty = null),
        this.init();
    }
    init() {
      let t = JSON.parse(this.options.replace(/'/g, '"'));
      (t = {
        ...t,
        resize: !1,
        on: { ready: () => this.slider.classList.remove(Hl) },
      }),
        (this.flkty = new a(this.slideshow, t)),
        this.flkty.on(
          "dragStart",
          () => (document.ontouchmove = t => t.preventDefault())
        ),
        this.flkty.on("dragEnd", () => (document.ontouchmove = () => !0)),
        this.flkty.on("settle", () => {
          this.flkty.resizeQueued &&
            ((this.flkty.resizeQueued = !1), this.flkty.onresize());
        }),
        this.slideshowPrev &&
          this.slideshowPrev.addEventListener("click", () =>
            this.flkty.previous(!0)
          ),
        this.slideshowNext &&
          this.slideshowNext.addEventListener("click", () =>
            this.flkty.next(!0)
          ),
        window.addEventListener("scroll", this.scrollEvent),
        window.addEventListener("resize", this.sliderResizeEvent);
    }
    isAutoplay() {
      return !1 !== this.flkty.options.autoPlay;
    }
    checkSliderVisibility() {
      const t = this.slideshow.classList.contains(Fl);
      (visibilityHelper.isElementPartiallyVisible(this.slideshow) ||
        visibilityHelper.isElementTotallyVisible(this.slideshow)) &&
      t &&
      this.isAutoplay()
        ? this.flkty.playPlayer()
        : this.flkty.stopPlayer();
    }
    flickityResizeEvent() {
      this.flkty &&
        (this.flkty.isAnimating
          ? (this.flkty.resizeQueued = !0)
          : this.flkty.onresize());
    }
    onUnload() {
      this.flkty.destroy(),
        window.removeEventListener("scroll", this.scrollEvent),
        window.removeEventListener("resize", this.sliderResizeEvent);
    }
    onBlockSelect(t) {
      const e = this.slideshow.querySelector(`[${Ml}="${t.detail.blockId}"]`),
        i = parseInt(e.getAttribute(zl));
      this.flkty.select(i), this.flkty.stopPlayer();
    }
    onBlockDeselect() {
      this.isAutoplay() && this.flkty.playPlayer();
    }
  }
  Ut("gallery", {
    onLoad() {
      Tl[this.id] = new $l(this);
    },
    onUnload(t) {
      Tl[this.id].onUnload(t);
    },
    onBlockSelect(t) {
      Tl[this.id].onBlockSelect(t);
    },
    onBlockDeselect(t) {
      Tl[this.id].onBlockDeselect(t);
    },
  });
  const Bl = {},
    Wl = "[data-mosaic-blocks]",
    Ol = "[data-prev-arrow]",
    Dl = "[data-next-arrow]",
    Nl = "data-slide",
    Vl = "data-slide-index",
    Rl = "flickity-enabled";
  class jl {
    constructor(t) {
      (this.container = t.container),
        (this.slideshow = this.container.querySelector(Wl)),
        (this.slideshowPrev = this.container.querySelector(Ol)),
        (this.slideshowNext = this.container.querySelector(Dl)),
        (this.flkty = null),
        (this.sliderInitEvent = v(() => this.initMobileSlider(), 250)),
        (this.sliderResizeEvent = v(() => this.flickityResizeEvent(), 250)),
        (this._listeners = new yi()),
        this.init();
    }
    init() {
      this.initMobileSlider(),
        window.addEventListener("resize", this.sliderInitEvent);
    }
    initMobileSlider() {
      const t = document.documentElement.clientWidth <= theme.sizes.small,
        e = { wrapAround: !0, prevNextButtons: !1, pageDots: !1, resize: !1 };
      t && !this.isInit()
        ? ((this.flkty = new n(this.slideshow, e)),
          this.flkty.on(
            "dragStart",
            () => (document.ontouchmove = t => t.preventDefault())
          ),
          this.flkty.on("dragEnd", () => (document.ontouchmove = () => !0)),
          this.flkty.on("settle", () => {
            this.flkty.resizeQueued &&
              ((this.flkty.resizeQueued = !1), this.flkty.onresize());
          }),
          this._listeners.add(this.slideshowPrev, "click", () =>
            this.flkty.previous(!0)
          ),
          this._listeners.add(this.slideshowNext, "click", () =>
            this.flkty.next(!0)
          ),
          window.addEventListener("resize", this.sliderResizeEvent))
        : !t &&
          this.isInit() &&
          (this.flkty.destroy(),
          window.removeEventListener("resize", this.sliderResizeEvent),
          this._listeners.removeAll());
    }
    flickityResizeEvent() {
      this.flkty &&
        (this.flkty.isAnimating
          ? (this.flkty.resizeQueued = !0)
          : this.flkty.onresize());
    }
    isInit() {
      return this.slideshow.classList.contains(Rl);
    }
    onUnload() {
      this.isInit() && this.flkty.destroy(),
        window.removeEventListener("resize", this.sliderInitEvent),
        window.removeEventListener("resize", this.sliderResizeEvent);
    }
    onBlockSelect(t) {
      const e = this.container.querySelector(`[${Nl}="${t.detail.blockId}"]`);
      this.isInit() &&
        null !== e &&
        this.flkty.select(parseInt(e.getAttribute(Vl)));
    }
  }
  Ut("mosaic", {
    onLoad() {
      Bl[this.id] = new jl(this);
    },
    onUnload(t) {
      Bl[this.id].onUnload(t);
    },
    onBlockSelect(t) {
      Bl[this.id].onBlockSelect(t);
    },
  });
  const Ul = "[data-popup]",
    Ql = "[data-popup-close]",
    Kl = "data-reappear_time",
    Xl = "data-delay",
    Yl = "data-testmode",
    Jl = "true",
    Gl = "popup--visible";
  let Zl = {};
  class tc {
    constructor(t, e, i) {
      (this.configuration = {
        expires: i,
        path: "/",
        domain: window.location.hostname,
      }),
        (this.name = t),
        (this.value = e);
    }
    write() {
      ((-1 !== document.cookie.indexOf("; ") &&
        !document.cookie.split("; ").find(t => t.startsWith(this.name))) ||
        -1 === document.cookie.indexOf("; ")) &&
        (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
    }
    read() {
      if (
        -1 !== document.cookie.indexOf("; ") &&
        document.cookie.split("; ").find(t => t.startsWith(this.name))
      ) {
        return document.cookie
          .split("; ")
          .find(t => t.startsWith(this.name))
          .split("=")[1];
      }
      return !1;
    }
    destroy() {
      document.cookie.split("; ").find(t => t.startsWith(this.name)) &&
        (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
    }
  }
  class ec {
    constructor(t) {
      (this.popup = t),
        (this.close = this.popup.querySelector(Ql)),
        (this.timeout = 0),
        (this.testmode = this.popup.getAttribute(Yl) === Jl),
        (this.delay = 1e3 * parseInt(this.popup.getAttribute(Xl))),
        (this.cookie = new tc(
          "newsletter",
          "user_has_closed",
          this.expireDate()
        )),
        this.init();
    }
    expireDate() {
      const t = new Date(),
        e = new Date();
      let i = parseInt(this.popup.getAttribute(Kl));
      return (
        0 !== i
          ? e.setTime(t.getTime() + 864e5 * i)
          : e.setTime(t.getTime() + 31536e8),
        (i = e.toGMTString()),
        i
      );
    }
    init() {
      (!1 !== this.cookie.read() && !this.testmode) ||
        (this.timeout = setTimeout(() => {
          this.popup.classList.add(Gl), this.initClosers(), this.close.focus();
        }, this.delay));
    }
    initClosers() {
      this.close.addEventListener("click", this.closeModal.bind(this));
    }
    closeModal(t) {
      t.preventDefault(),
        this.popup.classList.remove(Gl),
        clearTimeout(this.timeout),
        this.testmode || this.cookie.write();
    }
  }
  Ut("popup", {
    onLoad() {
      const t = this.container.querySelector(Ul);
      null !== t && (Zl[this.id] = new ec(t));
    },
  });
  const ic = ".input-group--error",
    sc = "input.password, input.email";
  class oc {
    constructor(t) {
      (this.container = t.container),
        (this.inputGroups = this.container.querySelectorAll(ic)),
        this.init();
    }
    init() {
      this.inputGroups.forEach(t => {
        t.querySelector(sc).focus();
      });
    }
  }
  Ut("password", {
    onLoad() {
      new oc(this);
    },
  });
  const nc = "[data-tabs]",
    rc = "[data-tabs-nav]",
    ac = "[data-tabs-contents]",
    lc = "[data-tab-title]",
    cc = "[data-tab-content]",
    dc = "is-active",
    hc = {};
  class uc {
    constructor(t) {
      (this.container = t),
        (this.tabs = this.container.querySelector(nc)),
        (this.resizeEvent = v(() => this.prepareTabs(), 250)),
        (this._listeners = new yi()),
        this.tabs &&
          ((this.tabsNav = this.tabs.querySelector(rc)),
          (this.tabsContents = this.tabs.querySelector(ac)),
          (this.tabTitles = this.tabs.querySelectorAll(lc)),
          (this.tabContents = this.tabs.querySelectorAll(cc)),
          this.init());
    }
    init() {
      this.prepareTabs(),
        window.addEventListener("resize", this.resizeEvent),
        this.tabTitles.forEach((t, e) => {
          this._listeners.add(t, "click", () => this.tabTitleClick(t, e));
        });
    }
    prepareTabs() {
      (window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth) <= theme.sizes.small
        ? this.tabTitles.forEach((t, e) => {
            this.tabs.appendChild(t),
              this.tabs.appendChild(this.tabContents[e]);
          })
        : this.tabTitles.forEach((t, e) => {
            this.tabsNav.appendChild(t),
              this.tabsContents.appendChild(this.tabContents[e]);
          });
    }
    tabTitleClick(t, e) {
      const i =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth,
        s = t.classList.contains(dc),
        o = this.tabTitles.length;
      let n = e;
      if (1 === o && i > theme.sizes.small) return !1;
      s && ((n += 1), void 0 === this.tabTitles[n] && (n = 0)),
        this.tabTitles.forEach((t, e) => {
          t.classList.remove(dc), this.tabContents[e].classList.remove(dc);
        }),
        this.tabTitles[n].classList.add(dc),
        this.tabContents[n].classList.add(dc),
        i <= theme.sizes.small &&
          setTimeout(() => {
            const t =
              this.tabTitles[n].getBoundingClientRect().top -
              document.body.getBoundingClientRect().top -
              theme.dimensions.headerScrolled;
            window.scrollTo({ top: t, left: 0, behavior: "smooth" });
          }, 300);
    }
    triggerClick(t) {
      t.target.classList.contains(dc) ||
        t.target.dispatchEvent(new Event("click"));
    }
    onUnload() {
      window.removeEventListener("resize", this.resizeEvent),
        this._listeners.removeAll();
    }
  }
  Ut("tabs", [
    {
      onLoad() {
        hc[this.id] = new uc(this.container);
      },
      onBlockSelect(t) {
        hc[this.id].triggerClick(t);
      },
      onUnload(t) {
        hc[this.id].onUnload(t);
      },
    },
  ]);
  const pc = (t, e = "", i) => (
    (i = i || document.createElement("div")).classList.add(e),
    t.parentNode.insertBefore(i, t),
    i.appendChild(t)
  );
  document.addEventListener("DOMContentLoaded", function () {
    Qt("*"), document.body.classList.remove("is-page-loading");
    "true" === document.body.getAttribute("data-animations") &&
      l.init({ offset: 50, duration: 1e3, once: !0 });
    document.querySelectorAll("[data-anchor-link]").forEach(t => {
      t.addEventListener("click", e => {
        e.preventDefault();
        const i =
          document
            .getElementById(t.getAttribute("href").split("#")[1])
            .getBoundingClientRect().top +
          window.scrollY -
          theme.dimensions.headerScrolled;
        window.scrollTo({ top: i, left: 0, behavior: "smooth" });
      });
    });
    document.querySelectorAll(".rte table").forEach(t => {
      pc(t, "rte__table-wrapper");
    });
    document
      .querySelectorAll(
        '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe'
      )
      .forEach(t => {
        pc(t, "rte__video-wrapper");
      }),
      window.self !== window.top &&
        document.querySelector("html").classList.add("iframe"),
      "scrollBehavior" in document.documentElement.style ||
        T({ url: window.theme.assets.smoothscroll });
  }),
    window.navigator.cookieEnabled &&
      (document.documentElement.className =
        document.documentElement.className.replace(
          "supports-no-cookies",
          "supports-cookies"
        ));
})(
  themeVendor.BodyScrollLock,
  themeVendor.themeCurrency,
  themeVendor.Sqrl,
  themeVendor.ajaxinate,
  themeVendor.FlickityAsNavFor,
  themeVendor.Flickity,
  themeVendor.themeImages,
  themeVendor.FlickityFade,
  themeVendor.AOS
);
